/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddCollectionNote,
  AddLeadNote,
  AddLoanApplicationComment,
  ApplicationDraft,
  ApprovalConditionResolution,
  ArchiveBusinessFile,
  ArchiveLoanFolder,
  ArchiveOverview,
  AttachProofOfPaymentBody,
  BankAccount,
  BpmTask,
  BpmTaskWithApplicationPage,
  CalculatedPenalty,
  CancelLeadRequest,
  CancelLoanApplicationRequest,
  ChargeRequest,
  ClaimLeadTaskParams,
  Collateral,
  CollateralVerification,
  CollateralVerificationSubmission,
  CollectionNote,
  CollectionNotePage,
  CollectionReminder,
  Company,
  CreditApprovalDecision,
  CreditAssessment,
  CreditAssessmentHistoryPage,
  CreditAssessmentReport,
  CreditAssessmentReportUpdate,
  CreditAssessmentSubmission,
  CreditReportRequest,
  CustomerLedger,
  DeclineReasonReport,
  DirectorResult,
  DirectorResultPage,
  DiscountRequest,
  DocumentChecklist,
  DocumentHistoryPage,
  DocumentReference,
  DocumentRequirement,
  DocumentRequirementChange,
  DocumentRequirementUpdate,
  DocumentValidityRule,
  DownloadCreditReportParams,
  DownloadLoanStatementParams,
  DrawdownRequest,
  DueCollection,
  DueCollectionPage,
  DueCollectionStats,
  DueLoansPage,
  EarlyRepaymentQuote,
  EarlyRepaymentRequest,
  EditPenaltyReviewChargeRequest,
  EditPenaltyReviewChargeResponse,
  Error,
  Financial,
  GenerateLoanPreAgreementPDF400,
  GenerateLoanPreAgreementPDF500,
  GetAllDocuments200,
  GetAllDocumentsParams,
  GetClaimedLoanTasksParams,
  GetCollectionNotesParams,
  GetCreditAssessmentHistoryParams,
  GetCreditReportHistoryParams,
  GetDashboardStatsParams,
  GetDeclineReasonReportParams,
  GetDocumentHistoryParams,
  GetDocumentsByLoanApplicationParams,
  GetDueCollectionsByDateRangeParams,
  GetDueCollectionsParams,
  GetDueLoansParams,
  GetEarlyRepaymentQuoteBody,
  GetLatestLeadNotesParams,
  GetLatestRetainedXdsIdentityParams,
  GetLeadNotesParams,
  GetLeadsByStatusParams,
  GetLedgerAccountBalanceParams,
  GetLedgerAccountScheduleParams,
  GetLedgerAccountTransactionsParams,
  GetLedgerAccountsByCustomerParams,
  GetLedgerAccountsParams,
  GetLoanAgreementHistoryParams,
  GetLoanApplicationCommentsParams,
  GetLoanApplicationsParams,
  GetLoanBookRecordsParams,
  GetLoanBookSummaryParams,
  GetLoanDisbursementHistoryParams,
  GetLoanRequestsParams,
  GetLoanStatementParams,
  GetLoanTasksParams,
  GetOverdueCollectionsParams,
  GetPaymentTrackingCollectionSheetParams,
  GetPaymentTrackingParams,
  GetPaymentTrackingStatsParams,
  GetPromisesToPayParams,
  GetUnclaimedLoanTasksParams,
  GetVerificationHistoryParams,
  GrantPenaltyGraceRequest,
  Lead,
  LeadNote,
  LeadNotePage,
  LeadPage,
  LedgerAccount,
  LedgerAccountBalance,
  LedgerAccountPage,
  LedgerInstallment,
  LedgerTransaction,
  ListPenaltyReviewsParams,
  LoanAgreementData,
  LoanAgreementHistoryPage,
  LoanAgreementUpload,
  LoanApplication,
  LoanApplicationComment,
  LoanApplicationCommentPage,
  LoanApplicationPage,
  LoanBookPage,
  LoanBookRecord,
  LoanBookSummary,
  LoanCalculationRequest,
  LoanCalculationResult,
  LoanDefaultTerms,
  LoanDetails,
  LoanDisbursement,
  LoanDisbursementHistoryPage,
  LoanIndividual,
  LoanLead,
  LoanPreAgreementData,
  LoanRequestPage,
  LoanRequestSummary,
  LoanStatement,
  LoanStatistics,
  MarkInvoicedRequest,
  OpeningBalanceInterestRequest,
  OpeningBalancePaymentRequest,
  OpeningBalanceRequest,
  OpeningBalanceResponse,
  OpeningBalanceSummary,
  OverdueCollection,
  OverdueCollectionPage,
  OverdueCollectionStats,
  OverdueReminderRequest,
  OverdueReminderResult,
  PaymentRequest,
  PaymentTrackingCollectionSheet,
  PaymentTrackingPage,
  PaymentTrackingStats,
  PenaltyCalculationRequest,
  PenaltyDecisionRequest,
  PenaltyReview,
  PenaltyReviewPage,
  PrepareLoanPreAgreementData400,
  PrepareLoanPreAgreementData404,
  PrepareLoanPreAgreementData500,
  RectifyPaymentRequest,
  ReminderRequest,
  ReminderResult,
  RetainedXdsIdentity,
  ReversalRequest,
  SaveApplicationDraft,
  SchedulerExecutionRequest,
  SchedulerExecutionResult,
  SearchLeadsParams,
  SendAccountOverdueNotificationBody,
  SendAllReminders200,
  SendAllRemindersParams,
  SendCollectionReminder,
  SendPaymentReminderNotificationBody,
  SplitPaymentRequest,
  SplitPaymentResult,
  TaskPage,
  UploadDocumentBody,
  VerificationCategory,
  VerificationHistoryPage,
  VerificationItem,
  VerificationRejection,
  VerificationStats,
  VerificationUpdate,
  WriteOffRequest
} from './schemas/loanServiceSchemas';

import { customAxiosInstanceMutator } from './custom-axios-instance';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;

/**
 * @summary Read the latest retained identity evidence without invoking providers
 */
export const getLatestRetainedXdsIdentity = (
    params: GetLatestRetainedXdsIdentityParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<RetainedXdsIdentity | void>(
      {url: `/loan/api/v1/credit-reports/identity`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLatestRetainedXdsIdentityQueryKey = (params?: GetLatestRetainedXdsIdentityParams,) => {
    return [
    `/loan/api/v1/credit-reports/identity`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLatestRetainedXdsIdentityQueryOptions = <TData = Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>, TError = unknown>(params: GetLatestRetainedXdsIdentityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLatestRetainedXdsIdentityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>> = ({ signal }) => getLatestRetainedXdsIdentity(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLatestRetainedXdsIdentityQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>>
export type GetLatestRetainedXdsIdentityQueryError = unknown


export function useGetLatestRetainedXdsIdentity<TData = Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>, TError = unknown>(
 params: GetLatestRetainedXdsIdentityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>,
          TError,
          Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestRetainedXdsIdentity<TData = Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>, TError = unknown>(
 params: GetLatestRetainedXdsIdentityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>,
          TError,
          Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestRetainedXdsIdentity<TData = Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>, TError = unknown>(
 params: GetLatestRetainedXdsIdentityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read the latest retained identity evidence without invoking providers
 */

export function useGetLatestRetainedXdsIdentity<TData = Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>, TError = unknown>(
 params: GetLatestRetainedXdsIdentityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestRetainedXdsIdentity>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLatestRetainedXdsIdentityQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Read identity returned in a retained XDS report without invoking providers
 */
export const getRetainedXdsIdentity = (
    reportId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<RetainedXdsIdentity>(
      {url: `/loan/api/v1/credit-reports/${reportId}/identity`, method: 'GET', signal
    },
      );
    }
  



export const getGetRetainedXdsIdentityQueryKey = (reportId?: string,) => {
    return [
    `/loan/api/v1/credit-reports/${reportId}/identity`
    ] as const;
    }

    
export const getGetRetainedXdsIdentityQueryOptions = <TData = Awaited<ReturnType<typeof getRetainedXdsIdentity>>, TError = void>(reportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedXdsIdentity>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRetainedXdsIdentityQueryKey(reportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRetainedXdsIdentity>>> = ({ signal }) => getRetainedXdsIdentity(reportId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(reportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRetainedXdsIdentity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRetainedXdsIdentityQueryResult = NonNullable<Awaited<ReturnType<typeof getRetainedXdsIdentity>>>
export type GetRetainedXdsIdentityQueryError = void


export function useGetRetainedXdsIdentity<TData = Awaited<ReturnType<typeof getRetainedXdsIdentity>>, TError = void>(
 reportId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedXdsIdentity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetainedXdsIdentity>>,
          TError,
          Awaited<ReturnType<typeof getRetainedXdsIdentity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRetainedXdsIdentity<TData = Awaited<ReturnType<typeof getRetainedXdsIdentity>>, TError = void>(
 reportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedXdsIdentity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetainedXdsIdentity>>,
          TError,
          Awaited<ReturnType<typeof getRetainedXdsIdentity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRetainedXdsIdentity<TData = Awaited<ReturnType<typeof getRetainedXdsIdentity>>, TError = void>(
 reportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedXdsIdentity>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read identity returned in a retained XDS report without invoking providers
 */

export function useGetRetainedXdsIdentity<TData = Awaited<ReturnType<typeof getRetainedXdsIdentity>>, TError = void>(
 reportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetainedXdsIdentity>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRetainedXdsIdentityQueryOptions(reportId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Submit a basic loan application with minimal required information
 * @summary Create initial loan application
 */
export const createLead = (
    lead: Lead,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanLead>(
      {url: `/loan/api/v1/lead/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: lead, signal
    },
      );
    }
  


export const getCreateLeadMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLead>>, TError,{data: Lead}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createLead>>, TError,{data: Lead}, TContext> => {

const mutationKey = ['createLead'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLead>>, {data: Lead}> = (props) => {
          const {data} = props ?? {};

          return  createLead(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateLeadMutationResult = NonNullable<Awaited<ReturnType<typeof createLead>>>
    export type CreateLeadMutationBody = Lead
    export type CreateLeadMutationError = Error

    /**
 * @summary Create initial loan application
 */
export const useCreateLead = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLead>>, TError,{data: Lead}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLead>>,
        TError,
        {data: Lead},
        TContext
      > => {

      const mutationOptions = getCreateLeadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a lead linked to a task
 * @summary Find lead for a task
 */
export const findLeadByTask = (
    taskId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanLead>(
      {url: `/loan/api/v1/lead/${taskId}/task`, method: 'POST', signal
    },
      );
    }
  


export const getFindLeadByTaskMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof findLeadByTask>>, TError,{taskId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof findLeadByTask>>, TError,{taskId: string}, TContext> => {

const mutationKey = ['findLeadByTask'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof findLeadByTask>>, {taskId: string}> = (props) => {
          const {taskId} = props ?? {};

          return  findLeadByTask(taskId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FindLeadByTaskMutationResult = NonNullable<Awaited<ReturnType<typeof findLeadByTask>>>
    
    export type FindLeadByTaskMutationError = unknown

    /**
 * @summary Find lead for a task
 */
export const useFindLeadByTask = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof findLeadByTask>>, TError,{taskId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof findLeadByTask>>,
        TError,
        {taskId: string},
        TContext
      > => {

      const mutationOptions = getFindLeadByTaskMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieve all loan leads filtered by status with pagination
 * @summary Get loan leads by status
 */
export const getLeadsByStatus = (
    params: GetLeadsByStatusParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LeadPage>(
      {url: `/loan/api/v1/leads`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLeadsByStatusQueryKey = (params?: GetLeadsByStatusParams,) => {
    return [
    `/loan/api/v1/leads`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLeadsByStatusQueryOptions = <TData = Awaited<ReturnType<typeof getLeadsByStatus>>, TError = Error>(params: GetLeadsByStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadsByStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeadsByStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeadsByStatus>>> = ({ signal }) => getLeadsByStatus(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeadsByStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeadsByStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getLeadsByStatus>>>
export type GetLeadsByStatusQueryError = Error


export function useGetLeadsByStatus<TData = Awaited<ReturnType<typeof getLeadsByStatus>>, TError = Error>(
 params: GetLeadsByStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadsByStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeadsByStatus>>,
          TError,
          Awaited<ReturnType<typeof getLeadsByStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadsByStatus<TData = Awaited<ReturnType<typeof getLeadsByStatus>>, TError = Error>(
 params: GetLeadsByStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadsByStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeadsByStatus>>,
          TError,
          Awaited<ReturnType<typeof getLeadsByStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadsByStatus<TData = Awaited<ReturnType<typeof getLeadsByStatus>>, TError = Error>(
 params: GetLeadsByStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadsByStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get loan leads by status
 */

export function useGetLeadsByStatus<TData = Awaited<ReturnType<typeof getLeadsByStatus>>, TError = Error>(
 params: GetLeadsByStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadsByStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeadsByStatusQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Search loan leads by customer reference, company (registered name), company registration number, contact person, loan type, status, loan-amount range and created-date range. All parameters are optional and combined with AND.
 * @summary Search loan leads
 */
export const searchLeads = (
    params?: SearchLeadsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LeadPage>(
      {url: `/loan/api/v1/leads/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSearchLeadsQueryKey = (params?: SearchLeadsParams,) => {
    return [
    `/loan/api/v1/leads/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchLeadsQueryOptions = <TData = Awaited<ReturnType<typeof searchLeads>>, TError = Error>(params?: SearchLeadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLeads>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchLeadsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchLeads>>> = ({ signal }) => searchLeads(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchLeads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchLeadsQueryResult = NonNullable<Awaited<ReturnType<typeof searchLeads>>>
export type SearchLeadsQueryError = Error


export function useSearchLeads<TData = Awaited<ReturnType<typeof searchLeads>>, TError = Error>(
 params: undefined |  SearchLeadsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLeads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchLeads>>,
          TError,
          Awaited<ReturnType<typeof searchLeads>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchLeads<TData = Awaited<ReturnType<typeof searchLeads>>, TError = Error>(
 params?: SearchLeadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLeads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchLeads>>,
          TError,
          Awaited<ReturnType<typeof searchLeads>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchLeads<TData = Awaited<ReturnType<typeof searchLeads>>, TError = Error>(
 params?: SearchLeadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLeads>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search loan leads
 */

export function useSearchLeads<TData = Awaited<ReturnType<typeof searchLeads>>, TError = Error>(
 params?: SearchLeadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLeads>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchLeadsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Replace the captured details of a lead that is still NEW, so information missed at capture can be filled in before the lead is converted. The body is the same shape as createLead and replaces every detail field; status, channel, reference and the application link are left as they are.
 * @summary Update loan lead
 */
export const updateLead = (
    id: string,
    lead: Lead,
 ) => {
      
      
      return customAxiosInstanceMutator<LoanLead>(
      {url: `/loan/api/v1/leads/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: lead
    },
      );
    }
  


export const getUpdateLeadMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLead>>, TError,{id: string;data: Lead}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateLead>>, TError,{id: string;data: Lead}, TContext> => {

const mutationKey = ['updateLead'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLead>>, {id: string;data: Lead}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLead(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLeadMutationResult = NonNullable<Awaited<ReturnType<typeof updateLead>>>
    export type UpdateLeadMutationBody = Lead
    export type UpdateLeadMutationError = Error

    /**
 * @summary Update loan lead
 */
export const useUpdateLead = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLead>>, TError,{id: string;data: Lead}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLead>>,
        TError,
        {id: string;data: Lead},
        TContext
      > => {

      const mutationOptions = getUpdateLeadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Leads are never deleted. This cancels the lead with a standard reason; use the cancel endpoint to give one.
 * @summary Cancel loan lead (kept for older clients)
 */
export const deleteLead = (
    id: string,
 ) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/loan/api/v1/leads/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteLeadMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLead>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteLead>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteLead'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLead>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteLead(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteLeadMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLead>>>
    
    export type DeleteLeadMutationError = Error

    /**
 * @summary Cancel loan lead (kept for older clients)
 */
export const useDeleteLead = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLead>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLead>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteLeadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Cancels a lead with a reason. The lead is kept with status CANCELLED and its workflow is stopped; leads are never deleted. A lead that became an application is cancelled through the application instead.
 * @summary Cancel a lead
 */
export const cancelLead = (
    id: string,
    cancelLeadRequest: CancelLeadRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanLead>(
      {url: `/loan/api/v1/leads/${id}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelLeadRequest, signal
    },
      );
    }
  


export const getCancelLeadMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelLead>>, TError,{id: string;data: CancelLeadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelLead>>, TError,{id: string;data: CancelLeadRequest}, TContext> => {

const mutationKey = ['cancelLead'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelLead>>, {id: string;data: CancelLeadRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  cancelLead(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelLeadMutationResult = NonNullable<Awaited<ReturnType<typeof cancelLead>>>
    export type CancelLeadMutationBody = CancelLeadRequest
    export type CancelLeadMutationError = void

    /**
 * @summary Cancel a lead
 */
export const useCancelLead = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelLead>>, TError,{id: string;data: CancelLeadRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelLead>>,
        TError,
        {id: string;data: CancelLeadRequest},
        TContext
      > => {

      const mutationOptions = getCancelLeadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieve tasks either by assigned group or specific user, with optional filtering by customer name and work item stage
 * @summary Get loan application tasks
 */
export const getLoanTasks = (
    params?: GetLoanTasksParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<TaskPage>(
      {url: `/loan/api/v1/tasks`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLoanTasksQueryKey = (params?: GetLoanTasksParams,) => {
    return [
    `/loan/api/v1/tasks`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLoanTasksQueryOptions = <TData = Awaited<ReturnType<typeof getLoanTasks>>, TError = Error>(params?: GetLoanTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanTasks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanTasksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanTasks>>> = ({ signal }) => getLoanTasks(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoanTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanTasks>>>
export type GetLoanTasksQueryError = Error


export function useGetLoanTasks<TData = Awaited<ReturnType<typeof getLoanTasks>>, TError = Error>(
 params: undefined |  GetLoanTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanTasks>>,
          TError,
          Awaited<ReturnType<typeof getLoanTasks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanTasks<TData = Awaited<ReturnType<typeof getLoanTasks>>, TError = Error>(
 params?: GetLoanTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanTasks>>,
          TError,
          Awaited<ReturnType<typeof getLoanTasks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanTasks<TData = Awaited<ReturnType<typeof getLoanTasks>>, TError = Error>(
 params?: GetLoanTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanTasks>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get loan application tasks
 */

export function useGetLoanTasks<TData = Awaited<ReturnType<typeof getLoanTasks>>, TError = Error>(
 params?: GetLoanTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanTasks>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoanTasksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Claims task for a lead and assigns it to the specified user
 * @summary Claim an available task for a lead
 */
export const claimLeadTask = (
    taskId: string,
    params: ClaimLeadTaskParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<BpmTask>(
      {url: `/loan/api/v1/leads/${taskId}/claim-task`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getClaimLeadTaskMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimLeadTask>>, TError,{taskId: string;params: ClaimLeadTaskParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof claimLeadTask>>, TError,{taskId: string;params: ClaimLeadTaskParams}, TContext> => {

const mutationKey = ['claimLeadTask'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimLeadTask>>, {taskId: string;params: ClaimLeadTaskParams}> = (props) => {
          const {taskId,params} = props ?? {};

          return  claimLeadTask(taskId,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClaimLeadTaskMutationResult = NonNullable<Awaited<ReturnType<typeof claimLeadTask>>>
    
    export type ClaimLeadTaskMutationError = Error

    /**
 * @summary Claim an available task for a lead
 */
export const useClaimLeadTask = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimLeadTask>>, TError,{taskId: string;params: ClaimLeadTaskParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof claimLeadTask>>,
        TError,
        {taskId: string;params: ClaimLeadTaskParams},
        TContext
      > => {

      const mutationOptions = getClaimLeadTaskMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Every submitted loan application with the detail the business tracks against it: what was asked for, what the application carries, what has been disbursed and the stage it is at. Covers requests that began as a lead and those captured directly; the lead fields are empty for the latter. Draft and pending-submission applications are excluded.

 * @summary Loan requests and where each one has got to
 */
export const getLoanRequests = (
    params?: GetLoanRequestsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanRequestPage>(
      {url: `/loan/api/v1/loan-requests`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLoanRequestsQueryKey = (params?: GetLoanRequestsParams,) => {
    return [
    `/loan/api/v1/loan-requests`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLoanRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getLoanRequests>>, TError = unknown>(params?: GetLoanRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanRequests>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanRequestsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanRequests>>> = ({ signal }) => getLoanRequests(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoanRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanRequests>>>
export type GetLoanRequestsQueryError = unknown


export function useGetLoanRequests<TData = Awaited<ReturnType<typeof getLoanRequests>>, TError = unknown>(
 params: undefined |  GetLoanRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanRequests>>,
          TError,
          Awaited<ReturnType<typeof getLoanRequests>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanRequests<TData = Awaited<ReturnType<typeof getLoanRequests>>, TError = unknown>(
 params?: GetLoanRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanRequests>>,
          TError,
          Awaited<ReturnType<typeof getLoanRequests>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanRequests<TData = Awaited<ReturnType<typeof getLoanRequests>>, TError = unknown>(
 params?: GetLoanRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanRequests>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Loan requests and where each one has got to
 */

export function useGetLoanRequests<TData = Awaited<ReturnType<typeof getLoanRequests>>, TError = unknown>(
 params?: GetLoanRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanRequests>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoanRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Counts and values across every submitted request, so the tracking table can show where the business stands without paging through it.

 * @summary High level view of the loan request book
 */
export const getLoanRequestSummary = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanRequestSummary>(
      {url: `/loan/api/v1/loan-requests/summary`, method: 'GET', signal
    },
      );
    }
  



export const getGetLoanRequestSummaryQueryKey = () => {
    return [
    `/loan/api/v1/loan-requests/summary`
    ] as const;
    }

    
export const getGetLoanRequestSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getLoanRequestSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanRequestSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanRequestSummaryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanRequestSummary>>> = ({ signal }) => getLoanRequestSummary(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanRequestSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoanRequestSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanRequestSummary>>>
export type GetLoanRequestSummaryQueryError = unknown


export function useGetLoanRequestSummary<TData = Awaited<ReturnType<typeof getLoanRequestSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanRequestSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanRequestSummary>>,
          TError,
          Awaited<ReturnType<typeof getLoanRequestSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanRequestSummary<TData = Awaited<ReturnType<typeof getLoanRequestSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanRequestSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanRequestSummary>>,
          TError,
          Awaited<ReturnType<typeof getLoanRequestSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanRequestSummary<TData = Awaited<ReturnType<typeof getLoanRequestSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanRequestSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary High level view of the loan request book
 */

export function useGetLoanRequestSummary<TData = Awaited<ReturnType<typeof getLoanRequestSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanRequestSummary>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoanRequestSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns the latest note for every lead id supplied, so a list of leads can show its last note without issuing one request per row. Leads with no notes are simply absent from the response.

 * @summary Get the most recent note for each of the given leads
 */
export const getLatestLeadNotes = (
    params: GetLatestLeadNotesParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LeadNote[]>(
      {url: `/loan/api/v1/leads/notes/latest`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLatestLeadNotesQueryKey = (params?: GetLatestLeadNotesParams,) => {
    return [
    `/loan/api/v1/leads/notes/latest`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLatestLeadNotesQueryOptions = <TData = Awaited<ReturnType<typeof getLatestLeadNotes>>, TError = unknown>(params: GetLatestLeadNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestLeadNotes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLatestLeadNotesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestLeadNotes>>> = ({ signal }) => getLatestLeadNotes(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLatestLeadNotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLatestLeadNotesQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestLeadNotes>>>
export type GetLatestLeadNotesQueryError = unknown


export function useGetLatestLeadNotes<TData = Awaited<ReturnType<typeof getLatestLeadNotes>>, TError = unknown>(
 params: GetLatestLeadNotesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestLeadNotes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestLeadNotes>>,
          TError,
          Awaited<ReturnType<typeof getLatestLeadNotes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestLeadNotes<TData = Awaited<ReturnType<typeof getLatestLeadNotes>>, TError = unknown>(
 params: GetLatestLeadNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestLeadNotes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestLeadNotes>>,
          TError,
          Awaited<ReturnType<typeof getLatestLeadNotes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestLeadNotes<TData = Awaited<ReturnType<typeof getLatestLeadNotes>>, TError = unknown>(
 params: GetLatestLeadNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestLeadNotes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the most recent note for each of the given leads
 */

export function useGetLatestLeadNotes<TData = Awaited<ReturnType<typeof getLatestLeadNotes>>, TError = unknown>(
 params: GetLatestLeadNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestLeadNotes>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLatestLeadNotesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Adds an append-only note to the lead. Used by the team to record what was discussed with the prospective customer while the lead is being worked.

 * @summary Add a note to a lead
 */
export const addLeadNote = (
    leadId: string,
    addLeadNote: AddLeadNote,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LeadNote>(
      {url: `/loan/api/v1/leads/${leadId}/notes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addLeadNote, signal
    },
      );
    }
  


export const getAddLeadNoteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addLeadNote>>, TError,{leadId: string;data: AddLeadNote}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addLeadNote>>, TError,{leadId: string;data: AddLeadNote}, TContext> => {

const mutationKey = ['addLeadNote'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addLeadNote>>, {leadId: string;data: AddLeadNote}> = (props) => {
          const {leadId,data} = props ?? {};

          return  addLeadNote(leadId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddLeadNoteMutationResult = NonNullable<Awaited<ReturnType<typeof addLeadNote>>>
    export type AddLeadNoteMutationBody = AddLeadNote
    export type AddLeadNoteMutationError = void

    /**
 * @summary Add a note to a lead
 */
export const useAddLeadNote = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addLeadNote>>, TError,{leadId: string;data: AddLeadNote}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addLeadNote>>,
        TError,
        {leadId: string;data: AddLeadNote},
        TContext
      > => {

      const mutationOptions = getAddLeadNoteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns paginated notes for a lead, newest first.
 * @summary Get notes for a lead
 */
export const getLeadNotes = (
    leadId: string,
    params?: GetLeadNotesParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LeadNotePage>(
      {url: `/loan/api/v1/leads/${leadId}/notes`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLeadNotesQueryKey = (leadId?: string,
    params?: GetLeadNotesParams,) => {
    return [
    `/loan/api/v1/leads/${leadId}/notes`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLeadNotesQueryOptions = <TData = Awaited<ReturnType<typeof getLeadNotes>>, TError = void>(leadId: string,
    params?: GetLeadNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadNotes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeadNotesQueryKey(leadId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeadNotes>>> = ({ signal }) => getLeadNotes(leadId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(leadId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeadNotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeadNotesQueryResult = NonNullable<Awaited<ReturnType<typeof getLeadNotes>>>
export type GetLeadNotesQueryError = void


export function useGetLeadNotes<TData = Awaited<ReturnType<typeof getLeadNotes>>, TError = void>(
 leadId: string,
    params: undefined |  GetLeadNotesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadNotes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeadNotes>>,
          TError,
          Awaited<ReturnType<typeof getLeadNotes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadNotes<TData = Awaited<ReturnType<typeof getLeadNotes>>, TError = void>(
 leadId: string,
    params?: GetLeadNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadNotes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeadNotes>>,
          TError,
          Awaited<ReturnType<typeof getLeadNotes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadNotes<TData = Awaited<ReturnType<typeof getLeadNotes>>, TError = void>(
 leadId: string,
    params?: GetLeadNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadNotes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get notes for a lead
 */

export function useGetLeadNotes<TData = Awaited<ReturnType<typeof getLeadNotes>>, TError = void>(
 leadId: string,
    params?: GetLeadNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadNotes>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeadNotesQueryOptions(leadId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieve all unclaimed tasks (not assigned to any user) with associated loan application details and pagination
 * @summary Get unclaimed loan application tasks
 */
export const getUnclaimedLoanTasks = (
    params?: GetUnclaimedLoanTasksParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<BpmTaskWithApplicationPage>(
      {url: `/loan/api/v1/tasks/unclaimed`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetUnclaimedLoanTasksQueryKey = (params?: GetUnclaimedLoanTasksParams,) => {
    return [
    `/loan/api/v1/tasks/unclaimed`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUnclaimedLoanTasksQueryOptions = <TData = Awaited<ReturnType<typeof getUnclaimedLoanTasks>>, TError = Error | void>(params?: GetUnclaimedLoanTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnclaimedLoanTasks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnclaimedLoanTasksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnclaimedLoanTasks>>> = ({ signal }) => getUnclaimedLoanTasks(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUnclaimedLoanTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUnclaimedLoanTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getUnclaimedLoanTasks>>>
export type GetUnclaimedLoanTasksQueryError = Error | void


export function useGetUnclaimedLoanTasks<TData = Awaited<ReturnType<typeof getUnclaimedLoanTasks>>, TError = Error | void>(
 params: undefined |  GetUnclaimedLoanTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnclaimedLoanTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnclaimedLoanTasks>>,
          TError,
          Awaited<ReturnType<typeof getUnclaimedLoanTasks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnclaimedLoanTasks<TData = Awaited<ReturnType<typeof getUnclaimedLoanTasks>>, TError = Error | void>(
 params?: GetUnclaimedLoanTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnclaimedLoanTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnclaimedLoanTasks>>,
          TError,
          Awaited<ReturnType<typeof getUnclaimedLoanTasks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnclaimedLoanTasks<TData = Awaited<ReturnType<typeof getUnclaimedLoanTasks>>, TError = Error | void>(
 params?: GetUnclaimedLoanTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnclaimedLoanTasks>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get unclaimed loan application tasks
 */

export function useGetUnclaimedLoanTasks<TData = Awaited<ReturnType<typeof getUnclaimedLoanTasks>>, TError = Error | void>(
 params?: GetUnclaimedLoanTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnclaimedLoanTasks>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUnclaimedLoanTasksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieve all claimed tasks (assigned to users) with associated loan application details and pagination
 * @summary Get claimed loan application tasks
 */
export const getClaimedLoanTasks = (
    params?: GetClaimedLoanTasksParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<BpmTaskWithApplicationPage>(
      {url: `/loan/api/v1/tasks/claimed`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetClaimedLoanTasksQueryKey = (params?: GetClaimedLoanTasksParams,) => {
    return [
    `/loan/api/v1/tasks/claimed`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetClaimedLoanTasksQueryOptions = <TData = Awaited<ReturnType<typeof getClaimedLoanTasks>>, TError = Error | void>(params?: GetClaimedLoanTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClaimedLoanTasks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClaimedLoanTasksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClaimedLoanTasks>>> = ({ signal }) => getClaimedLoanTasks(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClaimedLoanTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClaimedLoanTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getClaimedLoanTasks>>>
export type GetClaimedLoanTasksQueryError = Error | void


export function useGetClaimedLoanTasks<TData = Awaited<ReturnType<typeof getClaimedLoanTasks>>, TError = Error | void>(
 params: undefined |  GetClaimedLoanTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClaimedLoanTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClaimedLoanTasks>>,
          TError,
          Awaited<ReturnType<typeof getClaimedLoanTasks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClaimedLoanTasks<TData = Awaited<ReturnType<typeof getClaimedLoanTasks>>, TError = Error | void>(
 params?: GetClaimedLoanTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClaimedLoanTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClaimedLoanTasks>>,
          TError,
          Awaited<ReturnType<typeof getClaimedLoanTasks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClaimedLoanTasks<TData = Awaited<ReturnType<typeof getClaimedLoanTasks>>, TError = Error | void>(
 params?: GetClaimedLoanTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClaimedLoanTasks>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get claimed loan application tasks
 */

export function useGetClaimedLoanTasks<TData = Awaited<ReturnType<typeof getClaimedLoanTasks>>, TError = Error | void>(
 params?: GetClaimedLoanTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClaimedLoanTasks>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClaimedLoanTasksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a new loan application
 */
export const createLoanApplication = (
    loanApplication: NonReadonly<LoanApplication>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanApplication>(
      {url: `/loan/api/v1/loan-applications`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loanApplication, signal
    },
      );
    }
  


export const getCreateLoanApplicationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLoanApplication>>, TError,{data: NonReadonly<LoanApplication>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createLoanApplication>>, TError,{data: NonReadonly<LoanApplication>}, TContext> => {

const mutationKey = ['createLoanApplication'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLoanApplication>>, {data: NonReadonly<LoanApplication>}> = (props) => {
          const {data} = props ?? {};

          return  createLoanApplication(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateLoanApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof createLoanApplication>>>
    export type CreateLoanApplicationMutationBody = NonReadonly<LoanApplication>
    export type CreateLoanApplicationMutationError = void

    /**
 * @summary Create a new loan application
 */
export const useCreateLoanApplication = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLoanApplication>>, TError,{data: NonReadonly<LoanApplication>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLoanApplication>>,
        TError,
        {data: NonReadonly<LoanApplication>},
        TContext
      > => {

      const mutationOptions = getCreateLoanApplicationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get all loan applications
 */
export const getLoanApplications = (
    params?: GetLoanApplicationsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanApplicationPage>(
      {url: `/loan/api/v1/loan-applications`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLoanApplicationsQueryKey = (params?: GetLoanApplicationsParams,) => {
    return [
    `/loan/api/v1/loan-applications`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLoanApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof getLoanApplications>>, TError = unknown>(params?: GetLoanApplicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanApplicationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanApplications>>> = ({ signal }) => getLoanApplications(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanApplications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoanApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanApplications>>>
export type GetLoanApplicationsQueryError = unknown


export function useGetLoanApplications<TData = Awaited<ReturnType<typeof getLoanApplications>>, TError = unknown>(
 params: undefined |  GetLoanApplicationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanApplications>>,
          TError,
          Awaited<ReturnType<typeof getLoanApplications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanApplications<TData = Awaited<ReturnType<typeof getLoanApplications>>, TError = unknown>(
 params?: GetLoanApplicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanApplications>>,
          TError,
          Awaited<ReturnType<typeof getLoanApplications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanApplications<TData = Awaited<ReturnType<typeof getLoanApplications>>, TError = unknown>(
 params?: GetLoanApplicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplications>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all loan applications
 */

export function useGetLoanApplications<TData = Awaited<ReturnType<typeof getLoanApplications>>, TError = unknown>(
 params?: GetLoanApplicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplications>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoanApplicationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get loan application by ID
 */
export const getLoanApplication = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanApplication>(
      {url: `/loan/api/v1/loan-applications/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetLoanApplicationQueryKey = (id?: string,) => {
    return [
    `/loan/api/v1/loan-applications/${id}`
    ] as const;
    }

    
export const getGetLoanApplicationQueryOptions = <TData = Awaited<ReturnType<typeof getLoanApplication>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplication>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanApplicationQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanApplication>>> = ({ signal }) => getLoanApplication(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanApplication>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoanApplicationQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanApplication>>>
export type GetLoanApplicationQueryError = void


export function useGetLoanApplication<TData = Awaited<ReturnType<typeof getLoanApplication>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplication>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanApplication>>,
          TError,
          Awaited<ReturnType<typeof getLoanApplication>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanApplication<TData = Awaited<ReturnType<typeof getLoanApplication>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplication>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanApplication>>,
          TError,
          Awaited<ReturnType<typeof getLoanApplication>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanApplication<TData = Awaited<ReturnType<typeof getLoanApplication>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplication>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get loan application by ID
 */

export function useGetLoanApplication<TData = Awaited<ReturnType<typeof getLoanApplication>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplication>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoanApplicationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get loan application by task ID
 */
export const getLoanApplicationByTask = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanApplication>(
      {url: `/loan/api/v1/loan-application/task/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetLoanApplicationByTaskQueryKey = (id?: string,) => {
    return [
    `/loan/api/v1/loan-application/task/${id}`
    ] as const;
    }

    
export const getGetLoanApplicationByTaskQueryOptions = <TData = Awaited<ReturnType<typeof getLoanApplicationByTask>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplicationByTask>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanApplicationByTaskQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanApplicationByTask>>> = ({ signal }) => getLoanApplicationByTask(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanApplicationByTask>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoanApplicationByTaskQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanApplicationByTask>>>
export type GetLoanApplicationByTaskQueryError = void


export function useGetLoanApplicationByTask<TData = Awaited<ReturnType<typeof getLoanApplicationByTask>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplicationByTask>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanApplicationByTask>>,
          TError,
          Awaited<ReturnType<typeof getLoanApplicationByTask>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanApplicationByTask<TData = Awaited<ReturnType<typeof getLoanApplicationByTask>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplicationByTask>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanApplicationByTask>>,
          TError,
          Awaited<ReturnType<typeof getLoanApplicationByTask>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanApplicationByTask<TData = Awaited<ReturnType<typeof getLoanApplicationByTask>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplicationByTask>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get loan application by task ID
 */

export function useGetLoanApplicationByTask<TData = Awaited<ReturnType<typeof getLoanApplicationByTask>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplicationByTask>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoanApplicationByTaskQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Update individual details for a loan application
 */
export const updateIndividualDetails = (
    id: string,
    loanIndividual: LoanIndividual,
 ) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/loan/api/v1/loan-applications/${id}/individual-details`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: loanIndividual
    },
      );
    }
  


export const getUpdateIndividualDetailsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIndividualDetails>>, TError,{id: string;data: LoanIndividual}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateIndividualDetails>>, TError,{id: string;data: LoanIndividual}, TContext> => {

const mutationKey = ['updateIndividualDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateIndividualDetails>>, {id: string;data: LoanIndividual}> = (props) => {
          const {id,data} = props ?? {};

          return  updateIndividualDetails(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateIndividualDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updateIndividualDetails>>>
    export type UpdateIndividualDetailsMutationBody = LoanIndividual
    export type UpdateIndividualDetailsMutationError = void

    /**
 * @summary Update individual details for a loan application
 */
export const useUpdateIndividualDetails = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIndividualDetails>>, TError,{id: string;data: LoanIndividual}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateIndividualDetails>>,
        TError,
        {id: string;data: LoanIndividual},
        TContext
      > => {

      const mutationOptions = getUpdateIndividualDetailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update company details for a loan application
 */
export const updateCompanyDetails = (
    id: string,
    company: Company,
 ) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/loan/api/v1/loan-applications/${id}/company-details`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: company
    },
      );
    }
  


export const getUpdateCompanyDetailsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyDetails>>, TError,{id: string;data: Company}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateCompanyDetails>>, TError,{id: string;data: Company}, TContext> => {

const mutationKey = ['updateCompanyDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompanyDetails>>, {id: string;data: Company}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCompanyDetails(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompanyDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompanyDetails>>>
    export type UpdateCompanyDetailsMutationBody = Company
    export type UpdateCompanyDetailsMutationError = void

    /**
 * @summary Update company details for a loan application
 */
export const useUpdateCompanyDetails = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyDetails>>, TError,{id: string;data: Company}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCompanyDetails>>,
        TError,
        {id: string;data: Company},
        TContext
      > => {

      const mutationOptions = getUpdateCompanyDetailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update financial details for a loan application
 */
export const updateFinancialDetails = (
    id: string,
    financial: Financial,
 ) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/loan/api/v1/loan-applications/${id}/financial-details`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: financial
    },
      );
    }
  


export const getUpdateFinancialDetailsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFinancialDetails>>, TError,{id: string;data: Financial}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFinancialDetails>>, TError,{id: string;data: Financial}, TContext> => {

const mutationKey = ['updateFinancialDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFinancialDetails>>, {id: string;data: Financial}> = (props) => {
          const {id,data} = props ?? {};

          return  updateFinancialDetails(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFinancialDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updateFinancialDetails>>>
    export type UpdateFinancialDetailsMutationBody = Financial
    export type UpdateFinancialDetailsMutationError = void

    /**
 * @summary Update financial details for a loan application
 */
export const useUpdateFinancialDetails = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFinancialDetails>>, TError,{id: string;data: Financial}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFinancialDetails>>,
        TError,
        {id: string;data: Financial},
        TContext
      > => {

      const mutationOptions = getUpdateFinancialDetailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update bank details for a loan application
 */
export const updateBankDetails = (
    id: string,
    bankAccount: BankAccount,
 ) => {
      
      
      return customAxiosInstanceMutator<LoanApplication>(
      {url: `/loan/api/v1/loan-applications/${id}/bank-details`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: bankAccount
    },
      );
    }
  


export const getUpdateBankDetailsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBankDetails>>, TError,{id: string;data: BankAccount}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateBankDetails>>, TError,{id: string;data: BankAccount}, TContext> => {

const mutationKey = ['updateBankDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBankDetails>>, {id: string;data: BankAccount}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBankDetails(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateBankDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updateBankDetails>>>
    export type UpdateBankDetailsMutationBody = BankAccount
    export type UpdateBankDetailsMutationError = void

    /**
 * @summary Update bank details for a loan application
 */
export const useUpdateBankDetails = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBankDetails>>, TError,{id: string;data: BankAccount}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateBankDetails>>,
        TError,
        {id: string;data: BankAccount},
        TContext
      > => {

      const mutationOptions = getUpdateBankDetailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update collateral details for a loan application
 */
export const updateCollateralDetails = (
    id: string,
    collateral: Collateral,
 ) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/loan/api/v1/loan-applications/${id}/collateral-details`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: collateral
    },
      );
    }
  


export const getUpdateCollateralDetailsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCollateralDetails>>, TError,{id: string;data: Collateral}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateCollateralDetails>>, TError,{id: string;data: Collateral}, TContext> => {

const mutationKey = ['updateCollateralDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCollateralDetails>>, {id: string;data: Collateral}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCollateralDetails(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCollateralDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updateCollateralDetails>>>
    export type UpdateCollateralDetailsMutationBody = Collateral
    export type UpdateCollateralDetailsMutationError = void

    /**
 * @summary Update collateral details for a loan application
 */
export const useUpdateCollateralDetails = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCollateralDetails>>, TError,{id: string;data: Collateral}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCollateralDetails>>,
        TError,
        {id: string;data: Collateral},
        TContext
      > => {

      const mutationOptions = getUpdateCollateralDetailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update loan details for a loan application
 */
export const updateLoanDetails = (
    id: string,
    loanDetails: LoanDetails,
 ) => {
      
      
      return customAxiosInstanceMutator<LoanApplication>(
      {url: `/loan/api/v1/loan-applications/${id}/loan-details`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: loanDetails
    },
      );
    }
  


export const getUpdateLoanDetailsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLoanDetails>>, TError,{id: string;data: LoanDetails}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateLoanDetails>>, TError,{id: string;data: LoanDetails}, TContext> => {

const mutationKey = ['updateLoanDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLoanDetails>>, {id: string;data: LoanDetails}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLoanDetails(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLoanDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updateLoanDetails>>>
    export type UpdateLoanDetailsMutationBody = LoanDetails
    export type UpdateLoanDetailsMutationError = void

    /**
 * @summary Update loan details for a loan application
 */
export const useUpdateLoanDetails = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLoanDetails>>, TError,{id: string;data: LoanDetails}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLoanDetails>>,
        TError,
        {id: string;data: LoanDetails},
        TContext
      > => {

      const mutationOptions = getUpdateLoanDetailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Submit a loan application for review
 */
export const submitLoanApplication = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/loan/api/v1/loan-applications/${id}/submit`, method: 'POST', signal
    },
      );
    }
  


export const getSubmitLoanApplicationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitLoanApplication>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitLoanApplication>>, TError,{id: string}, TContext> => {

const mutationKey = ['submitLoanApplication'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitLoanApplication>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  submitLoanApplication(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitLoanApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof submitLoanApplication>>>
    
    export type SubmitLoanApplicationMutationError = void

    /**
 * @summary Submit a loan application for review
 */
export const useSubmitLoanApplication = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitLoanApplication>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitLoanApplication>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSubmitLoanApplicationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Cancels a loan application that has not yet been disbursed or completed. Sets the status to CANCELLED, records the reason and timestamp. If a BPM process is active, it will be terminated. If a ledger account exists (pre-disbursement), it will be marked as CANCELLED.

 * @summary Cancel a loan application
 */
export const cancelLoanApplication = (
    id: string,
    cancelLoanApplicationRequest: CancelLoanApplicationRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanApplication>(
      {url: `/loan/api/v1/loan-applications/${id}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelLoanApplicationRequest, signal
    },
      );
    }
  


export const getCancelLoanApplicationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelLoanApplication>>, TError,{id: string;data: CancelLoanApplicationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelLoanApplication>>, TError,{id: string;data: CancelLoanApplicationRequest}, TContext> => {

const mutationKey = ['cancelLoanApplication'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelLoanApplication>>, {id: string;data: CancelLoanApplicationRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  cancelLoanApplication(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelLoanApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof cancelLoanApplication>>>
    export type CancelLoanApplicationMutationBody = CancelLoanApplicationRequest
    export type CancelLoanApplicationMutationError = void

    /**
 * @summary Cancel a loan application
 */
export const useCancelLoanApplication = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelLoanApplication>>, TError,{id: string;data: CancelLoanApplicationRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelLoanApplication>>,
        TError,
        {id: string;data: CancelLoanApplicationRequest},
        TContext
      > => {

      const mutationOptions = getCancelLoanApplicationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Adds an append-only comment to the loan application. The current application stage is captured automatically server-side.

 * @summary Add a comment to a loan application
 */
export const addLoanApplicationComment = (
    id: string,
    addLoanApplicationComment: AddLoanApplicationComment,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanApplicationComment>(
      {url: `/loan/api/v1/loan-applications/${id}/comments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addLoanApplicationComment, signal
    },
      );
    }
  


export const getAddLoanApplicationCommentMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addLoanApplicationComment>>, TError,{id: string;data: AddLoanApplicationComment}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addLoanApplicationComment>>, TError,{id: string;data: AddLoanApplicationComment}, TContext> => {

const mutationKey = ['addLoanApplicationComment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addLoanApplicationComment>>, {id: string;data: AddLoanApplicationComment}> = (props) => {
          const {id,data} = props ?? {};

          return  addLoanApplicationComment(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddLoanApplicationCommentMutationResult = NonNullable<Awaited<ReturnType<typeof addLoanApplicationComment>>>
    export type AddLoanApplicationCommentMutationBody = AddLoanApplicationComment
    export type AddLoanApplicationCommentMutationError = void

    /**
 * @summary Add a comment to a loan application
 */
export const useAddLoanApplicationComment = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addLoanApplicationComment>>, TError,{id: string;data: AddLoanApplicationComment}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addLoanApplicationComment>>,
        TError,
        {id: string;data: AddLoanApplicationComment},
        TContext
      > => {

      const mutationOptions = getAddLoanApplicationCommentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns paginated comments for a loan application, newest first.
 * @summary Get comments for a loan application
 */
export const getLoanApplicationComments = (
    id: string,
    params?: GetLoanApplicationCommentsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanApplicationCommentPage>(
      {url: `/loan/api/v1/loan-applications/${id}/comments`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLoanApplicationCommentsQueryKey = (id?: string,
    params?: GetLoanApplicationCommentsParams,) => {
    return [
    `/loan/api/v1/loan-applications/${id}/comments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLoanApplicationCommentsQueryOptions = <TData = Awaited<ReturnType<typeof getLoanApplicationComments>>, TError = void>(id: string,
    params?: GetLoanApplicationCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplicationComments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanApplicationCommentsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanApplicationComments>>> = ({ signal }) => getLoanApplicationComments(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanApplicationComments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoanApplicationCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanApplicationComments>>>
export type GetLoanApplicationCommentsQueryError = void


export function useGetLoanApplicationComments<TData = Awaited<ReturnType<typeof getLoanApplicationComments>>, TError = void>(
 id: string,
    params: undefined |  GetLoanApplicationCommentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplicationComments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanApplicationComments>>,
          TError,
          Awaited<ReturnType<typeof getLoanApplicationComments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanApplicationComments<TData = Awaited<ReturnType<typeof getLoanApplicationComments>>, TError = void>(
 id: string,
    params?: GetLoanApplicationCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplicationComments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanApplicationComments>>,
          TError,
          Awaited<ReturnType<typeof getLoanApplicationComments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanApplicationComments<TData = Awaited<ReturnType<typeof getLoanApplicationComments>>, TError = void>(
 id: string,
    params?: GetLoanApplicationCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplicationComments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get comments for a loan application
 */

export function useGetLoanApplicationComments<TData = Awaited<ReturnType<typeof getLoanApplicationComments>>, TError = void>(
 id: string,
    params?: GetLoanApplicationCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanApplicationComments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoanApplicationCommentsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get all verification items for a loan application
 */
export const getVerifications = (
    applicationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<VerificationCategory[]>(
      {url: `/loan/api/v1/applications/${applicationId}/verifications`, method: 'GET', signal
    },
      );
    }
  



export const getGetVerificationsQueryKey = (applicationId?: string,) => {
    return [
    `/loan/api/v1/applications/${applicationId}/verifications`
    ] as const;
    }

    
export const getGetVerificationsQueryOptions = <TData = Awaited<ReturnType<typeof getVerifications>>, TError = void>(applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVerificationsQueryKey(applicationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVerifications>>> = ({ signal }) => getVerifications(applicationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(applicationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVerifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVerificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getVerifications>>>
export type GetVerificationsQueryError = void


export function useGetVerifications<TData = Awaited<ReturnType<typeof getVerifications>>, TError = void>(
 applicationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerifications>>,
          TError,
          Awaited<ReturnType<typeof getVerifications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerifications<TData = Awaited<ReturnType<typeof getVerifications>>, TError = void>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerifications>>,
          TError,
          Awaited<ReturnType<typeof getVerifications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerifications<TData = Awaited<ReturnType<typeof getVerifications>>, TError = void>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifications>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all verification items for a loan application
 */

export function useGetVerifications<TData = Awaited<ReturnType<typeof getVerifications>>, TError = void>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifications>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVerificationsQueryOptions(applicationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Update a verification item
 */
export const updateVerificationItem = (
    applicationId: string,
    categoryCode: string,
    itemCode: string,
    verificationUpdate: VerificationUpdate,
 ) => {
      
      
      return customAxiosInstanceMutator<VerificationItem>(
      {url: `/loan/api/v1/applications/${applicationId}/verifications/${categoryCode}/${itemCode}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: verificationUpdate
    },
      );
    }
  


export const getUpdateVerificationItemMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVerificationItem>>, TError,{applicationId: string;categoryCode: string;itemCode: string;data: VerificationUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVerificationItem>>, TError,{applicationId: string;categoryCode: string;itemCode: string;data: VerificationUpdate}, TContext> => {

const mutationKey = ['updateVerificationItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVerificationItem>>, {applicationId: string;categoryCode: string;itemCode: string;data: VerificationUpdate}> = (props) => {
          const {applicationId,categoryCode,itemCode,data} = props ?? {};

          return  updateVerificationItem(applicationId,categoryCode,itemCode,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVerificationItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateVerificationItem>>>
    export type UpdateVerificationItemMutationBody = VerificationUpdate
    export type UpdateVerificationItemMutationError = void

    /**
 * @summary Update a verification item
 */
export const useUpdateVerificationItem = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVerificationItem>>, TError,{applicationId: string;categoryCode: string;itemCode: string;data: VerificationUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVerificationItem>>,
        TError,
        {applicationId: string;categoryCode: string;itemCode: string;data: VerificationUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateVerificationItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update all verification items in a category
 */
export const updateVerificationCategory = (
    applicationId: string,
    categoryCode: string,
    verificationUpdate: VerificationUpdate,
 ) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/loan/api/v1/applications/${applicationId}/verifications/${categoryCode}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: verificationUpdate
    },
      );
    }
  


export const getUpdateVerificationCategoryMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVerificationCategory>>, TError,{applicationId: string;categoryCode: string;data: VerificationUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVerificationCategory>>, TError,{applicationId: string;categoryCode: string;data: VerificationUpdate}, TContext> => {

const mutationKey = ['updateVerificationCategory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVerificationCategory>>, {applicationId: string;categoryCode: string;data: VerificationUpdate}> = (props) => {
          const {applicationId,categoryCode,data} = props ?? {};

          return  updateVerificationCategory(applicationId,categoryCode,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVerificationCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateVerificationCategory>>>
    export type UpdateVerificationCategoryMutationBody = VerificationUpdate
    export type UpdateVerificationCategoryMutationError = void

    /**
 * @summary Update all verification items in a category
 */
export const useUpdateVerificationCategory = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVerificationCategory>>, TError,{applicationId: string;categoryCode: string;data: VerificationUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVerificationCategory>>,
        TError,
        {applicationId: string;categoryCode: string;data: VerificationUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateVerificationCategoryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Initialize verification items for a loan application
 */
export const initializeVerifications = (
    applicationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/loan/api/v1/applications/${applicationId}/verifications/initialize`, method: 'POST', signal
    },
      );
    }
  


export const getInitializeVerificationsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeVerifications>>, TError,{applicationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof initializeVerifications>>, TError,{applicationId: string}, TContext> => {

const mutationKey = ['initializeVerifications'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initializeVerifications>>, {applicationId: string}> = (props) => {
          const {applicationId} = props ?? {};

          return  initializeVerifications(applicationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InitializeVerificationsMutationResult = NonNullable<Awaited<ReturnType<typeof initializeVerifications>>>
    
    export type InitializeVerificationsMutationError = void

    /**
 * @summary Initialize verification items for a loan application
 */
export const useInitializeVerifications = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeVerifications>>, TError,{applicationId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof initializeVerifications>>,
        TError,
        {applicationId: string},
        TContext
      > => {

      const mutationOptions = getInitializeVerificationsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get verification statistics
 */
export const getVerificationStats = (
    applicationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<VerificationStats>(
      {url: `/loan/api/v1/applications/${applicationId}/verifications/stats`, method: 'GET', signal
    },
      );
    }
  



export const getGetVerificationStatsQueryKey = (applicationId?: string,) => {
    return [
    `/loan/api/v1/applications/${applicationId}/verifications/stats`
    ] as const;
    }

    
export const getGetVerificationStatsQueryOptions = <TData = Awaited<ReturnType<typeof getVerificationStats>>, TError = void>(applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerificationStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVerificationStatsQueryKey(applicationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVerificationStats>>> = ({ signal }) => getVerificationStats(applicationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(applicationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVerificationStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVerificationStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getVerificationStats>>>
export type GetVerificationStatsQueryError = void


export function useGetVerificationStats<TData = Awaited<ReturnType<typeof getVerificationStats>>, TError = void>(
 applicationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerificationStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerificationStats>>,
          TError,
          Awaited<ReturnType<typeof getVerificationStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerificationStats<TData = Awaited<ReturnType<typeof getVerificationStats>>, TError = void>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerificationStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerificationStats>>,
          TError,
          Awaited<ReturnType<typeof getVerificationStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerificationStats<TData = Awaited<ReturnType<typeof getVerificationStats>>, TError = void>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerificationStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get verification statistics
 */

export function useGetVerificationStats<TData = Awaited<ReturnType<typeof getVerificationStats>>, TError = void>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerificationStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVerificationStatsQueryOptions(applicationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Check if all required verifications are completed and submit the verification
 * @summary Submit application verification
 */
export const submitVerification = (
    applicationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanApplication>(
      {url: `/loan/api/v1/applications/${applicationId}/verifications/submit`, method: 'POST', signal
    },
      );
    }
  


export const getSubmitVerificationMutationOptions = <TError = Error | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitVerification>>, TError,{applicationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitVerification>>, TError,{applicationId: string}, TContext> => {

const mutationKey = ['submitVerification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitVerification>>, {applicationId: string}> = (props) => {
          const {applicationId} = props ?? {};

          return  submitVerification(applicationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof submitVerification>>>
    
    export type SubmitVerificationMutationError = Error | void

    /**
 * @summary Submit application verification
 */
export const useSubmitVerification = <TError = Error | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitVerification>>, TError,{applicationId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitVerification>>,
        TError,
        {applicationId: string},
        TContext
      > => {

      const mutationOptions = getSubmitVerificationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Reject the verification with a reason or comment
 * @summary Reject application verification
 */
export const rejectVerification = (
    applicationId: string,
    verificationRejection: VerificationRejection,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanApplication>(
      {url: `/loan/api/v1/applications/${applicationId}/verifications/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verificationRejection, signal
    },
      );
    }
  


export const getRejectVerificationMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectVerification>>, TError,{applicationId: string;data: VerificationRejection}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rejectVerification>>, TError,{applicationId: string;data: VerificationRejection}, TContext> => {

const mutationKey = ['rejectVerification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectVerification>>, {applicationId: string;data: VerificationRejection}> = (props) => {
          const {applicationId,data} = props ?? {};

          return  rejectVerification(applicationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof rejectVerification>>>
    export type RejectVerificationMutationBody = VerificationRejection
    export type RejectVerificationMutationError = Error

    /**
 * @summary Reject application verification
 */
export const useRejectVerification = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectVerification>>, TError,{applicationId: string;data: VerificationRejection}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectVerification>>,
        TError,
        {applicationId: string;data: VerificationRejection},
        TContext
      > => {

      const mutationOptions = getRejectVerificationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieve verification history records with pagination support
 * @summary Get verification history with pagination
 */
export const getVerificationHistory = (
    params?: GetVerificationHistoryParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<VerificationHistoryPage>(
      {url: `/loan/api/v1/verification-history`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetVerificationHistoryQueryKey = (params?: GetVerificationHistoryParams,) => {
    return [
    `/loan/api/v1/verification-history`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetVerificationHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getVerificationHistory>>, TError = Error>(params?: GetVerificationHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerificationHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVerificationHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVerificationHistory>>> = ({ signal }) => getVerificationHistory(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVerificationHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVerificationHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getVerificationHistory>>>
export type GetVerificationHistoryQueryError = Error


export function useGetVerificationHistory<TData = Awaited<ReturnType<typeof getVerificationHistory>>, TError = Error>(
 params: undefined |  GetVerificationHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerificationHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerificationHistory>>,
          TError,
          Awaited<ReturnType<typeof getVerificationHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerificationHistory<TData = Awaited<ReturnType<typeof getVerificationHistory>>, TError = Error>(
 params?: GetVerificationHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerificationHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerificationHistory>>,
          TError,
          Awaited<ReturnType<typeof getVerificationHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerificationHistory<TData = Awaited<ReturnType<typeof getVerificationHistory>>, TError = Error>(
 params?: GetVerificationHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerificationHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get verification history with pagination
 */

export function useGetVerificationHistory<TData = Awaited<ReturnType<typeof getVerificationHistory>>, TError = Error>(
 params?: GetVerificationHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerificationHistory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVerificationHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get credit assessment details for a loan application
 */
export const getCreditAssessment = (
    applicationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<CreditAssessment>(
      {url: `/loan/api/v1/applications/${applicationId}/credit-assessment`, method: 'GET', signal
    },
      );
    }
  



export const getGetCreditAssessmentQueryKey = (applicationId?: string,) => {
    return [
    `/loan/api/v1/applications/${applicationId}/credit-assessment`
    ] as const;
    }

    
export const getGetCreditAssessmentQueryOptions = <TData = Awaited<ReturnType<typeof getCreditAssessment>>, TError = Error>(applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditAssessmentQueryKey(applicationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditAssessment>>> = ({ signal }) => getCreditAssessment(applicationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(applicationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreditAssessmentQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditAssessment>>>
export type GetCreditAssessmentQueryError = Error


export function useGetCreditAssessment<TData = Awaited<ReturnType<typeof getCreditAssessment>>, TError = Error>(
 applicationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditAssessment>>,
          TError,
          Awaited<ReturnType<typeof getCreditAssessment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditAssessment<TData = Awaited<ReturnType<typeof getCreditAssessment>>, TError = Error>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditAssessment>>,
          TError,
          Awaited<ReturnType<typeof getCreditAssessment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditAssessment<TData = Awaited<ReturnType<typeof getCreditAssessment>>, TError = Error>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessment>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get credit assessment details for a loan application
 */

export function useGetCreditAssessment<TData = Awaited<ReturnType<typeof getCreditAssessment>>, TError = Error>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessment>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreditAssessmentQueryOptions(applicationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Submit credit assessment for a loan application
 */
export const submitCreditAssessment = (
    applicationId: string,
    creditAssessmentSubmission: CreditAssessmentSubmission,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<CreditAssessment>(
      {url: `/loan/api/v1/applications/${applicationId}/credit-assessment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditAssessmentSubmission, signal
    },
      );
    }
  


export const getSubmitCreditAssessmentMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCreditAssessment>>, TError,{applicationId: string;data: CreditAssessmentSubmission}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitCreditAssessment>>, TError,{applicationId: string;data: CreditAssessmentSubmission}, TContext> => {

const mutationKey = ['submitCreditAssessment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitCreditAssessment>>, {applicationId: string;data: CreditAssessmentSubmission}> = (props) => {
          const {applicationId,data} = props ?? {};

          return  submitCreditAssessment(applicationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitCreditAssessmentMutationResult = NonNullable<Awaited<ReturnType<typeof submitCreditAssessment>>>
    export type SubmitCreditAssessmentMutationBody = CreditAssessmentSubmission
    export type SubmitCreditAssessmentMutationError = Error

    /**
 * @summary Submit credit assessment for a loan application
 */
export const useSubmitCreditAssessment = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCreditAssessment>>, TError,{applicationId: string;data: CreditAssessmentSubmission}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitCreditAssessment>>,
        TError,
        {applicationId: string;data: CreditAssessmentSubmission},
        TContext
      > => {

      const mutationOptions = getSubmitCreditAssessmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Calculates interest rates, admin fees, total repayment amount, and payment schedule based on loan amount, term, and type
 * @summary Calculate loan details based on input parameters
 */
export const calculateLoan = (
    loanCalculationRequest: LoanCalculationRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanCalculationResult>(
      {url: `/loan/api/v1/calculate-loan`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loanCalculationRequest, signal
    },
      );
    }
  


export const getCalculateLoanMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calculateLoan>>, TError,{data: LoanCalculationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof calculateLoan>>, TError,{data: LoanCalculationRequest}, TContext> => {

const mutationKey = ['calculateLoan'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof calculateLoan>>, {data: LoanCalculationRequest}> = (props) => {
          const {data} = props ?? {};

          return  calculateLoan(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CalculateLoanMutationResult = NonNullable<Awaited<ReturnType<typeof calculateLoan>>>
    export type CalculateLoanMutationBody = LoanCalculationRequest
    export type CalculateLoanMutationError = Error

    /**
 * @summary Calculate loan details based on input parameters
 */
export const useCalculateLoan = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calculateLoan>>, TError,{data: LoanCalculationRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof calculateLoan>>,
        TError,
        {data: LoanCalculationRequest},
        TContext
      > => {

      const mutationOptions = getCalculateLoanMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Calculates and updates interest rates, admin fees, total repayment amount based on current application data
 * @summary Calculate and update loan details for an existing application
 */
export const calculateAndUpdateLoanDetails = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanCalculationResult>(
      {url: `/loan/api/v1/loan-applications/${id}/calculate-loan-details`, method: 'POST', signal
    },
      );
    }
  


export const getCalculateAndUpdateLoanDetailsMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calculateAndUpdateLoanDetails>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof calculateAndUpdateLoanDetails>>, TError,{id: string}, TContext> => {

const mutationKey = ['calculateAndUpdateLoanDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof calculateAndUpdateLoanDetails>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  calculateAndUpdateLoanDetails(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CalculateAndUpdateLoanDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof calculateAndUpdateLoanDetails>>>
    
    export type CalculateAndUpdateLoanDetailsMutationError = Error

    /**
 * @summary Calculate and update loan details for an existing application
 */
export const useCalculateAndUpdateLoanDetails = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calculateAndUpdateLoanDetails>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof calculateAndUpdateLoanDetails>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCalculateAndUpdateLoanDetailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Upload a signed loan agreement document for a loan application
 * @summary Upload a signed loan agreement
 */
export const uploadSignedLoanAgreement = (
    applicationId: string,
    loanAgreementUpload: LoanAgreementUpload,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(loanAgreementUpload.notes !== undefined) {
 formData.append(`notes`, loanAgreementUpload.notes)
 }
formData.append(`file`, loanAgreementUpload.file)
formData.append(`confirmedSigned`, loanAgreementUpload.confirmedSigned.toString())
if(loanAgreementUpload.uploadedBy !== undefined) {
 formData.append(`uploadedBy`, loanAgreementUpload.uploadedBy)
 }

      return customAxiosInstanceMutator<LoanApplication>(
      {url: `/loan/api/v1/loan-applications/${applicationId}/agreements/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadSignedLoanAgreementMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadSignedLoanAgreement>>, TError,{applicationId: string;data: LoanAgreementUpload}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadSignedLoanAgreement>>, TError,{applicationId: string;data: LoanAgreementUpload}, TContext> => {

const mutationKey = ['uploadSignedLoanAgreement'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadSignedLoanAgreement>>, {applicationId: string;data: LoanAgreementUpload}> = (props) => {
          const {applicationId,data} = props ?? {};

          return  uploadSignedLoanAgreement(applicationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadSignedLoanAgreementMutationResult = NonNullable<Awaited<ReturnType<typeof uploadSignedLoanAgreement>>>
    export type UploadSignedLoanAgreementMutationBody = LoanAgreementUpload
    export type UploadSignedLoanAgreementMutationError = Error

    /**
 * @summary Upload a signed loan agreement
 */
export const useUploadSignedLoanAgreement = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadSignedLoanAgreement>>, TError,{applicationId: string;data: LoanAgreementUpload}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadSignedLoanAgreement>>,
        TError,
        {applicationId: string;data: LoanAgreementUpload},
        TContext
      > => {

      const mutationOptions = getUploadSignedLoanAgreementMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Submit collateral verification with supporting documents, photos, and approval status
 * @summary Verify collateral for a loan application
 */
export const verifyCollateral = (
    applicationId: string,
    collateralVerification: CollateralVerification,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`status`, collateralVerification.status)
formData.append(`assetDescription`, collateralVerification.assetDescription)
if(collateralVerification.notes !== undefined) {
 formData.append(`notes`, collateralVerification.notes)
 }
if(collateralVerification.collateralReport !== undefined) {
 formData.append(`collateralReport`, collateralVerification.collateralReport)
 }
formData.append(`collateralChecklist`, collateralVerification.collateralChecklist)
collateralVerification.photos.forEach(value => formData.append(`photos`, value));

      return customAxiosInstanceMutator<LoanApplication>(
      {url: `/loan/api/v1/applications/${applicationId}/collateral/verify`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getVerifyCollateralMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCollateral>>, TError,{applicationId: string;data: CollateralVerification}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verifyCollateral>>, TError,{applicationId: string;data: CollateralVerification}, TContext> => {

const mutationKey = ['verifyCollateral'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyCollateral>>, {applicationId: string;data: CollateralVerification}> = (props) => {
          const {applicationId,data} = props ?? {};

          return  verifyCollateral(applicationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyCollateralMutationResult = NonNullable<Awaited<ReturnType<typeof verifyCollateral>>>
    export type VerifyCollateralMutationBody = CollateralVerification
    export type VerifyCollateralMutationError = Error

    /**
 * @summary Verify collateral for a loan application
 */
export const useVerifyCollateral = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCollateral>>, TError,{applicationId: string;data: CollateralVerification}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyCollateral>>,
        TError,
        {applicationId: string;data: CollateralVerification},
        TContext
      > => {

      const mutationOptions = getVerifyCollateralMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Approve (with an approved amount, rationale and conditions) or reject an application the credit analyst recommended. Only the Credit Committee or an administrator may decide.
 * @summary Record the Credit Committee's decision
 */
export const submitCreditApproval = (
    applicationId: string,
    creditApprovalDecision: CreditApprovalDecision,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanApplication>(
      {url: `/loan/api/v1/applications/${applicationId}/credit-approval`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditApprovalDecision, signal
    },
      );
    }
  


export const getSubmitCreditApprovalMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCreditApproval>>, TError,{applicationId: string;data: CreditApprovalDecision}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitCreditApproval>>, TError,{applicationId: string;data: CreditApprovalDecision}, TContext> => {

const mutationKey = ['submitCreditApproval'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitCreditApproval>>, {applicationId: string;data: CreditApprovalDecision}> = (props) => {
          const {applicationId,data} = props ?? {};

          return  submitCreditApproval(applicationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitCreditApprovalMutationResult = NonNullable<Awaited<ReturnType<typeof submitCreditApproval>>>
    export type SubmitCreditApprovalMutationBody = CreditApprovalDecision
    export type SubmitCreditApprovalMutationError = void

    /**
 * @summary Record the Credit Committee's decision
 */
export const useSubmitCreditApproval = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCreditApproval>>, TError,{applicationId: string;data: CreditApprovalDecision}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitCreditApproval>>,
        TError,
        {applicationId: string;data: CreditApprovalDecision},
        TContext
      > => {

      const mutationOptions = getSubmitCreditApprovalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Any staff member may mark a condition fulfilled; only the Credit Committee, a credit analyst or an administrator may waive one.
 * @summary Fulfil or waive an approval condition
 */
export const resolveApprovalCondition = (
    applicationId: string,
    conditionId: string,
    approvalConditionResolution: ApprovalConditionResolution,
 ) => {
      
      
      return customAxiosInstanceMutator<LoanApplication>(
      {url: `/loan/api/v1/applications/${applicationId}/approval-conditions/${conditionId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: approvalConditionResolution
    },
      );
    }
  


export const getResolveApprovalConditionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveApprovalCondition>>, TError,{applicationId: string;conditionId: string;data: ApprovalConditionResolution}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resolveApprovalCondition>>, TError,{applicationId: string;conditionId: string;data: ApprovalConditionResolution}, TContext> => {

const mutationKey = ['resolveApprovalCondition'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveApprovalCondition>>, {applicationId: string;conditionId: string;data: ApprovalConditionResolution}> = (props) => {
          const {applicationId,conditionId,data} = props ?? {};

          return  resolveApprovalCondition(applicationId,conditionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResolveApprovalConditionMutationResult = NonNullable<Awaited<ReturnType<typeof resolveApprovalCondition>>>
    export type ResolveApprovalConditionMutationBody = ApprovalConditionResolution
    export type ResolveApprovalConditionMutationError = void

    /**
 * @summary Fulfil or waive an approval condition
 */
export const useResolveApprovalCondition = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveApprovalCondition>>, TError,{applicationId: string;conditionId: string;data: ApprovalConditionResolution}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resolveApprovalCondition>>,
        TError,
        {applicationId: string;conditionId: string;data: ApprovalConditionResolution},
        TContext
      > => {

      const mutationOptions = getResolveApprovalConditionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Submit verification decision for a specific collateral item with just status and notes (without documents)
 * @summary Submit collateral verification status and notes
 */
export const submitCollateralVerification = (
    applicationId: string,
    collateralVerificationSubmission: CollateralVerificationSubmission,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanApplication>(
      {url: `/loan/api/v1/applications/${applicationId}/collateral/submit-verification`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: collateralVerificationSubmission, signal
    },
      );
    }
  


export const getSubmitCollateralVerificationMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCollateralVerification>>, TError,{applicationId: string;data: CollateralVerificationSubmission}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitCollateralVerification>>, TError,{applicationId: string;data: CollateralVerificationSubmission}, TContext> => {

const mutationKey = ['submitCollateralVerification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitCollateralVerification>>, {applicationId: string;data: CollateralVerificationSubmission}> = (props) => {
          const {applicationId,data} = props ?? {};

          return  submitCollateralVerification(applicationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitCollateralVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof submitCollateralVerification>>>
    export type SubmitCollateralVerificationMutationBody = CollateralVerificationSubmission
    export type SubmitCollateralVerificationMutationError = Error

    /**
 * @summary Submit collateral verification status and notes
 */
export const useSubmitCollateralVerification = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCollateralVerification>>, TError,{applicationId: string;data: CollateralVerificationSubmission}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitCollateralVerification>>,
        TError,
        {applicationId: string;data: CollateralVerificationSubmission},
        TContext
      > => {

      const mutationOptions = getSubmitCollateralVerificationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Records the disbursement of approved loan funds to a customer
 * @summary Record a loan disbursement
 */
export const recordDisbursement = (
    applicationId: string,
    loanDisbursement: NonReadonly<LoanDisbursement>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanApplication>(
      {url: `/loan/api/v1/applications/${applicationId}/disbursement`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loanDisbursement, signal
    },
      );
    }
  


export const getRecordDisbursementMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordDisbursement>>, TError,{applicationId: string;data: NonReadonly<LoanDisbursement>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof recordDisbursement>>, TError,{applicationId: string;data: NonReadonly<LoanDisbursement>}, TContext> => {

const mutationKey = ['recordDisbursement'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordDisbursement>>, {applicationId: string;data: NonReadonly<LoanDisbursement>}> = (props) => {
          const {applicationId,data} = props ?? {};

          return  recordDisbursement(applicationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RecordDisbursementMutationResult = NonNullable<Awaited<ReturnType<typeof recordDisbursement>>>
    export type RecordDisbursementMutationBody = NonReadonly<LoanDisbursement>
    export type RecordDisbursementMutationError = Error

    /**
 * @summary Record a loan disbursement
 */
export const useRecordDisbursement = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordDisbursement>>, TError,{applicationId: string;data: NonReadonly<LoanDisbursement>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordDisbursement>>,
        TError,
        {applicationId: string;data: NonReadonly<LoanDisbursement>},
        TContext
      > => {

      const mutationOptions = getRecordDisbursementMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Attaches the bank's proof of payment to a disbursement already recorded - it often arrives after the payout. Attaching again replaces the link; the earlier file stays on the application.

 * @summary Attach proof of payment to a disbursement
 */
export const attachProofOfPayment = (
    applicationId: string,
    disbursementId: string,
    attachProofOfPaymentBody: AttachProofOfPaymentBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, attachProofOfPaymentBody.file)
if(attachProofOfPaymentBody.uploadedBy !== undefined) {
 formData.append(`uploadedBy`, attachProofOfPaymentBody.uploadedBy)
 }

      return customAxiosInstanceMutator<LoanApplication>(
      {url: `/loan/api/v1/applications/${applicationId}/disbursements/${disbursementId}/proof-of-payment`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getAttachProofOfPaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachProofOfPayment>>, TError,{applicationId: string;disbursementId: string;data: AttachProofOfPaymentBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof attachProofOfPayment>>, TError,{applicationId: string;disbursementId: string;data: AttachProofOfPaymentBody}, TContext> => {

const mutationKey = ['attachProofOfPayment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof attachProofOfPayment>>, {applicationId: string;disbursementId: string;data: AttachProofOfPaymentBody}> = (props) => {
          const {applicationId,disbursementId,data} = props ?? {};

          return  attachProofOfPayment(applicationId,disbursementId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AttachProofOfPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof attachProofOfPayment>>>
    export type AttachProofOfPaymentMutationBody = AttachProofOfPaymentBody
    export type AttachProofOfPaymentMutationError = unknown

    /**
 * @summary Attach proof of payment to a disbursement
 */
export const useAttachProofOfPayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachProofOfPayment>>, TError,{applicationId: string;disbursementId: string;data: AttachProofOfPaymentBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof attachProofOfPayment>>,
        TError,
        {applicationId: string;disbursementId: string;data: AttachProofOfPaymentBody},
        TContext
      > => {

      const mutationOptions = getAttachProofOfPaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Applications declined in a period (verification, credit assessment or Credit Committee) with their reason, totalled by reason and by stage. Defaults to the current month to date.

 * @summary Decline reasons report
 */
export const getDeclineReasonReport = (
    params?: GetDeclineReasonReportParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DeclineReasonReport>(
      {url: `/loan/api/v1/reports/decline-reasons`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetDeclineReasonReportQueryKey = (params?: GetDeclineReasonReportParams,) => {
    return [
    `/loan/api/v1/reports/decline-reasons`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDeclineReasonReportQueryOptions = <TData = Awaited<ReturnType<typeof getDeclineReasonReport>>, TError = unknown>(params?: GetDeclineReasonReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeclineReasonReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeclineReasonReportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeclineReasonReport>>> = ({ signal }) => getDeclineReasonReport(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeclineReasonReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDeclineReasonReportQueryResult = NonNullable<Awaited<ReturnType<typeof getDeclineReasonReport>>>
export type GetDeclineReasonReportQueryError = unknown


export function useGetDeclineReasonReport<TData = Awaited<ReturnType<typeof getDeclineReasonReport>>, TError = unknown>(
 params: undefined |  GetDeclineReasonReportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeclineReasonReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeclineReasonReport>>,
          TError,
          Awaited<ReturnType<typeof getDeclineReasonReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeclineReasonReport<TData = Awaited<ReturnType<typeof getDeclineReasonReport>>, TError = unknown>(
 params?: GetDeclineReasonReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeclineReasonReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeclineReasonReport>>,
          TError,
          Awaited<ReturnType<typeof getDeclineReasonReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeclineReasonReport<TData = Awaited<ReturnType<typeof getDeclineReasonReport>>, TError = unknown>(
 params?: GetDeclineReasonReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeclineReasonReport>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Decline reasons report
 */

export function useGetDeclineReasonReport<TData = Awaited<ReturnType<typeof getDeclineReasonReport>>, TError = unknown>(
 params?: GetDeclineReasonReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeclineReasonReport>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDeclineReasonReportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieve credit assessment history records with pagination support
 * @summary Get credit assessment history with pagination
 */
export const getCreditAssessmentHistory = (
    params?: GetCreditAssessmentHistoryParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<CreditAssessmentHistoryPage>(
      {url: `/loan/api/v1/credit-assessment-history`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetCreditAssessmentHistoryQueryKey = (params?: GetCreditAssessmentHistoryParams,) => {
    return [
    `/loan/api/v1/credit-assessment-history`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCreditAssessmentHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getCreditAssessmentHistory>>, TError = Error>(params?: GetCreditAssessmentHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessmentHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditAssessmentHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditAssessmentHistory>>> = ({ signal }) => getCreditAssessmentHistory(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessmentHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreditAssessmentHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditAssessmentHistory>>>
export type GetCreditAssessmentHistoryQueryError = Error


export function useGetCreditAssessmentHistory<TData = Awaited<ReturnType<typeof getCreditAssessmentHistory>>, TError = Error>(
 params: undefined |  GetCreditAssessmentHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessmentHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditAssessmentHistory>>,
          TError,
          Awaited<ReturnType<typeof getCreditAssessmentHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditAssessmentHistory<TData = Awaited<ReturnType<typeof getCreditAssessmentHistory>>, TError = Error>(
 params?: GetCreditAssessmentHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessmentHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditAssessmentHistory>>,
          TError,
          Awaited<ReturnType<typeof getCreditAssessmentHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditAssessmentHistory<TData = Awaited<ReturnType<typeof getCreditAssessmentHistory>>, TError = Error>(
 params?: GetCreditAssessmentHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessmentHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get credit assessment history with pagination
 */

export function useGetCreditAssessmentHistory<TData = Awaited<ReturnType<typeof getCreditAssessmentHistory>>, TError = Error>(
 params?: GetCreditAssessmentHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessmentHistory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreditAssessmentHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves individual bureau report and scoring result by ID number
 * @summary Get credit report for an individual
 */
export const getCreditReport = (
    creditReportRequest: CreditReportRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DirectorResult>(
      {url: `/loan/api/v1/credit-report`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditReportRequest, signal
    },
      );
    }
  


export const getGetCreditReportMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCreditReport>>, TError,{data: CreditReportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getCreditReport>>, TError,{data: CreditReportRequest}, TContext> => {

const mutationKey = ['getCreditReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getCreditReport>>, {data: CreditReportRequest}> = (props) => {
          const {data} = props ?? {};

          return  getCreditReport(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetCreditReportMutationResult = NonNullable<Awaited<ReturnType<typeof getCreditReport>>>
    export type GetCreditReportMutationBody = CreditReportRequest
    export type GetCreditReportMutationError = Error

    /**
 * @summary Get credit report for an individual
 */
export const useGetCreditReport = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCreditReport>>, TError,{data: CreditReportRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getCreditReport>>,
        TError,
        {data: CreditReportRequest},
        TContext
      > => {

      const mutationOptions = getGetCreditReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves the XDS report PDF from CDS using enquiry identifiers
 * @summary Download XDS report PDF
 */
export const downloadCreditReport = (
    params: DownloadCreditReportParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Blob>(
      {url: `/loan/api/v1/credit-report/download`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      );
    }
  



export const getDownloadCreditReportQueryKey = (params?: DownloadCreditReportParams,) => {
    return [
    `/loan/api/v1/credit-report/download`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDownloadCreditReportQueryOptions = <TData = Awaited<ReturnType<typeof downloadCreditReport>>, TError = Error>(params: DownloadCreditReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadCreditReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadCreditReportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadCreditReport>>> = ({ signal }) => downloadCreditReport(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadCreditReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadCreditReportQueryResult = NonNullable<Awaited<ReturnType<typeof downloadCreditReport>>>
export type DownloadCreditReportQueryError = Error


export function useDownloadCreditReport<TData = Awaited<ReturnType<typeof downloadCreditReport>>, TError = Error>(
 params: DownloadCreditReportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadCreditReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadCreditReport>>,
          TError,
          Awaited<ReturnType<typeof downloadCreditReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadCreditReport<TData = Awaited<ReturnType<typeof downloadCreditReport>>, TError = Error>(
 params: DownloadCreditReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadCreditReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadCreditReport>>,
          TError,
          Awaited<ReturnType<typeof downloadCreditReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadCreditReport<TData = Awaited<ReturnType<typeof downloadCreditReport>>, TError = Error>(
 params: DownloadCreditReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadCreditReport>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download XDS report PDF
 */

export function useDownloadCreditReport<TData = Awaited<ReturnType<typeof downloadCreditReport>>, TError = Error>(
 params: DownloadCreditReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadCreditReport>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadCreditReportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieve all director-level report and scoring result pairs with pagination support
 * @summary Get credit report history with pagination
 */
export const getCreditReportHistory = (
    params?: GetCreditReportHistoryParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DirectorResultPage>(
      {url: `/loan/api/v1/credit-report-history`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetCreditReportHistoryQueryKey = (params?: GetCreditReportHistoryParams,) => {
    return [
    `/loan/api/v1/credit-report-history`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCreditReportHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getCreditReportHistory>>, TError = Error>(params?: GetCreditReportHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditReportHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditReportHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditReportHistory>>> = ({ signal }) => getCreditReportHistory(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditReportHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreditReportHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditReportHistory>>>
export type GetCreditReportHistoryQueryError = Error


export function useGetCreditReportHistory<TData = Awaited<ReturnType<typeof getCreditReportHistory>>, TError = Error>(
 params: undefined |  GetCreditReportHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditReportHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditReportHistory>>,
          TError,
          Awaited<ReturnType<typeof getCreditReportHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditReportHistory<TData = Awaited<ReturnType<typeof getCreditReportHistory>>, TError = Error>(
 params?: GetCreditReportHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditReportHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditReportHistory>>,
          TError,
          Awaited<ReturnType<typeof getCreditReportHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditReportHistory<TData = Awaited<ReturnType<typeof getCreditReportHistory>>, TError = Error>(
 params?: GetCreditReportHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditReportHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get credit report history with pagination
 */

export function useGetCreditReportHistory<TData = Awaited<ReturnType<typeof getCreditReportHistory>>, TError = Error>(
 params?: GetCreditReportHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditReportHistory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreditReportHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieve loan agreement history records with pagination support
 * @summary Get loan agreement history with pagination
 */
export const getLoanAgreementHistory = (
    params?: GetLoanAgreementHistoryParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanAgreementHistoryPage>(
      {url: `/loan/api/v1/loan-agreement-history`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLoanAgreementHistoryQueryKey = (params?: GetLoanAgreementHistoryParams,) => {
    return [
    `/loan/api/v1/loan-agreement-history`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLoanAgreementHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getLoanAgreementHistory>>, TError = Error>(params?: GetLoanAgreementHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanAgreementHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanAgreementHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanAgreementHistory>>> = ({ signal }) => getLoanAgreementHistory(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanAgreementHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoanAgreementHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanAgreementHistory>>>
export type GetLoanAgreementHistoryQueryError = Error


export function useGetLoanAgreementHistory<TData = Awaited<ReturnType<typeof getLoanAgreementHistory>>, TError = Error>(
 params: undefined |  GetLoanAgreementHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanAgreementHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanAgreementHistory>>,
          TError,
          Awaited<ReturnType<typeof getLoanAgreementHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanAgreementHistory<TData = Awaited<ReturnType<typeof getLoanAgreementHistory>>, TError = Error>(
 params?: GetLoanAgreementHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanAgreementHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanAgreementHistory>>,
          TError,
          Awaited<ReturnType<typeof getLoanAgreementHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanAgreementHistory<TData = Awaited<ReturnType<typeof getLoanAgreementHistory>>, TError = Error>(
 params?: GetLoanAgreementHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanAgreementHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get loan agreement history with pagination
 */

export function useGetLoanAgreementHistory<TData = Awaited<ReturnType<typeof getLoanAgreementHistory>>, TError = Error>(
 params?: GetLoanAgreementHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanAgreementHistory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoanAgreementHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieve loan disbursement history records with pagination support
 * @summary Get loan disbursement history with pagination
 */
export const getLoanDisbursementHistory = (
    params?: GetLoanDisbursementHistoryParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanDisbursementHistoryPage>(
      {url: `/loan/api/v1/loan-disbursement-history`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLoanDisbursementHistoryQueryKey = (params?: GetLoanDisbursementHistoryParams,) => {
    return [
    `/loan/api/v1/loan-disbursement-history`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLoanDisbursementHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getLoanDisbursementHistory>>, TError = Error>(params?: GetLoanDisbursementHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanDisbursementHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanDisbursementHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanDisbursementHistory>>> = ({ signal }) => getLoanDisbursementHistory(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanDisbursementHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoanDisbursementHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanDisbursementHistory>>>
export type GetLoanDisbursementHistoryQueryError = Error


export function useGetLoanDisbursementHistory<TData = Awaited<ReturnType<typeof getLoanDisbursementHistory>>, TError = Error>(
 params: undefined |  GetLoanDisbursementHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanDisbursementHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanDisbursementHistory>>,
          TError,
          Awaited<ReturnType<typeof getLoanDisbursementHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanDisbursementHistory<TData = Awaited<ReturnType<typeof getLoanDisbursementHistory>>, TError = Error>(
 params?: GetLoanDisbursementHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanDisbursementHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanDisbursementHistory>>,
          TError,
          Awaited<ReturnType<typeof getLoanDisbursementHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanDisbursementHistory<TData = Awaited<ReturnType<typeof getLoanDisbursementHistory>>, TError = Error>(
 params?: GetLoanDisbursementHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanDisbursementHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get loan disbursement history with pagination
 */

export function useGetLoanDisbursementHistory<TData = Awaited<ReturnType<typeof getLoanDisbursementHistory>>, TError = Error>(
 params?: GetLoanDisbursementHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanDisbursementHistory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoanDisbursementHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Upload a document and associate it with a loan application
 * @summary Upload a document for a loan application
 */
export const uploadDocument = (
    loanApplicationId: string,
    uploadDocumentBody: UploadDocumentBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, uploadDocumentBody.file)
formData.append(`documentType`, uploadDocumentBody.documentType)
if(uploadDocumentBody.description !== undefined) {
 formData.append(`description`, uploadDocumentBody.description)
 }
if(uploadDocumentBody.directorId !== undefined) {
 formData.append(`directorId`, uploadDocumentBody.directorId)
 }
if(uploadDocumentBody.directorName !== undefined) {
 formData.append(`directorName`, uploadDocumentBody.directorName)
 }
if(uploadDocumentBody.period !== undefined) {
 formData.append(`period`, uploadDocumentBody.period)
 }
if(uploadDocumentBody.documentDate !== undefined) {
 formData.append(`documentDate`, uploadDocumentBody.documentDate)
 }
if(uploadDocumentBody.expiryDate !== undefined) {
 formData.append(`expiryDate`, uploadDocumentBody.expiryDate)
 }

      return customAxiosInstanceMutator<DocumentReference>(
      {url: `/loan/api/v1/documents/upload/${loanApplicationId}`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadDocumentMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,{loanApplicationId: string;data: UploadDocumentBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,{loanApplicationId: string;data: UploadDocumentBody}, TContext> => {

const mutationKey = ['uploadDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadDocument>>, {loanApplicationId: string;data: UploadDocumentBody}> = (props) => {
          const {loanApplicationId,data} = props ?? {};

          return  uploadDocument(loanApplicationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadDocument>>>
    export type UploadDocumentMutationBody = UploadDocumentBody
    export type UploadDocumentMutationError = Error

    /**
 * @summary Upload a document for a loan application
 */
export const useUploadDocument = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,{loanApplicationId: string;data: UploadDocumentBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadDocument>>,
        TError,
        {loanApplicationId: string;data: UploadDocumentBody},
        TContext
      > => {

      const mutationOptions = getUploadDocumentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves all documents associated with a specific loan application
 * @summary Get all documents for a loan application
 */
export const getDocumentsByLoanApplication = (
    loanApplicationId: string,
    params?: GetDocumentsByLoanApplicationParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DocumentReference[]>(
      {url: `/loan/api/v1/documents/${loanApplicationId}`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetDocumentsByLoanApplicationQueryKey = (loanApplicationId?: string,
    params?: GetDocumentsByLoanApplicationParams,) => {
    return [
    `/loan/api/v1/documents/${loanApplicationId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDocumentsByLoanApplicationQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentsByLoanApplication>>, TError = Error>(loanApplicationId: string,
    params?: GetDocumentsByLoanApplicationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentsByLoanApplication>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentsByLoanApplicationQueryKey(loanApplicationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentsByLoanApplication>>> = ({ signal }) => getDocumentsByLoanApplication(loanApplicationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(loanApplicationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentsByLoanApplication>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentsByLoanApplicationQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentsByLoanApplication>>>
export type GetDocumentsByLoanApplicationQueryError = Error


export function useGetDocumentsByLoanApplication<TData = Awaited<ReturnType<typeof getDocumentsByLoanApplication>>, TError = Error>(
 loanApplicationId: string,
    params: undefined |  GetDocumentsByLoanApplicationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentsByLoanApplication>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentsByLoanApplication>>,
          TError,
          Awaited<ReturnType<typeof getDocumentsByLoanApplication>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentsByLoanApplication<TData = Awaited<ReturnType<typeof getDocumentsByLoanApplication>>, TError = Error>(
 loanApplicationId: string,
    params?: GetDocumentsByLoanApplicationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentsByLoanApplication>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentsByLoanApplication>>,
          TError,
          Awaited<ReturnType<typeof getDocumentsByLoanApplication>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentsByLoanApplication<TData = Awaited<ReturnType<typeof getDocumentsByLoanApplication>>, TError = Error>(
 loanApplicationId: string,
    params?: GetDocumentsByLoanApplicationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentsByLoanApplication>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all documents for a loan application
 */

export function useGetDocumentsByLoanApplication<TData = Awaited<ReturnType<typeof getDocumentsByLoanApplication>>, TError = Error>(
 loanApplicationId: string,
    params?: GetDocumentsByLoanApplicationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentsByLoanApplication>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentsByLoanApplicationQueryOptions(loanApplicationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Attaches a document the customer has already supplied to this application, so a client is not asked twice for the same paper. The stored file is copied inside the document service rather than re-uploaded, and the copy is independent of the original.
 * @summary Reuse an existing document on a loan application
 */
export const reuseDocument = (
    loanApplicationId: string,
    documentId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DocumentReference>(
      {url: `/loan/api/v1/documents/reuse/${loanApplicationId}/${documentId}`, method: 'POST', signal
    },
      );
    }
  


export const getReuseDocumentMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reuseDocument>>, TError,{loanApplicationId: string;documentId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reuseDocument>>, TError,{loanApplicationId: string;documentId: string}, TContext> => {

const mutationKey = ['reuseDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reuseDocument>>, {loanApplicationId: string;documentId: string}> = (props) => {
          const {loanApplicationId,documentId} = props ?? {};

          return  reuseDocument(loanApplicationId,documentId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReuseDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof reuseDocument>>>
    
    export type ReuseDocumentMutationError = void

    /**
 * @summary Reuse an existing document on a loan application
 */
export const useReuseDocument = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reuseDocument>>, TError,{loanApplicationId: string;documentId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reuseDocument>>,
        TError,
        {loanApplicationId: string;documentId: string},
        TContext
      > => {

      const mutationOptions = getReuseDocumentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves all documents associated with a specific customer
 * @summary Get all documents for a customer
 */
export const getDocumentsByCustomer = (
    customerId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DocumentReference[]>(
      {url: `/loan/api/v1/documents/customer/${customerId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetDocumentsByCustomerQueryKey = (customerId?: string,) => {
    return [
    `/loan/api/v1/documents/customer/${customerId}`
    ] as const;
    }

    
export const getGetDocumentsByCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentsByCustomer>>, TError = Error>(customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentsByCustomer>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentsByCustomerQueryKey(customerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentsByCustomer>>> = ({ signal }) => getDocumentsByCustomer(customerId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentsByCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentsByCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentsByCustomer>>>
export type GetDocumentsByCustomerQueryError = Error


export function useGetDocumentsByCustomer<TData = Awaited<ReturnType<typeof getDocumentsByCustomer>>, TError = Error>(
 customerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentsByCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentsByCustomer>>,
          TError,
          Awaited<ReturnType<typeof getDocumentsByCustomer>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentsByCustomer<TData = Awaited<ReturnType<typeof getDocumentsByCustomer>>, TError = Error>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentsByCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentsByCustomer>>,
          TError,
          Awaited<ReturnType<typeof getDocumentsByCustomer>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentsByCustomer<TData = Awaited<ReturnType<typeof getDocumentsByCustomer>>, TError = Error>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentsByCustomer>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all documents for a customer
 */

export function useGetDocumentsByCustomer<TData = Awaited<ReturnType<typeof getDocumentsByCustomer>>, TError = Error>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentsByCustomer>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentsByCustomerQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves all documents with pagination support
 * @summary Get all documents
 */
export const getAllDocuments = (
    params?: GetAllDocumentsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<GetAllDocuments200>(
      {url: `/loan/api/v1/documents`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAllDocumentsQueryKey = (params?: GetAllDocumentsParams,) => {
    return [
    `/loan/api/v1/documents`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getAllDocuments>>, TError = unknown>(params?: GetAllDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocuments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllDocumentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllDocuments>>> = ({ signal }) => getAllDocuments(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllDocuments>>>
export type GetAllDocumentsQueryError = unknown


export function useGetAllDocuments<TData = Awaited<ReturnType<typeof getAllDocuments>>, TError = unknown>(
 params: undefined |  GetAllDocumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllDocuments>>,
          TError,
          Awaited<ReturnType<typeof getAllDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllDocuments<TData = Awaited<ReturnType<typeof getAllDocuments>>, TError = unknown>(
 params?: GetAllDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllDocuments>>,
          TError,
          Awaited<ReturnType<typeof getAllDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllDocuments<TData = Awaited<ReturnType<typeof getAllDocuments>>, TError = unknown>(
 params?: GetAllDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all documents
 */

export function useGetAllDocuments<TData = Awaited<ReturnType<typeof getAllDocuments>>, TError = unknown>(
 params?: GetAllDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllDocumentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Download a document by its ID
 * @summary Download a document
 */
export const downloadDocument = (
    documentId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Blob>(
      {url: `/loan/api/v1/documents/${documentId}/download`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }
  



export const getDownloadDocumentQueryKey = (documentId?: string,) => {
    return [
    `/loan/api/v1/documents/${documentId}/download`
    ] as const;
    }

    
export const getDownloadDocumentQueryOptions = <TData = Awaited<ReturnType<typeof downloadDocument>>, TError = Error>(documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadDocumentQueryKey(documentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadDocument>>> = ({ signal }) => downloadDocument(documentId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(documentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof downloadDocument>>>
export type DownloadDocumentQueryError = Error


export function useDownloadDocument<TData = Awaited<ReturnType<typeof downloadDocument>>, TError = Error>(
 documentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDocument>>,
          TError,
          Awaited<ReturnType<typeof downloadDocument>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadDocument<TData = Awaited<ReturnType<typeof downloadDocument>>, TError = Error>(
 documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDocument>>,
          TError,
          Awaited<ReturnType<typeof downloadDocument>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadDocument<TData = Awaited<ReturnType<typeof downloadDocument>>, TError = Error>(
 documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download a document
 */

export function useDownloadDocument<TData = Awaited<ReturnType<typeof downloadDocument>>, TError = Error>(
 documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadDocumentQueryOptions(documentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Mark a document as deleted
 * @summary Delete a document
 */
export const deleteDocument = (
    documentId: string,
 ) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/loan/api/v1/documents/${documentId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteDocumentMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocument>>, TError,{documentId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDocument>>, TError,{documentId: string}, TContext> => {

const mutationKey = ['deleteDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDocument>>, {documentId: string}> = (props) => {
          const {documentId} = props ?? {};

          return  deleteDocument(documentId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDocument>>>
    
    export type DeleteDocumentMutationError = Error

    /**
 * @summary Delete a document
 */
export const useDeleteDocument = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocument>>, TError,{documentId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDocument>>,
        TError,
        {documentId: string},
        TContext
      > => {

      const mutationOptions = getDeleteDocumentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Submit uploaded loan application documents
 * @summary Submit multiple documents for a loan application
 */
export const submitLoanDocuments = (
    loanApplicationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanApplication>(
      {url: `/loan/api/v1/documents/submit/${loanApplicationId}`, method: 'POST', signal
    },
      );
    }
  


export const getSubmitLoanDocumentsMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitLoanDocuments>>, TError,{loanApplicationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitLoanDocuments>>, TError,{loanApplicationId: string}, TContext> => {

const mutationKey = ['submitLoanDocuments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitLoanDocuments>>, {loanApplicationId: string}> = (props) => {
          const {loanApplicationId} = props ?? {};

          return  submitLoanDocuments(loanApplicationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitLoanDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof submitLoanDocuments>>>
    
    export type SubmitLoanDocumentsMutationError = Error

    /**
 * @summary Submit multiple documents for a loan application
 */
export const useSubmitLoanDocuments = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitLoanDocuments>>, TError,{loanApplicationId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitLoanDocuments>>,
        TError,
        {loanApplicationId: string},
        TContext
      > => {

      const mutationOptions = getSubmitLoanDocumentsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves statistics about active loans, due loans, open leads, and tasks for the dashboard for a specified month
 * @summary Get loan dashboard statistics
 */
export const getDashboardStats = (
    params: GetDashboardStatsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanStatistics>(
      {url: `/loan/api/v1/dashboard/stats`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetDashboardStatsQueryKey = (params?: GetDashboardStatsParams,) => {
    return [
    `/loan/api/v1/dashboard/stats`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDashboardStatsQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardStats>>, TError = void>(params: GetDashboardStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardStatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardStats>>> = ({ signal }) => getDashboardStats(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDashboardStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardStats>>>
export type GetDashboardStatsQueryError = void


export function useGetDashboardStats<TData = Awaited<ReturnType<typeof getDashboardStats>>, TError = void>(
 params: GetDashboardStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardStats>>,
          TError,
          Awaited<ReturnType<typeof getDashboardStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardStats<TData = Awaited<ReturnType<typeof getDashboardStats>>, TError = void>(
 params: GetDashboardStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardStats>>,
          TError,
          Awaited<ReturnType<typeof getDashboardStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardStats<TData = Awaited<ReturnType<typeof getDashboardStats>>, TError = void>(
 params: GetDashboardStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get loan dashboard statistics
 */

export function useGetDashboardStats<TData = Awaited<ReturnType<typeof getDashboardStats>>, TError = void>(
 params: GetDashboardStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDashboardStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves detailed information about loans due in the current week
 * @summary Get loans due this week
 */
export const getDueLoans = (
    params?: GetDueLoansParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DueLoansPage>(
      {url: `/loan/api/v1/dashboard/due-loans`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetDueLoansQueryKey = (params?: GetDueLoansParams,) => {
    return [
    `/loan/api/v1/dashboard/due-loans`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDueLoansQueryOptions = <TData = Awaited<ReturnType<typeof getDueLoans>>, TError = void>(params?: GetDueLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueLoans>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDueLoansQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDueLoans>>> = ({ signal }) => getDueLoans(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDueLoans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDueLoansQueryResult = NonNullable<Awaited<ReturnType<typeof getDueLoans>>>
export type GetDueLoansQueryError = void


export function useGetDueLoans<TData = Awaited<ReturnType<typeof getDueLoans>>, TError = void>(
 params: undefined |  GetDueLoansParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueLoans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDueLoans>>,
          TError,
          Awaited<ReturnType<typeof getDueLoans>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDueLoans<TData = Awaited<ReturnType<typeof getDueLoans>>, TError = void>(
 params?: GetDueLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueLoans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDueLoans>>,
          TError,
          Awaited<ReturnType<typeof getDueLoans>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDueLoans<TData = Awaited<ReturnType<typeof getDueLoans>>, TError = void>(
 params?: GetDueLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueLoans>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get loans due this week
 */

export function useGetDueLoans<TData = Awaited<ReturnType<typeof getDueLoans>>, TError = void>(
 params?: GetDueLoansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueLoans>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDueLoansQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves all loan applications with document status for dashboard display
 * @summary Get loan application documents history
 */
export const getDocumentHistory = (
    params?: GetDocumentHistoryParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DocumentHistoryPage>(
      {url: `/loan/api/v1/document-history`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetDocumentHistoryQueryKey = (params?: GetDocumentHistoryParams,) => {
    return [
    `/loan/api/v1/document-history`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDocumentHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentHistory>>, TError = void>(params?: GetDocumentHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentHistory>>> = ({ signal }) => getDocumentHistory(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentHistory>>>
export type GetDocumentHistoryQueryError = void


export function useGetDocumentHistory<TData = Awaited<ReturnType<typeof getDocumentHistory>>, TError = void>(
 params: undefined |  GetDocumentHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentHistory>>,
          TError,
          Awaited<ReturnType<typeof getDocumentHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentHistory<TData = Awaited<ReturnType<typeof getDocumentHistory>>, TError = void>(
 params?: GetDocumentHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentHistory>>,
          TError,
          Awaited<ReturnType<typeof getDocumentHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentHistory<TData = Awaited<ReturnType<typeof getDocumentHistory>>, TError = void>(
 params?: GetDocumentHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get loan application documents history
 */

export function useGetDocumentHistory<TData = Awaited<ReturnType<typeof getDocumentHistory>>, TError = void>(
 params?: GetDocumentHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentHistory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves payment tracking records for a specific month with pagination and filtering
 * @summary Get payment tracking records for loan book
 */
export const getPaymentTracking = (
    params: GetPaymentTrackingParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<PaymentTrackingPage>(
      {url: `/loan/api/v1/collections/payment-tracking`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetPaymentTrackingQueryKey = (params?: GetPaymentTrackingParams,) => {
    return [
    `/loan/api/v1/collections/payment-tracking`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPaymentTrackingQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentTracking>>, TError = Error | void>(params: GetPaymentTrackingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTracking>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentTrackingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentTracking>>> = ({ signal }) => getPaymentTracking(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentTracking>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentTrackingQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentTracking>>>
export type GetPaymentTrackingQueryError = Error | void


export function useGetPaymentTracking<TData = Awaited<ReturnType<typeof getPaymentTracking>>, TError = Error | void>(
 params: GetPaymentTrackingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTracking>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentTracking>>,
          TError,
          Awaited<ReturnType<typeof getPaymentTracking>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentTracking<TData = Awaited<ReturnType<typeof getPaymentTracking>>, TError = Error | void>(
 params: GetPaymentTrackingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTracking>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentTracking>>,
          TError,
          Awaited<ReturnType<typeof getPaymentTracking>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentTracking<TData = Awaited<ReturnType<typeof getPaymentTracking>>, TError = Error | void>(
 params: GetPaymentTrackingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTracking>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payment tracking records for loan book
 */

export function useGetPaymentTracking<TData = Awaited<ReturnType<typeof getPaymentTracking>>, TError = Error | void>(
 params: GetPaymentTrackingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTracking>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentTrackingQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves payment tracking statistics for a specific month
 * @summary Get payment tracking statistics
 */
export const getPaymentTrackingStats = (
    params: GetPaymentTrackingStatsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<PaymentTrackingStats>(
      {url: `/loan/api/v1/collections/payment-tracking/stats`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetPaymentTrackingStatsQueryKey = (params?: GetPaymentTrackingStatsParams,) => {
    return [
    `/loan/api/v1/collections/payment-tracking/stats`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPaymentTrackingStatsQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentTrackingStats>>, TError = Error | void>(params: GetPaymentTrackingStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTrackingStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentTrackingStatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentTrackingStats>>> = ({ signal }) => getPaymentTrackingStats(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentTrackingStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentTrackingStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentTrackingStats>>>
export type GetPaymentTrackingStatsQueryError = Error | void


export function useGetPaymentTrackingStats<TData = Awaited<ReturnType<typeof getPaymentTrackingStats>>, TError = Error | void>(
 params: GetPaymentTrackingStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTrackingStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentTrackingStats>>,
          TError,
          Awaited<ReturnType<typeof getPaymentTrackingStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentTrackingStats<TData = Awaited<ReturnType<typeof getPaymentTrackingStats>>, TError = Error | void>(
 params: GetPaymentTrackingStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTrackingStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentTrackingStats>>,
          TError,
          Awaited<ReturnType<typeof getPaymentTrackingStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentTrackingStats<TData = Awaited<ReturnType<typeof getPaymentTrackingStats>>, TError = Error | void>(
 params: GetPaymentTrackingStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTrackingStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payment tracking statistics
 */

export function useGetPaymentTrackingStats<TData = Awaited<ReturnType<typeof getPaymentTrackingStats>>, TError = Error | void>(
 params: GetPaymentTrackingStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTrackingStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentTrackingStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves the Loan Book Collection Sheet data - includes both paginated payment tracking records 
and summary statistics. This matches the spreadsheet format with records 
and totals at the bottom.

Optional date filters (fromDate and toDate) allow filtering records by any date range.

 * @summary Get payment tracking collection sheet
 */
export const getPaymentTrackingCollectionSheet = (
    params?: GetPaymentTrackingCollectionSheetParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<PaymentTrackingCollectionSheet>(
      {url: `/loan/api/v1/collections/payment-tracking/collection-sheet`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetPaymentTrackingCollectionSheetQueryKey = (params?: GetPaymentTrackingCollectionSheetParams,) => {
    return [
    `/loan/api/v1/collections/payment-tracking/collection-sheet`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPaymentTrackingCollectionSheetQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>, TError = Error | void>(params?: GetPaymentTrackingCollectionSheetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentTrackingCollectionSheetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>> = ({ signal }) => getPaymentTrackingCollectionSheet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentTrackingCollectionSheetQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>>
export type GetPaymentTrackingCollectionSheetQueryError = Error | void


export function useGetPaymentTrackingCollectionSheet<TData = Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>, TError = Error | void>(
 params: undefined |  GetPaymentTrackingCollectionSheetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>,
          TError,
          Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentTrackingCollectionSheet<TData = Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>, TError = Error | void>(
 params?: GetPaymentTrackingCollectionSheetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>,
          TError,
          Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentTrackingCollectionSheet<TData = Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>, TError = Error | void>(
 params?: GetPaymentTrackingCollectionSheetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payment tracking collection sheet
 */

export function useGetPaymentTrackingCollectionSheet<TData = Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>, TError = Error | void>(
 params?: GetPaymentTrackingCollectionSheetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTrackingCollectionSheet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentTrackingCollectionSheetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves all collections that are due soon or overdue
 * @summary Get due collections
 */
export const getDueCollections = (
    params?: GetDueCollectionsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DueCollectionPage>(
      {url: `/loan/api/v1/collections/due`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetDueCollectionsQueryKey = (params?: GetDueCollectionsParams,) => {
    return [
    `/loan/api/v1/collections/due`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDueCollectionsQueryOptions = <TData = Awaited<ReturnType<typeof getDueCollections>>, TError = Error | void>(params?: GetDueCollectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollections>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDueCollectionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDueCollections>>> = ({ signal }) => getDueCollections(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDueCollections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDueCollectionsQueryResult = NonNullable<Awaited<ReturnType<typeof getDueCollections>>>
export type GetDueCollectionsQueryError = Error | void


export function useGetDueCollections<TData = Awaited<ReturnType<typeof getDueCollections>>, TError = Error | void>(
 params: undefined |  GetDueCollectionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDueCollections>>,
          TError,
          Awaited<ReturnType<typeof getDueCollections>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDueCollections<TData = Awaited<ReturnType<typeof getDueCollections>>, TError = Error | void>(
 params?: GetDueCollectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDueCollections>>,
          TError,
          Awaited<ReturnType<typeof getDueCollections>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDueCollections<TData = Awaited<ReturnType<typeof getDueCollections>>, TError = Error | void>(
 params?: GetDueCollectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollections>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get due collections
 */

export function useGetDueCollections<TData = Awaited<ReturnType<typeof getDueCollections>>, TError = Error | void>(
 params?: GetDueCollectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollections>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDueCollectionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves statistics about due collections
 * @summary Get due collection statistics
 */
export const getDueCollectionStats = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DueCollectionStats>(
      {url: `/loan/api/v1/collections/stats`, method: 'GET', signal
    },
      );
    }
  



export const getGetDueCollectionStatsQueryKey = () => {
    return [
    `/loan/api/v1/collections/stats`
    ] as const;
    }

    
export const getGetDueCollectionStatsQueryOptions = <TData = Awaited<ReturnType<typeof getDueCollectionStats>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDueCollectionStatsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDueCollectionStats>>> = ({ signal }) => getDueCollectionStats(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDueCollectionStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getDueCollectionStats>>>
export type GetDueCollectionStatsQueryError = void


export function useGetDueCollectionStats<TData = Awaited<ReturnType<typeof getDueCollectionStats>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDueCollectionStats>>,
          TError,
          Awaited<ReturnType<typeof getDueCollectionStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDueCollectionStats<TData = Awaited<ReturnType<typeof getDueCollectionStats>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDueCollectionStats>>,
          TError,
          Awaited<ReturnType<typeof getDueCollectionStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDueCollectionStats<TData = Awaited<ReturnType<typeof getDueCollectionStats>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get due collection statistics
 */

export function useGetDueCollectionStats<TData = Awaited<ReturnType<typeof getDueCollectionStats>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDueCollectionStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves details of a specific due collection
 * @summary Get due collection by Account
 */
export const getDueCollectionById = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DueCollection>(
      {url: `/loan/api/v1/collections/due/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetDueCollectionByIdQueryKey = (id?: string,) => {
    return [
    `/loan/api/v1/collections/due/${id}`
    ] as const;
    }

    
export const getGetDueCollectionByIdQueryOptions = <TData = Awaited<ReturnType<typeof getDueCollectionById>>, TError = void | Error>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDueCollectionByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDueCollectionById>>> = ({ signal }) => getDueCollectionById(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDueCollectionByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDueCollectionById>>>
export type GetDueCollectionByIdQueryError = void | Error


export function useGetDueCollectionById<TData = Awaited<ReturnType<typeof getDueCollectionById>>, TError = void | Error>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDueCollectionById>>,
          TError,
          Awaited<ReturnType<typeof getDueCollectionById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDueCollectionById<TData = Awaited<ReturnType<typeof getDueCollectionById>>, TError = void | Error>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDueCollectionById>>,
          TError,
          Awaited<ReturnType<typeof getDueCollectionById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDueCollectionById<TData = Awaited<ReturnType<typeof getDueCollectionById>>, TError = void | Error>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get due collection by Account
 */

export function useGetDueCollectionById<TData = Awaited<ReturnType<typeof getDueCollectionById>>, TError = void | Error>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionById>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDueCollectionByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves due collections within a specified date range
 * @summary Get due collections by date range
 */
export const getDueCollectionsByDateRange = (
    params: GetDueCollectionsByDateRangeParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DueCollectionPage>(
      {url: `/loan/api/v1/collections/by-date-range`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetDueCollectionsByDateRangeQueryKey = (params?: GetDueCollectionsByDateRangeParams,) => {
    return [
    `/loan/api/v1/collections/by-date-range`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDueCollectionsByDateRangeQueryOptions = <TData = Awaited<ReturnType<typeof getDueCollectionsByDateRange>>, TError = Error | void>(params: GetDueCollectionsByDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionsByDateRange>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDueCollectionsByDateRangeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDueCollectionsByDateRange>>> = ({ signal }) => getDueCollectionsByDateRange(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionsByDateRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDueCollectionsByDateRangeQueryResult = NonNullable<Awaited<ReturnType<typeof getDueCollectionsByDateRange>>>
export type GetDueCollectionsByDateRangeQueryError = Error | void


export function useGetDueCollectionsByDateRange<TData = Awaited<ReturnType<typeof getDueCollectionsByDateRange>>, TError = Error | void>(
 params: GetDueCollectionsByDateRangeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionsByDateRange>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDueCollectionsByDateRange>>,
          TError,
          Awaited<ReturnType<typeof getDueCollectionsByDateRange>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDueCollectionsByDateRange<TData = Awaited<ReturnType<typeof getDueCollectionsByDateRange>>, TError = Error | void>(
 params: GetDueCollectionsByDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionsByDateRange>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDueCollectionsByDateRange>>,
          TError,
          Awaited<ReturnType<typeof getDueCollectionsByDateRange>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDueCollectionsByDateRange<TData = Awaited<ReturnType<typeof getDueCollectionsByDateRange>>, TError = Error | void>(
 params: GetDueCollectionsByDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionsByDateRange>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get due collections by date range
 */

export function useGetDueCollectionsByDateRange<TData = Awaited<ReturnType<typeof getDueCollectionsByDateRange>>, TError = Error | void>(
 params: GetDueCollectionsByDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDueCollectionsByDateRange>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDueCollectionsByDateRangeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Sends a payment reminder to a customer via SMS or email
 * @summary Send payment reminder
 */
export const sendPaymentReminder = (
    reminderRequest: ReminderRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<ReminderResult>(
      {url: `/loan/api/v1/collections/send-reminder`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reminderRequest, signal
    },
      );
    }
  


export const getSendPaymentReminderMutationOptions = <TError = Error | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPaymentReminder>>, TError,{data: ReminderRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendPaymentReminder>>, TError,{data: ReminderRequest}, TContext> => {

const mutationKey = ['sendPaymentReminder'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendPaymentReminder>>, {data: ReminderRequest}> = (props) => {
          const {data} = props ?? {};

          return  sendPaymentReminder(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendPaymentReminderMutationResult = NonNullable<Awaited<ReturnType<typeof sendPaymentReminder>>>
    export type SendPaymentReminderMutationBody = ReminderRequest
    export type SendPaymentReminderMutationError = Error | void

    /**
 * @summary Send payment reminder
 */
export const useSendPaymentReminder = <TError = Error | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPaymentReminder>>, TError,{data: ReminderRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendPaymentReminder>>,
        TError,
        {data: ReminderRequest},
        TContext
      > => {

      const mutationOptions = getSendPaymentReminderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves all collections that are overdue
 * @summary Get overdue collections
 */
export const getOverdueCollections = (
    params?: GetOverdueCollectionsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<OverdueCollectionPage>(
      {url: `/loan/api/v1/collections/overdue`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetOverdueCollectionsQueryKey = (params?: GetOverdueCollectionsParams,) => {
    return [
    `/loan/api/v1/collections/overdue`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetOverdueCollectionsQueryOptions = <TData = Awaited<ReturnType<typeof getOverdueCollections>>, TError = Error | void>(params?: GetOverdueCollectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollections>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOverdueCollectionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverdueCollections>>> = ({ signal }) => getOverdueCollections(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOverdueCollectionsQueryResult = NonNullable<Awaited<ReturnType<typeof getOverdueCollections>>>
export type GetOverdueCollectionsQueryError = Error | void


export function useGetOverdueCollections<TData = Awaited<ReturnType<typeof getOverdueCollections>>, TError = Error | void>(
 params: undefined |  GetOverdueCollectionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverdueCollections>>,
          TError,
          Awaited<ReturnType<typeof getOverdueCollections>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverdueCollections<TData = Awaited<ReturnType<typeof getOverdueCollections>>, TError = Error | void>(
 params?: GetOverdueCollectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverdueCollections>>,
          TError,
          Awaited<ReturnType<typeof getOverdueCollections>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverdueCollections<TData = Awaited<ReturnType<typeof getOverdueCollections>>, TError = Error | void>(
 params?: GetOverdueCollectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollections>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get overdue collections
 */

export function useGetOverdueCollections<TData = Awaited<ReturnType<typeof getOverdueCollections>>, TError = Error | void>(
 params?: GetOverdueCollectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollections>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOverdueCollectionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves statistics about overdue collections
 * @summary Get overdue collection statistics
 */
export const getOverdueCollectionStats = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<OverdueCollectionStats>(
      {url: `/loan/api/v1/collections/overdue/stats`, method: 'GET', signal
    },
      );
    }
  



export const getGetOverdueCollectionStatsQueryKey = () => {
    return [
    `/loan/api/v1/collections/overdue/stats`
    ] as const;
    }

    
export const getGetOverdueCollectionStatsQueryOptions = <TData = Awaited<ReturnType<typeof getOverdueCollectionStats>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollectionStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOverdueCollectionStatsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverdueCollectionStats>>> = ({ signal }) => getOverdueCollectionStats(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollectionStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOverdueCollectionStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getOverdueCollectionStats>>>
export type GetOverdueCollectionStatsQueryError = void


export function useGetOverdueCollectionStats<TData = Awaited<ReturnType<typeof getOverdueCollectionStats>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollectionStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverdueCollectionStats>>,
          TError,
          Awaited<ReturnType<typeof getOverdueCollectionStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverdueCollectionStats<TData = Awaited<ReturnType<typeof getOverdueCollectionStats>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollectionStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverdueCollectionStats>>,
          TError,
          Awaited<ReturnType<typeof getOverdueCollectionStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverdueCollectionStats<TData = Awaited<ReturnType<typeof getOverdueCollectionStats>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollectionStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get overdue collection statistics
 */

export function useGetOverdueCollectionStats<TData = Awaited<ReturnType<typeof getOverdueCollectionStats>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollectionStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOverdueCollectionStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves details of a specific overdue collection
 * @summary Get overdue collection by ID
 */
export const getOverdueCollectionById = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<OverdueCollection>(
      {url: `/loan/api/v1/collections/overdue/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetOverdueCollectionByIdQueryKey = (id?: string,) => {
    return [
    `/loan/api/v1/collections/overdue/${id}`
    ] as const;
    }

    
export const getGetOverdueCollectionByIdQueryOptions = <TData = Awaited<ReturnType<typeof getOverdueCollectionById>>, TError = void | Error>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollectionById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOverdueCollectionByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverdueCollectionById>>> = ({ signal }) => getOverdueCollectionById(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollectionById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOverdueCollectionByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getOverdueCollectionById>>>
export type GetOverdueCollectionByIdQueryError = void | Error


export function useGetOverdueCollectionById<TData = Awaited<ReturnType<typeof getOverdueCollectionById>>, TError = void | Error>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollectionById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverdueCollectionById>>,
          TError,
          Awaited<ReturnType<typeof getOverdueCollectionById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverdueCollectionById<TData = Awaited<ReturnType<typeof getOverdueCollectionById>>, TError = void | Error>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollectionById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverdueCollectionById>>,
          TError,
          Awaited<ReturnType<typeof getOverdueCollectionById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverdueCollectionById<TData = Awaited<ReturnType<typeof getOverdueCollectionById>>, TError = void | Error>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollectionById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get overdue collection by ID
 */

export function useGetOverdueCollectionById<TData = Awaited<ReturnType<typeof getOverdueCollectionById>>, TError = void | Error>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueCollectionById>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOverdueCollectionByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Sends a reminder for an overdue payment via SMS, email, or scheduled call
 * @summary Send reminder for overdue payment
 */
export const sendOverdueReminder = (
    overdueReminderRequest: OverdueReminderRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<OverdueReminderResult>(
      {url: `/loan/api/v1/collections/send-overdue-reminder`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: overdueReminderRequest, signal
    },
      );
    }
  


export const getSendOverdueReminderMutationOptions = <TError = Error | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendOverdueReminder>>, TError,{data: OverdueReminderRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendOverdueReminder>>, TError,{data: OverdueReminderRequest}, TContext> => {

const mutationKey = ['sendOverdueReminder'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendOverdueReminder>>, {data: OverdueReminderRequest}> = (props) => {
          const {data} = props ?? {};

          return  sendOverdueReminder(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendOverdueReminderMutationResult = NonNullable<Awaited<ReturnType<typeof sendOverdueReminder>>>
    export type SendOverdueReminderMutationBody = OverdueReminderRequest
    export type SendOverdueReminderMutationError = Error | void

    /**
 * @summary Send reminder for overdue payment
 */
export const useSendOverdueReminder = <TError = Error | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendOverdueReminder>>, TError,{data: OverdueReminderRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendOverdueReminder>>,
        TError,
        {data: OverdueReminderRequest},
        TContext
      > => {

      const mutationOptions = getSendOverdueReminderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Sends reminders to all overdue customers based on predefined templates by overdue status
 * @summary Send reminders to all overdue customers
 */
export const sendAllReminders = (
    params: SendAllRemindersParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<SendAllReminders200>(
      {url: `/loan/api/v1/collections/send-all-reminders`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getSendAllRemindersMutationOptions = <TError = Error | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAllReminders>>, TError,{params: SendAllRemindersParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendAllReminders>>, TError,{params: SendAllRemindersParams}, TContext> => {

const mutationKey = ['sendAllReminders'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendAllReminders>>, {params: SendAllRemindersParams}> = (props) => {
          const {params} = props ?? {};

          return  sendAllReminders(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendAllRemindersMutationResult = NonNullable<Awaited<ReturnType<typeof sendAllReminders>>>
    
    export type SendAllRemindersMutationError = Error | void

    /**
 * @summary Send reminders to all overdue customers
 */
export const useSendAllReminders = <TError = Error | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAllReminders>>, TError,{params: SendAllRemindersParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendAllReminders>>,
        TError,
        {params: SendAllRemindersParams},
        TContext
      > => {

      const mutationOptions = getSendAllRemindersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves loan book records with support for filtering by status, customer name, and target month
 * @summary Get loan book records with pagination and filtering
 */
export const getLoanBookRecords = (
    params?: GetLoanBookRecordsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanBookPage>(
      {url: `/loan/api/v1/loan-book/records`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLoanBookRecordsQueryKey = (params?: GetLoanBookRecordsParams,) => {
    return [
    `/loan/api/v1/loan-book/records`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLoanBookRecordsQueryOptions = <TData = Awaited<ReturnType<typeof getLoanBookRecords>>, TError = Error | void>(params?: GetLoanBookRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanBookRecords>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanBookRecordsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanBookRecords>>> = ({ signal }) => getLoanBookRecords(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanBookRecords>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoanBookRecordsQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanBookRecords>>>
export type GetLoanBookRecordsQueryError = Error | void


export function useGetLoanBookRecords<TData = Awaited<ReturnType<typeof getLoanBookRecords>>, TError = Error | void>(
 params: undefined |  GetLoanBookRecordsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanBookRecords>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanBookRecords>>,
          TError,
          Awaited<ReturnType<typeof getLoanBookRecords>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanBookRecords<TData = Awaited<ReturnType<typeof getLoanBookRecords>>, TError = Error | void>(
 params?: GetLoanBookRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanBookRecords>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanBookRecords>>,
          TError,
          Awaited<ReturnType<typeof getLoanBookRecords>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanBookRecords<TData = Awaited<ReturnType<typeof getLoanBookRecords>>, TError = Error | void>(
 params?: GetLoanBookRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanBookRecords>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get loan book records with pagination and filtering
 */

export function useGetLoanBookRecords<TData = Awaited<ReturnType<typeof getLoanBookRecords>>, TError = Error | void>(
 params?: GetLoanBookRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanBookRecords>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoanBookRecordsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves comprehensive loan book summary including portfolio statistics, trends, and recent activity
 * @summary Get loan book summary statistics and analytics
 */
export const getLoanBookSummary = (
    params?: GetLoanBookSummaryParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanBookSummary>(
      {url: `/loan/api/v1/loan-book/summary`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLoanBookSummaryQueryKey = (params?: GetLoanBookSummaryParams,) => {
    return [
    `/loan/api/v1/loan-book/summary`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLoanBookSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getLoanBookSummary>>, TError = Error | void>(params?: GetLoanBookSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanBookSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanBookSummaryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanBookSummary>>> = ({ signal }) => getLoanBookSummary(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanBookSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoanBookSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanBookSummary>>>
export type GetLoanBookSummaryQueryError = Error | void


export function useGetLoanBookSummary<TData = Awaited<ReturnType<typeof getLoanBookSummary>>, TError = Error | void>(
 params: undefined |  GetLoanBookSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanBookSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanBookSummary>>,
          TError,
          Awaited<ReturnType<typeof getLoanBookSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanBookSummary<TData = Awaited<ReturnType<typeof getLoanBookSummary>>, TError = Error | void>(
 params?: GetLoanBookSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanBookSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanBookSummary>>,
          TError,
          Awaited<ReturnType<typeof getLoanBookSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanBookSummary<TData = Awaited<ReturnType<typeof getLoanBookSummary>>, TError = Error | void>(
 params?: GetLoanBookSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanBookSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get loan book summary statistics and analytics
 */

export function useGetLoanBookSummary<TData = Awaited<ReturnType<typeof getLoanBookSummary>>, TError = Error | void>(
 params?: GetLoanBookSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanBookSummary>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoanBookSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Updates the disbursed flag for a loan book record by ID
 * @summary Mark a loan book record as disbursed
 */
export const markLoanBookRecordAsDisbursed = (
    id: string,
 ) => {
      
      
      return customAxiosInstanceMutator<LoanBookRecord>(
      {url: `/loan/api/v1/loan-book/records/${id}/mark-disbursed`, method: 'PATCH'
    },
      );
    }
  


export const getMarkLoanBookRecordAsDisbursedMutationOptions = <TError = Error | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markLoanBookRecordAsDisbursed>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markLoanBookRecordAsDisbursed>>, TError,{id: string}, TContext> => {

const mutationKey = ['markLoanBookRecordAsDisbursed'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markLoanBookRecordAsDisbursed>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  markLoanBookRecordAsDisbursed(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkLoanBookRecordAsDisbursedMutationResult = NonNullable<Awaited<ReturnType<typeof markLoanBookRecordAsDisbursed>>>
    
    export type MarkLoanBookRecordAsDisbursedMutationError = Error | void

    /**
 * @summary Mark a loan book record as disbursed
 */
export const useMarkLoanBookRecordAsDisbursed = <TError = Error | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markLoanBookRecordAsDisbursed>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markLoanBookRecordAsDisbursed>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getMarkLoanBookRecordAsDisbursedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Updates the invoicedOnSage flag and optionally stores the Sage invoice number for a loan book record by ID
 * @summary Mark a loan book record as invoiced on Sage
 */
export const markLoanBookRecordAsInvoiced = (
    id: string,
    markInvoicedRequest?: MarkInvoicedRequest,
 ) => {
      
      
      return customAxiosInstanceMutator<LoanBookRecord>(
      {url: `/loan/api/v1/loan-book/records/${id}/mark-invoiced`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: markInvoicedRequest
    },
      );
    }
  


export const getMarkLoanBookRecordAsInvoicedMutationOptions = <TError = Error | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markLoanBookRecordAsInvoiced>>, TError,{id: string;data: MarkInvoicedRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markLoanBookRecordAsInvoiced>>, TError,{id: string;data: MarkInvoicedRequest}, TContext> => {

const mutationKey = ['markLoanBookRecordAsInvoiced'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markLoanBookRecordAsInvoiced>>, {id: string;data: MarkInvoicedRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  markLoanBookRecordAsInvoiced(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkLoanBookRecordAsInvoicedMutationResult = NonNullable<Awaited<ReturnType<typeof markLoanBookRecordAsInvoiced>>>
    export type MarkLoanBookRecordAsInvoicedMutationBody = MarkInvoicedRequest
    export type MarkLoanBookRecordAsInvoicedMutationError = Error | void

    /**
 * @summary Mark a loan book record as invoiced on Sage
 */
export const useMarkLoanBookRecordAsInvoiced = <TError = Error | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markLoanBookRecordAsInvoiced>>, TError,{id: string;data: MarkInvoicedRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markLoanBookRecordAsInvoiced>>,
        TError,
        {id: string;data: MarkInvoicedRequest},
        TContext
      > => {

      const mutationOptions = getMarkLoanBookRecordAsInvoicedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Sends a payment reminder email with upcoming due details
 * @summary Send payment reminder notification (email)
 */
export const sendPaymentReminderNotification = (
    sendPaymentReminderNotificationBody: SendPaymentReminderNotificationBody,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<ReminderResult>(
      {url: `/loan/api/v1/notifications/payment-reminder`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendPaymentReminderNotificationBody, signal
    },
      );
    }
  


export const getSendPaymentReminderNotificationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPaymentReminderNotification>>, TError,{data: SendPaymentReminderNotificationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendPaymentReminderNotification>>, TError,{data: SendPaymentReminderNotificationBody}, TContext> => {

const mutationKey = ['sendPaymentReminderNotification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendPaymentReminderNotification>>, {data: SendPaymentReminderNotificationBody}> = (props) => {
          const {data} = props ?? {};

          return  sendPaymentReminderNotification(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendPaymentReminderNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof sendPaymentReminderNotification>>>
    export type SendPaymentReminderNotificationMutationBody = SendPaymentReminderNotificationBody
    export type SendPaymentReminderNotificationMutationError = void

    /**
 * @summary Send payment reminder notification (email)
 */
export const useSendPaymentReminderNotification = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPaymentReminderNotification>>, TError,{data: SendPaymentReminderNotificationBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendPaymentReminderNotification>>,
        TError,
        {data: SendPaymentReminderNotificationBody},
        TContext
      > => {

      const mutationOptions = getSendPaymentReminderNotificationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Sends an overdue notice email with current arrears details
 * @summary Send account overdue notification (email)
 */
export const sendAccountOverdueNotification = (
    sendAccountOverdueNotificationBody: SendAccountOverdueNotificationBody,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<ReminderResult>(
      {url: `/loan/api/v1/notifications/account-overdue`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendAccountOverdueNotificationBody, signal
    },
      );
    }
  


export const getSendAccountOverdueNotificationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAccountOverdueNotification>>, TError,{data: SendAccountOverdueNotificationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendAccountOverdueNotification>>, TError,{data: SendAccountOverdueNotificationBody}, TContext> => {

const mutationKey = ['sendAccountOverdueNotification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendAccountOverdueNotification>>, {data: SendAccountOverdueNotificationBody}> = (props) => {
          const {data} = props ?? {};

          return  sendAccountOverdueNotification(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendAccountOverdueNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof sendAccountOverdueNotification>>>
    export type SendAccountOverdueNotificationMutationBody = SendAccountOverdueNotificationBody
    export type SendAccountOverdueNotificationMutationError = void

    /**
 * @summary Send account overdue notification (email)
 */
export const useSendAccountOverdueNotification = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAccountOverdueNotification>>, TError,{data: SendAccountOverdueNotificationBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendAccountOverdueNotification>>,
        TError,
        {data: SendAccountOverdueNotificationBody},
        TContext
      > => {

      const mutationOptions = getSendAccountOverdueNotificationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Computes and retrieves all data needed for PDF form fields from the database.
This endpoint allows the frontend to display the data for user review and 
populate additional optional fields before PDF generation.

 * @summary Prepare loan agreement data
 */
export const prepareLoanPreAgreementData = (
    applicationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanPreAgreementData>(
      {url: `/loan/api/v1/agreements/${applicationId}/data`, method: 'GET', signal
    },
      );
    }
  



export const getPrepareLoanPreAgreementDataQueryKey = (applicationId?: string,) => {
    return [
    `/loan/api/v1/agreements/${applicationId}/data`
    ] as const;
    }

    
export const getPrepareLoanPreAgreementDataQueryOptions = <TData = Awaited<ReturnType<typeof prepareLoanPreAgreementData>>, TError = PrepareLoanPreAgreementData400 | PrepareLoanPreAgreementData404 | PrepareLoanPreAgreementData500>(applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prepareLoanPreAgreementData>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPrepareLoanPreAgreementDataQueryKey(applicationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof prepareLoanPreAgreementData>>> = ({ signal }) => prepareLoanPreAgreementData(applicationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(applicationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof prepareLoanPreAgreementData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PrepareLoanPreAgreementDataQueryResult = NonNullable<Awaited<ReturnType<typeof prepareLoanPreAgreementData>>>
export type PrepareLoanPreAgreementDataQueryError = PrepareLoanPreAgreementData400 | PrepareLoanPreAgreementData404 | PrepareLoanPreAgreementData500


export function usePrepareLoanPreAgreementData<TData = Awaited<ReturnType<typeof prepareLoanPreAgreementData>>, TError = PrepareLoanPreAgreementData400 | PrepareLoanPreAgreementData404 | PrepareLoanPreAgreementData500>(
 applicationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof prepareLoanPreAgreementData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof prepareLoanPreAgreementData>>,
          TError,
          Awaited<ReturnType<typeof prepareLoanPreAgreementData>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePrepareLoanPreAgreementData<TData = Awaited<ReturnType<typeof prepareLoanPreAgreementData>>, TError = PrepareLoanPreAgreementData400 | PrepareLoanPreAgreementData404 | PrepareLoanPreAgreementData500>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prepareLoanPreAgreementData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof prepareLoanPreAgreementData>>,
          TError,
          Awaited<ReturnType<typeof prepareLoanPreAgreementData>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePrepareLoanPreAgreementData<TData = Awaited<ReturnType<typeof prepareLoanPreAgreementData>>, TError = PrepareLoanPreAgreementData400 | PrepareLoanPreAgreementData404 | PrepareLoanPreAgreementData500>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prepareLoanPreAgreementData>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Prepare loan agreement data
 */

export function usePrepareLoanPreAgreementData<TData = Awaited<ReturnType<typeof prepareLoanPreAgreementData>>, TError = PrepareLoanPreAgreementData400 | PrepareLoanPreAgreementData404 | PrepareLoanPreAgreementData500>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prepareLoanPreAgreementData>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPrepareLoanPreAgreementDataQueryOptions(applicationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Takes complete agreement data, fills PDF form fields, and flattens the document.
This generates the final PDF ready for download, printing, or electronic signature.

The PDF form fields are filled with the provided data and then flattened to 
prevent further editing. The generated PDF maintains the original template's 
formatting and styling.

 * @summary Generate loan agreement PDF
 */
export const generateLoanPreAgreementPDF = (
    loanPreAgreementData: LoanPreAgreementData,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Blob>(
      {url: `/loan/api/v1/agreements/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loanPreAgreementData,
        responseType: 'blob', signal
    },
      );
    }
  


export const getGenerateLoanPreAgreementPDFMutationOptions = <TError = GenerateLoanPreAgreementPDF400 | GenerateLoanPreAgreementPDF500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateLoanPreAgreementPDF>>, TError,{data: LoanPreAgreementData}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateLoanPreAgreementPDF>>, TError,{data: LoanPreAgreementData}, TContext> => {

const mutationKey = ['generateLoanPreAgreementPDF'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateLoanPreAgreementPDF>>, {data: LoanPreAgreementData}> = (props) => {
          const {data} = props ?? {};

          return  generateLoanPreAgreementPDF(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateLoanPreAgreementPDFMutationResult = NonNullable<Awaited<ReturnType<typeof generateLoanPreAgreementPDF>>>
    export type GenerateLoanPreAgreementPDFMutationBody = LoanPreAgreementData
    export type GenerateLoanPreAgreementPDFMutationError = GenerateLoanPreAgreementPDF400 | GenerateLoanPreAgreementPDF500

    /**
 * @summary Generate loan agreement PDF
 */
export const useGenerateLoanPreAgreementPDF = <TError = GenerateLoanPreAgreementPDF400 | GenerateLoanPreAgreementPDF500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateLoanPreAgreementPDF>>, TError,{data: LoanPreAgreementData}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateLoanPreAgreementPDF>>,
        TError,
        {data: LoanPreAgreementData},
        TContext
      > => {

      const mutationOptions = getGenerateLoanPreAgreementPDFMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Prepare loan agreement data
 */
export const prepareLoanAgreementData = (
    applicationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanAgreementData>(
      {url: `/loan/api/v1/loan-agreement/prepare/${applicationId}/data`, method: 'GET', signal
    },
      );
    }
  



export const getPrepareLoanAgreementDataQueryKey = (applicationId?: string,) => {
    return [
    `/loan/api/v1/loan-agreement/prepare/${applicationId}/data`
    ] as const;
    }

    
export const getPrepareLoanAgreementDataQueryOptions = <TData = Awaited<ReturnType<typeof prepareLoanAgreementData>>, TError = void>(applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prepareLoanAgreementData>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPrepareLoanAgreementDataQueryKey(applicationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof prepareLoanAgreementData>>> = ({ signal }) => prepareLoanAgreementData(applicationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(applicationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof prepareLoanAgreementData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PrepareLoanAgreementDataQueryResult = NonNullable<Awaited<ReturnType<typeof prepareLoanAgreementData>>>
export type PrepareLoanAgreementDataQueryError = void


export function usePrepareLoanAgreementData<TData = Awaited<ReturnType<typeof prepareLoanAgreementData>>, TError = void>(
 applicationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof prepareLoanAgreementData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof prepareLoanAgreementData>>,
          TError,
          Awaited<ReturnType<typeof prepareLoanAgreementData>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePrepareLoanAgreementData<TData = Awaited<ReturnType<typeof prepareLoanAgreementData>>, TError = void>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prepareLoanAgreementData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof prepareLoanAgreementData>>,
          TError,
          Awaited<ReturnType<typeof prepareLoanAgreementData>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePrepareLoanAgreementData<TData = Awaited<ReturnType<typeof prepareLoanAgreementData>>, TError = void>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prepareLoanAgreementData>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Prepare loan agreement data
 */

export function usePrepareLoanAgreementData<TData = Awaited<ReturnType<typeof prepareLoanAgreementData>>, TError = void>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prepareLoanAgreementData>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPrepareLoanAgreementDataQueryOptions(applicationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Generate loan agreement PDF
 */
export const generateLoanAgreementPDF = (
    loanAgreementData: LoanAgreementData,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Blob>(
      {url: `/loan/api/v1/loan-agreement/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loanAgreementData,
        responseType: 'blob', signal
    },
      );
    }
  


export const getGenerateLoanAgreementPDFMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateLoanAgreementPDF>>, TError,{data: LoanAgreementData}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateLoanAgreementPDF>>, TError,{data: LoanAgreementData}, TContext> => {

const mutationKey = ['generateLoanAgreementPDF'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateLoanAgreementPDF>>, {data: LoanAgreementData}> = (props) => {
          const {data} = props ?? {};

          return  generateLoanAgreementPDF(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateLoanAgreementPDFMutationResult = NonNullable<Awaited<ReturnType<typeof generateLoanAgreementPDF>>>
    export type GenerateLoanAgreementPDFMutationBody = LoanAgreementData
    export type GenerateLoanAgreementPDFMutationError = void

    /**
 * @summary Generate loan agreement PDF
 */
export const useGenerateLoanAgreementPDF = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateLoanAgreementPDF>>, TError,{data: LoanAgreementData}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateLoanAgreementPDF>>,
        TError,
        {data: LoanAgreementData},
        TContext
      > => {

      const mutationOptions = getGenerateLoanAgreementPDFMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Manually calculate penalties for an account as of a date without applying them
 * @summary Calculate penalties for an account
 */
export const calculatePenalties = (
    penaltyCalculationRequest: PenaltyCalculationRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<CalculatedPenalty>(
      {url: `/loan/api/v1/ledger/penalties/calculate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: penaltyCalculationRequest, signal
    },
      );
    }
  


export const getCalculatePenaltiesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calculatePenalties>>, TError,{data: PenaltyCalculationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof calculatePenalties>>, TError,{data: PenaltyCalculationRequest}, TContext> => {

const mutationKey = ['calculatePenalties'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof calculatePenalties>>, {data: PenaltyCalculationRequest}> = (props) => {
          const {data} = props ?? {};

          return  calculatePenalties(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CalculatePenaltiesMutationResult = NonNullable<Awaited<ReturnType<typeof calculatePenalties>>>
    export type CalculatePenaltiesMutationBody = PenaltyCalculationRequest
    export type CalculatePenaltiesMutationError = unknown

    /**
 * @summary Calculate penalties for an account
 */
export const useCalculatePenalties = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calculatePenalties>>, TError,{data: PenaltyCalculationRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof calculatePenalties>>,
        TError,
        {data: PenaltyCalculationRequest},
        TContext
      > => {

      const mutationOptions = getCalculatePenaltiesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves penalty reviews for users to review and action
 * @summary List penalty reviews
 */
export const listPenaltyReviews = (
    params?: ListPenaltyReviewsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<PenaltyReviewPage>(
      {url: `/loan/api/v1/ledger/penalties/reviews`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListPenaltyReviewsQueryKey = (params?: ListPenaltyReviewsParams,) => {
    return [
    `/loan/api/v1/ledger/penalties/reviews`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListPenaltyReviewsQueryOptions = <TData = Awaited<ReturnType<typeof listPenaltyReviews>>, TError = unknown>(params?: ListPenaltyReviewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPenaltyReviews>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPenaltyReviewsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPenaltyReviews>>> = ({ signal }) => listPenaltyReviews(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPenaltyReviews>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPenaltyReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listPenaltyReviews>>>
export type ListPenaltyReviewsQueryError = unknown


export function useListPenaltyReviews<TData = Awaited<ReturnType<typeof listPenaltyReviews>>, TError = unknown>(
 params: undefined |  ListPenaltyReviewsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPenaltyReviews>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPenaltyReviews>>,
          TError,
          Awaited<ReturnType<typeof listPenaltyReviews>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPenaltyReviews<TData = Awaited<ReturnType<typeof listPenaltyReviews>>, TError = unknown>(
 params?: ListPenaltyReviewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPenaltyReviews>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPenaltyReviews>>,
          TError,
          Awaited<ReturnType<typeof listPenaltyReviews>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPenaltyReviews<TData = Awaited<ReturnType<typeof listPenaltyReviews>>, TError = unknown>(
 params?: ListPenaltyReviewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPenaltyReviews>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List penalty reviews
 */

export function useListPenaltyReviews<TData = Awaited<ReturnType<typeof listPenaltyReviews>>, TError = unknown>(
 params?: ListPenaltyReviewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPenaltyReviews>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPenaltyReviewsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates a pending penalty review from a calculation to be approved/rejected/overridden
 * @summary Create penalty review
 */
export const createPenaltyReview = (
    calculatedPenalty: CalculatedPenalty,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<PenaltyReview>(
      {url: `/loan/api/v1/ledger/penalties/reviews`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: calculatedPenalty, signal
    },
      );
    }
  


export const getCreatePenaltyReviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPenaltyReview>>, TError,{data: CalculatedPenalty}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPenaltyReview>>, TError,{data: CalculatedPenalty}, TContext> => {

const mutationKey = ['createPenaltyReview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPenaltyReview>>, {data: CalculatedPenalty}> = (props) => {
          const {data} = props ?? {};

          return  createPenaltyReview(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePenaltyReviewMutationResult = NonNullable<Awaited<ReturnType<typeof createPenaltyReview>>>
    export type CreatePenaltyReviewMutationBody = CalculatedPenalty
    export type CreatePenaltyReviewMutationError = unknown

    /**
 * @summary Create penalty review
 */
export const useCreatePenaltyReview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPenaltyReview>>, TError,{data: CalculatedPenalty}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPenaltyReview>>,
        TError,
        {data: CalculatedPenalty},
        TContext
      > => {

      const mutationOptions = getCreatePenaltyReviewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Approves a penalty review and applies a penalty charge transaction
 * @summary Approve penalty review
 */
export const approvePenaltyReview = (
    reviewId: string,
    penaltyDecisionRequest?: PenaltyDecisionRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<PenaltyReview>(
      {url: `/loan/api/v1/ledger/penalties/reviews/${reviewId}/approve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: penaltyDecisionRequest, signal
    },
      );
    }
  


export const getApprovePenaltyReviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePenaltyReview>>, TError,{reviewId: string;data: PenaltyDecisionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof approvePenaltyReview>>, TError,{reviewId: string;data: PenaltyDecisionRequest}, TContext> => {

const mutationKey = ['approvePenaltyReview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approvePenaltyReview>>, {reviewId: string;data: PenaltyDecisionRequest}> = (props) => {
          const {reviewId,data} = props ?? {};

          return  approvePenaltyReview(reviewId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApprovePenaltyReviewMutationResult = NonNullable<Awaited<ReturnType<typeof approvePenaltyReview>>>
    export type ApprovePenaltyReviewMutationBody = PenaltyDecisionRequest
    export type ApprovePenaltyReviewMutationError = unknown

    /**
 * @summary Approve penalty review
 */
export const useApprovePenaltyReview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePenaltyReview>>, TError,{reviewId: string;data: PenaltyDecisionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approvePenaltyReview>>,
        TError,
        {reviewId: string;data: PenaltyDecisionRequest},
        TContext
      > => {

      const mutationOptions = getApprovePenaltyReviewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get a loan's default terms
 */
export const getLoanDefaultTerms = (
    accountId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanDefaultTerms>(
      {url: `/loan/api/v1/ledger/penalties/accounts/${accountId}/default-terms`, method: 'GET', signal
    },
      );
    }
  



export const getGetLoanDefaultTermsQueryKey = (accountId?: string,) => {
    return [
    `/loan/api/v1/ledger/penalties/accounts/${accountId}/default-terms`
    ] as const;
    }

    
export const getGetLoanDefaultTermsQueryOptions = <TData = Awaited<ReturnType<typeof getLoanDefaultTerms>>, TError = unknown>(accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanDefaultTerms>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanDefaultTermsQueryKey(accountId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanDefaultTerms>>> = ({ signal }) => getLoanDefaultTerms(accountId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(accountId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanDefaultTerms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoanDefaultTermsQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanDefaultTerms>>>
export type GetLoanDefaultTermsQueryError = unknown


export function useGetLoanDefaultTerms<TData = Awaited<ReturnType<typeof getLoanDefaultTerms>>, TError = unknown>(
 accountId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanDefaultTerms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanDefaultTerms>>,
          TError,
          Awaited<ReturnType<typeof getLoanDefaultTerms>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanDefaultTerms<TData = Awaited<ReturnType<typeof getLoanDefaultTerms>>, TError = unknown>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanDefaultTerms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanDefaultTerms>>,
          TError,
          Awaited<ReturnType<typeof getLoanDefaultTerms>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanDefaultTerms<TData = Awaited<ReturnType<typeof getLoanDefaultTerms>>, TError = unknown>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanDefaultTerms>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a loan's default terms
 */

export function useGetLoanDefaultTerms<TData = Awaited<ReturnType<typeof getLoanDefaultTerms>>, TError = unknown>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanDefaultTerms>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoanDefaultTermsQueryOptions(accountId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Sets the default rate, charge frequency and grace period. Pending charges the new grace period covers are withdrawn; the rest stay pending for a decision.

 * @summary Set a loan's default terms
 */
export const updateLoanDefaultTerms = (
    accountId: string,
    loanDefaultTerms: NonReadonly<LoanDefaultTerms>,
 ) => {
      
      
      return customAxiosInstanceMutator<LoanDefaultTerms>(
      {url: `/loan/api/v1/ledger/penalties/accounts/${accountId}/default-terms`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: loanDefaultTerms
    },
      );
    }
  


export const getUpdateLoanDefaultTermsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLoanDefaultTerms>>, TError,{accountId: string;data: NonReadonly<LoanDefaultTerms>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateLoanDefaultTerms>>, TError,{accountId: string;data: NonReadonly<LoanDefaultTerms>}, TContext> => {

const mutationKey = ['updateLoanDefaultTerms'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLoanDefaultTerms>>, {accountId: string;data: NonReadonly<LoanDefaultTerms>}> = (props) => {
          const {accountId,data} = props ?? {};

          return  updateLoanDefaultTerms(accountId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLoanDefaultTermsMutationResult = NonNullable<Awaited<ReturnType<typeof updateLoanDefaultTerms>>>
    export type UpdateLoanDefaultTermsMutationBody = NonReadonly<LoanDefaultTerms>
    export type UpdateLoanDefaultTermsMutationError = unknown

    /**
 * @summary Set a loan's default terms
 */
export const useUpdateLoanDefaultTerms = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLoanDefaultTerms>>, TError,{accountId: string;data: NonReadonly<LoanDefaultTerms>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLoanDefaultTerms>>,
        TError,
        {accountId: string;data: NonReadonly<LoanDefaultTerms>},
        TContext
      > => {

      const mutationOptions = getUpdateLoanDefaultTermsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Withdraws the pending charge and holds off new charges on the account for the given number of days. If the client is still unpaid when the grace runs out, a charge is proposed again.

 * @summary Grant grace on a pending charge
 */
export const grantPenaltyGrace = (
    reviewId: string,
    grantPenaltyGraceRequest: GrantPenaltyGraceRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<PenaltyReview>(
      {url: `/loan/api/v1/ledger/penalties/reviews/${reviewId}/grace`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: grantPenaltyGraceRequest, signal
    },
      );
    }
  


export const getGrantPenaltyGraceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantPenaltyGrace>>, TError,{reviewId: string;data: GrantPenaltyGraceRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof grantPenaltyGrace>>, TError,{reviewId: string;data: GrantPenaltyGraceRequest}, TContext> => {

const mutationKey = ['grantPenaltyGrace'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof grantPenaltyGrace>>, {reviewId: string;data: GrantPenaltyGraceRequest}> = (props) => {
          const {reviewId,data} = props ?? {};

          return  grantPenaltyGrace(reviewId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GrantPenaltyGraceMutationResult = NonNullable<Awaited<ReturnType<typeof grantPenaltyGrace>>>
    export type GrantPenaltyGraceMutationBody = GrantPenaltyGraceRequest
    export type GrantPenaltyGraceMutationError = unknown

    /**
 * @summary Grant grace on a pending charge
 */
export const useGrantPenaltyGrace = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantPenaltyGrace>>, TError,{reviewId: string;data: GrantPenaltyGraceRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof grantPenaltyGrace>>,
        TError,
        {reviewId: string;data: GrantPenaltyGraceRequest},
        TContext
      > => {

      const mutationOptions = getGrantPenaltyGraceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Rejects a penalty review with optional remarks
 * @summary Reject penalty review
 */
export const rejectPenaltyReview = (
    reviewId: string,
    penaltyDecisionRequest?: PenaltyDecisionRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<PenaltyReview>(
      {url: `/loan/api/v1/ledger/penalties/reviews/${reviewId}/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: penaltyDecisionRequest, signal
    },
      );
    }
  


export const getRejectPenaltyReviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectPenaltyReview>>, TError,{reviewId: string;data: PenaltyDecisionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rejectPenaltyReview>>, TError,{reviewId: string;data: PenaltyDecisionRequest}, TContext> => {

const mutationKey = ['rejectPenaltyReview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectPenaltyReview>>, {reviewId: string;data: PenaltyDecisionRequest}> = (props) => {
          const {reviewId,data} = props ?? {};

          return  rejectPenaltyReview(reviewId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectPenaltyReviewMutationResult = NonNullable<Awaited<ReturnType<typeof rejectPenaltyReview>>>
    export type RejectPenaltyReviewMutationBody = PenaltyDecisionRequest
    export type RejectPenaltyReviewMutationError = unknown

    /**
 * @summary Reject penalty review
 */
export const useRejectPenaltyReview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectPenaltyReview>>, TError,{reviewId: string;data: PenaltyDecisionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectPenaltyReview>>,
        TError,
        {reviewId: string;data: PenaltyDecisionRequest},
        TContext
      > => {

      const mutationOptions = getRejectPenaltyReviewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Overrides calculated amount and applies the overridden penalty as a charge
 * @summary Override penalty amount and approve
 */
export const overridePenaltyReview = (
    reviewId: string,
    penaltyDecisionRequest: PenaltyDecisionRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<PenaltyReview>(
      {url: `/loan/api/v1/ledger/penalties/reviews/${reviewId}/override`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: penaltyDecisionRequest, signal
    },
      );
    }
  


export const getOverridePenaltyReviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof overridePenaltyReview>>, TError,{reviewId: string;data: PenaltyDecisionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof overridePenaltyReview>>, TError,{reviewId: string;data: PenaltyDecisionRequest}, TContext> => {

const mutationKey = ['overridePenaltyReview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof overridePenaltyReview>>, {reviewId: string;data: PenaltyDecisionRequest}> = (props) => {
          const {reviewId,data} = props ?? {};

          return  overridePenaltyReview(reviewId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OverridePenaltyReviewMutationResult = NonNullable<Awaited<ReturnType<typeof overridePenaltyReview>>>
    export type OverridePenaltyReviewMutationBody = PenaltyDecisionRequest
    export type OverridePenaltyReviewMutationError = unknown

    /**
 * @summary Override penalty amount and approve
 */
export const useOverridePenaltyReview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof overridePenaltyReview>>, TError,{reviewId: string;data: PenaltyDecisionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof overridePenaltyReview>>,
        TError,
        {reviewId: string;data: PenaltyDecisionRequest},
        TContext
      > => {

      const mutationOptions = getOverridePenaltyReviewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Reverses the original charge transaction and records a new one with the corrected amount, date and due date. Prevents duplicate charges on retry via idempotency key.
 * @summary Immutable edit of an approved charge
 */
export const editPenaltyReviewCharge = (
    reviewId: string,
    editPenaltyReviewChargeRequest: EditPenaltyReviewChargeRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<EditPenaltyReviewChargeResponse>(
      {url: `/loan/api/v1/ledger/penalties/reviews/${reviewId}/edit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: editPenaltyReviewChargeRequest, signal
    },
      );
    }
  


export const getEditPenaltyReviewChargeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPenaltyReviewCharge>>, TError,{reviewId: string;data: EditPenaltyReviewChargeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof editPenaltyReviewCharge>>, TError,{reviewId: string;data: EditPenaltyReviewChargeRequest}, TContext> => {

const mutationKey = ['editPenaltyReviewCharge'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editPenaltyReviewCharge>>, {reviewId: string;data: EditPenaltyReviewChargeRequest}> = (props) => {
          const {reviewId,data} = props ?? {};

          return  editPenaltyReviewCharge(reviewId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EditPenaltyReviewChargeMutationResult = NonNullable<Awaited<ReturnType<typeof editPenaltyReviewCharge>>>
    export type EditPenaltyReviewChargeMutationBody = EditPenaltyReviewChargeRequest
    export type EditPenaltyReviewChargeMutationError = void

    /**
 * @summary Immutable edit of an approved charge
 */
export const useEditPenaltyReviewCharge = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPenaltyReviewCharge>>, TError,{reviewId: string;data: EditPenaltyReviewChargeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editPenaltyReviewCharge>>,
        TError,
        {reviewId: string;data: EditPenaltyReviewChargeRequest},
        TContext
      > => {

      const mutationOptions = getEditPenaltyReviewChargeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves current balance for a loan account (as-of today or specific date)
 * @summary Get account balance
 */
export const getLedgerAccountBalance = (
    accountId: string,
    params?: GetLedgerAccountBalanceParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerAccountBalance>(
      {url: `/loan/api/v1/ledger/accounts/${accountId}/balance`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLedgerAccountBalanceQueryKey = (accountId?: string,
    params?: GetLedgerAccountBalanceParams,) => {
    return [
    `/loan/api/v1/ledger/accounts/${accountId}/balance`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLedgerAccountBalanceQueryOptions = <TData = Awaited<ReturnType<typeof getLedgerAccountBalance>>, TError = void>(accountId: string,
    params?: GetLedgerAccountBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountBalance>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLedgerAccountBalanceQueryKey(accountId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLedgerAccountBalance>>> = ({ signal }) => getLedgerAccountBalance(accountId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(accountId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLedgerAccountBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof getLedgerAccountBalance>>>
export type GetLedgerAccountBalanceQueryError = void


export function useGetLedgerAccountBalance<TData = Awaited<ReturnType<typeof getLedgerAccountBalance>>, TError = void>(
 accountId: string,
    params: undefined |  GetLedgerAccountBalanceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLedgerAccountBalance>>,
          TError,
          Awaited<ReturnType<typeof getLedgerAccountBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLedgerAccountBalance<TData = Awaited<ReturnType<typeof getLedgerAccountBalance>>, TError = void>(
 accountId: string,
    params?: GetLedgerAccountBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLedgerAccountBalance>>,
          TError,
          Awaited<ReturnType<typeof getLedgerAccountBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLedgerAccountBalance<TData = Awaited<ReturnType<typeof getLedgerAccountBalance>>, TError = void>(
 accountId: string,
    params?: GetLedgerAccountBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get account balance
 */

export function useGetLedgerAccountBalance<TData = Awaited<ReturnType<typeof getLedgerAccountBalance>>, TError = void>(
 accountId: string,
    params?: GetLedgerAccountBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountBalance>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLedgerAccountBalanceQueryOptions(accountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves payment schedule (installments) for a loan account
 * @summary Get payment schedule
 */
export const getLedgerAccountSchedule = (
    accountId: string,
    params?: GetLedgerAccountScheduleParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerInstallment[]>(
      {url: `/loan/api/v1/ledger/accounts/${accountId}/schedule`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLedgerAccountScheduleQueryKey = (accountId?: string,
    params?: GetLedgerAccountScheduleParams,) => {
    return [
    `/loan/api/v1/ledger/accounts/${accountId}/schedule`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLedgerAccountScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getLedgerAccountSchedule>>, TError = void>(accountId: string,
    params?: GetLedgerAccountScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountSchedule>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLedgerAccountScheduleQueryKey(accountId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLedgerAccountSchedule>>> = ({ signal }) => getLedgerAccountSchedule(accountId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(accountId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountSchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLedgerAccountScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getLedgerAccountSchedule>>>
export type GetLedgerAccountScheduleQueryError = void


export function useGetLedgerAccountSchedule<TData = Awaited<ReturnType<typeof getLedgerAccountSchedule>>, TError = void>(
 accountId: string,
    params: undefined |  GetLedgerAccountScheduleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountSchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLedgerAccountSchedule>>,
          TError,
          Awaited<ReturnType<typeof getLedgerAccountSchedule>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLedgerAccountSchedule<TData = Awaited<ReturnType<typeof getLedgerAccountSchedule>>, TError = void>(
 accountId: string,
    params?: GetLedgerAccountScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountSchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLedgerAccountSchedule>>,
          TError,
          Awaited<ReturnType<typeof getLedgerAccountSchedule>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLedgerAccountSchedule<TData = Awaited<ReturnType<typeof getLedgerAccountSchedule>>, TError = void>(
 accountId: string,
    params?: GetLedgerAccountScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountSchedule>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payment schedule
 */

export function useGetLedgerAccountSchedule<TData = Awaited<ReturnType<typeof getLedgerAccountSchedule>>, TError = void>(
 accountId: string,
    params?: GetLedgerAccountScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountSchedule>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLedgerAccountScheduleQueryOptions(accountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves full account details
 * @summary Get account details
 */
export const getLedgerAccountById = (
    accountId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerAccount>(
      {url: `/loan/api/v1/ledger/accounts/${accountId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetLedgerAccountByIdQueryKey = (accountId?: string,) => {
    return [
    `/loan/api/v1/ledger/accounts/${accountId}`
    ] as const;
    }

    
export const getGetLedgerAccountByIdQueryOptions = <TData = Awaited<ReturnType<typeof getLedgerAccountById>>, TError = void>(accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLedgerAccountByIdQueryKey(accountId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLedgerAccountById>>> = ({ signal }) => getLedgerAccountById(accountId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(accountId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLedgerAccountByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLedgerAccountById>>>
export type GetLedgerAccountByIdQueryError = void


export function useGetLedgerAccountById<TData = Awaited<ReturnType<typeof getLedgerAccountById>>, TError = void>(
 accountId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLedgerAccountById>>,
          TError,
          Awaited<ReturnType<typeof getLedgerAccountById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLedgerAccountById<TData = Awaited<ReturnType<typeof getLedgerAccountById>>, TError = void>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLedgerAccountById>>,
          TError,
          Awaited<ReturnType<typeof getLedgerAccountById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLedgerAccountById<TData = Awaited<ReturnType<typeof getLedgerAccountById>>, TError = void>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get account details
 */

export function useGetLedgerAccountById<TData = Awaited<ReturnType<typeof getLedgerAccountById>>, TError = void>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountById>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLedgerAccountByIdQueryOptions(accountId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves all transactions for an account
 * @summary Get account transaction history
 */
export const getLedgerAccountTransactions = (
    accountId: string,
    params?: GetLedgerAccountTransactionsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerTransaction[]>(
      {url: `/loan/api/v1/ledger/accounts/${accountId}/transactions`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLedgerAccountTransactionsQueryKey = (accountId?: string,
    params?: GetLedgerAccountTransactionsParams,) => {
    return [
    `/loan/api/v1/ledger/accounts/${accountId}/transactions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLedgerAccountTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getLedgerAccountTransactions>>, TError = void>(accountId: string,
    params?: GetLedgerAccountTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountTransactions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLedgerAccountTransactionsQueryKey(accountId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLedgerAccountTransactions>>> = ({ signal }) => getLedgerAccountTransactions(accountId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(accountId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLedgerAccountTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getLedgerAccountTransactions>>>
export type GetLedgerAccountTransactionsQueryError = void


export function useGetLedgerAccountTransactions<TData = Awaited<ReturnType<typeof getLedgerAccountTransactions>>, TError = void>(
 accountId: string,
    params: undefined |  GetLedgerAccountTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLedgerAccountTransactions>>,
          TError,
          Awaited<ReturnType<typeof getLedgerAccountTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLedgerAccountTransactions<TData = Awaited<ReturnType<typeof getLedgerAccountTransactions>>, TError = void>(
 accountId: string,
    params?: GetLedgerAccountTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLedgerAccountTransactions>>,
          TError,
          Awaited<ReturnType<typeof getLedgerAccountTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLedgerAccountTransactions<TData = Awaited<ReturnType<typeof getLedgerAccountTransactions>>, TError = void>(
 accountId: string,
    params?: GetLedgerAccountTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get account transaction history
 */

export function useGetLedgerAccountTransactions<TData = Awaited<ReturnType<typeof getLedgerAccountTransactions>>, TError = void>(
 accountId: string,
    params?: GetLedgerAccountTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLedgerAccountTransactionsQueryOptions(accountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves all loan accounts with filtering by status
 * @summary Get all loan accounts with pagination
 */
export const getLedgerAccounts = (
    params?: GetLedgerAccountsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerAccountPage>(
      {url: `/loan/api/v1/ledger/accounts`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLedgerAccountsQueryKey = (params?: GetLedgerAccountsParams,) => {
    return [
    `/loan/api/v1/ledger/accounts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLedgerAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getLedgerAccounts>>, TError = void>(params?: GetLedgerAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccounts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLedgerAccountsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLedgerAccounts>>> = ({ signal }) => getLedgerAccounts(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLedgerAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getLedgerAccounts>>>
export type GetLedgerAccountsQueryError = void


export function useGetLedgerAccounts<TData = Awaited<ReturnType<typeof getLedgerAccounts>>, TError = void>(
 params: undefined |  GetLedgerAccountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLedgerAccounts>>,
          TError,
          Awaited<ReturnType<typeof getLedgerAccounts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLedgerAccounts<TData = Awaited<ReturnType<typeof getLedgerAccounts>>, TError = void>(
 params?: GetLedgerAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLedgerAccounts>>,
          TError,
          Awaited<ReturnType<typeof getLedgerAccounts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLedgerAccounts<TData = Awaited<ReturnType<typeof getLedgerAccounts>>, TError = void>(
 params?: GetLedgerAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all loan accounts with pagination
 */

export function useGetLedgerAccounts<TData = Awaited<ReturnType<typeof getLedgerAccounts>>, TError = void>(
 params?: GetLedgerAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccounts>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLedgerAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves loan account details by account number
 * @summary Get account by account number
 */
export const getLedgerAccountByNumber = (
    accountNumber: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerAccount>(
      {url: `/loan/api/v1/ledger/accounts/by-account-number/${accountNumber}`, method: 'GET', signal
    },
      );
    }
  



export const getGetLedgerAccountByNumberQueryKey = (accountNumber?: string,) => {
    return [
    `/loan/api/v1/ledger/accounts/by-account-number/${accountNumber}`
    ] as const;
    }

    
export const getGetLedgerAccountByNumberQueryOptions = <TData = Awaited<ReturnType<typeof getLedgerAccountByNumber>>, TError = void>(accountNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountByNumber>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLedgerAccountByNumberQueryKey(accountNumber);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLedgerAccountByNumber>>> = ({ signal }) => getLedgerAccountByNumber(accountNumber, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(accountNumber), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountByNumber>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLedgerAccountByNumberQueryResult = NonNullable<Awaited<ReturnType<typeof getLedgerAccountByNumber>>>
export type GetLedgerAccountByNumberQueryError = void


export function useGetLedgerAccountByNumber<TData = Awaited<ReturnType<typeof getLedgerAccountByNumber>>, TError = void>(
 accountNumber: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountByNumber>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLedgerAccountByNumber>>,
          TError,
          Awaited<ReturnType<typeof getLedgerAccountByNumber>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLedgerAccountByNumber<TData = Awaited<ReturnType<typeof getLedgerAccountByNumber>>, TError = void>(
 accountNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountByNumber>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLedgerAccountByNumber>>,
          TError,
          Awaited<ReturnType<typeof getLedgerAccountByNumber>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLedgerAccountByNumber<TData = Awaited<ReturnType<typeof getLedgerAccountByNumber>>, TError = void>(
 accountNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountByNumber>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get account by account number
 */

export function useGetLedgerAccountByNumber<TData = Awaited<ReturnType<typeof getLedgerAccountByNumber>>, TError = void>(
 accountNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountByNumber>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLedgerAccountByNumberQueryOptions(accountNumber,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves loan account by the associated loan application ID
 * @summary Get account by loan application ID
 */
export const getLedgerAccountByApplicationId = (
    applicationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerAccount>(
      {url: `/loan/api/v1/ledger/accounts/by-application/${applicationId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetLedgerAccountByApplicationIdQueryKey = (applicationId?: string,) => {
    return [
    `/loan/api/v1/ledger/accounts/by-application/${applicationId}`
    ] as const;
    }

    
export const getGetLedgerAccountByApplicationIdQueryOptions = <TData = Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>, TError = void>(applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLedgerAccountByApplicationIdQueryKey(applicationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>> = ({ signal }) => getLedgerAccountByApplicationId(applicationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(applicationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLedgerAccountByApplicationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>>
export type GetLedgerAccountByApplicationIdQueryError = void


export function useGetLedgerAccountByApplicationId<TData = Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>, TError = void>(
 applicationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>,
          TError,
          Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLedgerAccountByApplicationId<TData = Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>, TError = void>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>,
          TError,
          Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLedgerAccountByApplicationId<TData = Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>, TError = void>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get account by loan application ID
 */

export function useGetLedgerAccountByApplicationId<TData = Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>, TError = void>(
 applicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountByApplicationId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLedgerAccountByApplicationIdQueryOptions(applicationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves all loan accounts for a customer
 * @summary Get accounts by customer party ID
 */
export const getLedgerAccountsByCustomer = (
    params: GetLedgerAccountsByCustomerParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerAccount[]>(
      {url: `/loan/api/v1/ledger/accounts/by-customer`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLedgerAccountsByCustomerQueryKey = (params?: GetLedgerAccountsByCustomerParams,) => {
    return [
    `/loan/api/v1/ledger/accounts/by-customer`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLedgerAccountsByCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>, TError = void>(params: GetLedgerAccountsByCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLedgerAccountsByCustomerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>> = ({ signal }) => getLedgerAccountsByCustomer(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLedgerAccountsByCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>>
export type GetLedgerAccountsByCustomerQueryError = void


export function useGetLedgerAccountsByCustomer<TData = Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>, TError = void>(
 params: GetLedgerAccountsByCustomerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>,
          TError,
          Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLedgerAccountsByCustomer<TData = Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>, TError = void>(
 params: GetLedgerAccountsByCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>,
          TError,
          Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLedgerAccountsByCustomer<TData = Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>, TError = void>(
 params: GetLedgerAccountsByCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get accounts by customer party ID
 */

export function useGetLedgerAccountsByCustomer<TData = Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>, TError = void>(
 params: GetLedgerAccountsByCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLedgerAccountsByCustomer>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLedgerAccountsByCustomerQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Promises to pay recorded on collection notes, earliest promise date first. Each pending promise is re-checked against the payments received before the list is returned.

 * @summary Promises to pay across all accounts
 */
export const getPromisesToPay = (
    params?: GetPromisesToPayParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<CollectionNote[]>(
      {url: `/loan/api/v1/ledger/promises-to-pay`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetPromisesToPayQueryKey = (params?: GetPromisesToPayParams,) => {
    return [
    `/loan/api/v1/ledger/promises-to-pay`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPromisesToPayQueryOptions = <TData = Awaited<ReturnType<typeof getPromisesToPay>>, TError = void>(params?: GetPromisesToPayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromisesToPay>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromisesToPayQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPromisesToPay>>> = ({ signal }) => getPromisesToPay(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPromisesToPay>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPromisesToPayQueryResult = NonNullable<Awaited<ReturnType<typeof getPromisesToPay>>>
export type GetPromisesToPayQueryError = void


export function useGetPromisesToPay<TData = Awaited<ReturnType<typeof getPromisesToPay>>, TError = void>(
 params: undefined |  GetPromisesToPayParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromisesToPay>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromisesToPay>>,
          TError,
          Awaited<ReturnType<typeof getPromisesToPay>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromisesToPay<TData = Awaited<ReturnType<typeof getPromisesToPay>>, TError = void>(
 params?: GetPromisesToPayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromisesToPay>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromisesToPay>>,
          TError,
          Awaited<ReturnType<typeof getPromisesToPay>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromisesToPay<TData = Awaited<ReturnType<typeof getPromisesToPay>>, TError = void>(
 params?: GetPromisesToPayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromisesToPay>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Promises to pay across all accounts
 */

export function useGetPromisesToPay<TData = Awaited<ReturnType<typeof getPromisesToPay>>, TError = void>(
 params?: GetPromisesToPayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromisesToPay>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPromisesToPayQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Confirms the loan was settled in full on its closed date and nothing more is owed. Only for a closed loan with no balance.

 * @summary Settlement (paid-up) letter for a closed loan
 */
export const downloadSettlementLetter = (
    accountId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Blob>(
      {url: `/loan/api/v1/ledger-accounts/${accountId}/settlement-letter`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }
  



export const getDownloadSettlementLetterQueryKey = (accountId?: string,) => {
    return [
    `/loan/api/v1/ledger-accounts/${accountId}/settlement-letter`
    ] as const;
    }

    
export const getDownloadSettlementLetterQueryOptions = <TData = Awaited<ReturnType<typeof downloadSettlementLetter>>, TError = void>(accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadSettlementLetter>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadSettlementLetterQueryKey(accountId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadSettlementLetter>>> = ({ signal }) => downloadSettlementLetter(accountId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(accountId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadSettlementLetter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadSettlementLetterQueryResult = NonNullable<Awaited<ReturnType<typeof downloadSettlementLetter>>>
export type DownloadSettlementLetterQueryError = void


export function useDownloadSettlementLetter<TData = Awaited<ReturnType<typeof downloadSettlementLetter>>, TError = void>(
 accountId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadSettlementLetter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadSettlementLetter>>,
          TError,
          Awaited<ReturnType<typeof downloadSettlementLetter>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadSettlementLetter<TData = Awaited<ReturnType<typeof downloadSettlementLetter>>, TError = void>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadSettlementLetter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadSettlementLetter>>,
          TError,
          Awaited<ReturnType<typeof downloadSettlementLetter>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadSettlementLetter<TData = Awaited<ReturnType<typeof downloadSettlementLetter>>, TError = void>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadSettlementLetter>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Settlement (paid-up) letter for a closed loan
 */

export function useDownloadSettlementLetter<TData = Awaited<ReturnType<typeof downloadSettlementLetter>>, TError = void>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadSettlementLetter>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadSettlementLetterQueryOptions(accountId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Opening balance, every transaction that moved the balance in the period with a running balance, the closing balance and what it is made of, and the arrears and next instalment at the period end.

 * @summary Client statement for a period
 */
export const getLoanStatement = (
    accountId: string,
    params: GetLoanStatementParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LoanStatement>(
      {url: `/loan/api/v1/ledger-accounts/${accountId}/statement`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLoanStatementQueryKey = (accountId?: string,
    params?: GetLoanStatementParams,) => {
    return [
    `/loan/api/v1/ledger-accounts/${accountId}/statement`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLoanStatementQueryOptions = <TData = Awaited<ReturnType<typeof getLoanStatement>>, TError = void>(accountId: string,
    params: GetLoanStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanStatement>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanStatementQueryKey(accountId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanStatement>>> = ({ signal }) => getLoanStatement(accountId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(accountId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanStatement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoanStatementQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanStatement>>>
export type GetLoanStatementQueryError = void


export function useGetLoanStatement<TData = Awaited<ReturnType<typeof getLoanStatement>>, TError = void>(
 accountId: string,
    params: GetLoanStatementParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanStatement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanStatement>>,
          TError,
          Awaited<ReturnType<typeof getLoanStatement>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanStatement<TData = Awaited<ReturnType<typeof getLoanStatement>>, TError = void>(
 accountId: string,
    params: GetLoanStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanStatement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanStatement>>,
          TError,
          Awaited<ReturnType<typeof getLoanStatement>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanStatement<TData = Awaited<ReturnType<typeof getLoanStatement>>, TError = void>(
 accountId: string,
    params: GetLoanStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanStatement>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Client statement for a period
 */

export function useGetLoanStatement<TData = Awaited<ReturnType<typeof getLoanStatement>>, TError = void>(
 accountId: string,
    params: GetLoanStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanStatement>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoanStatementQueryOptions(accountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Client statement for a period as a PDF
 */
export const downloadLoanStatement = (
    accountId: string,
    params: DownloadLoanStatementParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Blob>(
      {url: `/loan/api/v1/ledger-accounts/${accountId}/statement/pdf`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      );
    }
  



export const getDownloadLoanStatementQueryKey = (accountId?: string,
    params?: DownloadLoanStatementParams,) => {
    return [
    `/loan/api/v1/ledger-accounts/${accountId}/statement/pdf`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDownloadLoanStatementQueryOptions = <TData = Awaited<ReturnType<typeof downloadLoanStatement>>, TError = void>(accountId: string,
    params: DownloadLoanStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadLoanStatement>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadLoanStatementQueryKey(accountId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadLoanStatement>>> = ({ signal }) => downloadLoanStatement(accountId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(accountId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadLoanStatement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadLoanStatementQueryResult = NonNullable<Awaited<ReturnType<typeof downloadLoanStatement>>>
export type DownloadLoanStatementQueryError = void


export function useDownloadLoanStatement<TData = Awaited<ReturnType<typeof downloadLoanStatement>>, TError = void>(
 accountId: string,
    params: DownloadLoanStatementParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadLoanStatement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadLoanStatement>>,
          TError,
          Awaited<ReturnType<typeof downloadLoanStatement>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadLoanStatement<TData = Awaited<ReturnType<typeof downloadLoanStatement>>, TError = void>(
 accountId: string,
    params: DownloadLoanStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadLoanStatement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadLoanStatement>>,
          TError,
          Awaited<ReturnType<typeof downloadLoanStatement>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadLoanStatement<TData = Awaited<ReturnType<typeof downloadLoanStatement>>, TError = void>(
 accountId: string,
    params: DownloadLoanStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadLoanStatement>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Client statement for a period as a PDF
 */

export function useDownloadLoanStatement<TData = Awaited<ReturnType<typeof downloadLoanStatement>>, TError = void>(
 accountId: string,
    params: DownloadLoanStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadLoanStatement>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadLoanStatementQueryOptions(accountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * All saved drafts, most recently saved first, without their form data.
 * @summary Loan applications still being captured
 */
export const listApplicationDrafts = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<ApplicationDraft[]>(
      {url: `/loan/api/v1/application-drafts`, method: 'GET', signal
    },
      );
    }
  



export const getListApplicationDraftsQueryKey = () => {
    return [
    `/loan/api/v1/application-drafts`
    ] as const;
    }

    
export const getListApplicationDraftsQueryOptions = <TData = Awaited<ReturnType<typeof listApplicationDrafts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApplicationDrafts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListApplicationDraftsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listApplicationDrafts>>> = ({ signal }) => listApplicationDrafts(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listApplicationDrafts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListApplicationDraftsQueryResult = NonNullable<Awaited<ReturnType<typeof listApplicationDrafts>>>
export type ListApplicationDraftsQueryError = unknown


export function useListApplicationDrafts<TData = Awaited<ReturnType<typeof listApplicationDrafts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApplicationDrafts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listApplicationDrafts>>,
          TError,
          Awaited<ReturnType<typeof listApplicationDrafts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListApplicationDrafts<TData = Awaited<ReturnType<typeof listApplicationDrafts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApplicationDrafts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listApplicationDrafts>>,
          TError,
          Awaited<ReturnType<typeof listApplicationDrafts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListApplicationDrafts<TData = Awaited<ReturnType<typeof listApplicationDrafts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApplicationDrafts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Loan applications still being captured
 */

export function useListApplicationDrafts<TData = Awaited<ReturnType<typeof listApplicationDrafts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApplicationDrafts>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListApplicationDraftsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Save a new application draft
 */
export const createApplicationDraft = (
    saveApplicationDraft: SaveApplicationDraft,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<ApplicationDraft>(
      {url: `/loan/api/v1/application-drafts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveApplicationDraft, signal
    },
      );
    }
  


export const getCreateApplicationDraftMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApplicationDraft>>, TError,{data: SaveApplicationDraft}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createApplicationDraft>>, TError,{data: SaveApplicationDraft}, TContext> => {

const mutationKey = ['createApplicationDraft'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createApplicationDraft>>, {data: SaveApplicationDraft}> = (props) => {
          const {data} = props ?? {};

          return  createApplicationDraft(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateApplicationDraftMutationResult = NonNullable<Awaited<ReturnType<typeof createApplicationDraft>>>
    export type CreateApplicationDraftMutationBody = SaveApplicationDraft
    export type CreateApplicationDraftMutationError = void

    /**
 * @summary Save a new application draft
 */
export const useCreateApplicationDraft = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApplicationDraft>>, TError,{data: SaveApplicationDraft}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createApplicationDraft>>,
        TError,
        {data: SaveApplicationDraft},
        TContext
      > => {

      const mutationOptions = getCreateApplicationDraftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary One application draft, with its form data, to resume it
 */
export const getApplicationDraft = (
    draftId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<ApplicationDraft>(
      {url: `/loan/api/v1/application-drafts/${draftId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetApplicationDraftQueryKey = (draftId?: string,) => {
    return [
    `/loan/api/v1/application-drafts/${draftId}`
    ] as const;
    }

    
export const getGetApplicationDraftQueryOptions = <TData = Awaited<ReturnType<typeof getApplicationDraft>>, TError = void>(draftId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicationDraft>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApplicationDraftQueryKey(draftId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicationDraft>>> = ({ signal }) => getApplicationDraft(draftId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(draftId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApplicationDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApplicationDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicationDraft>>>
export type GetApplicationDraftQueryError = void


export function useGetApplicationDraft<TData = Awaited<ReturnType<typeof getApplicationDraft>>, TError = void>(
 draftId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicationDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicationDraft>>,
          TError,
          Awaited<ReturnType<typeof getApplicationDraft>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicationDraft<TData = Awaited<ReturnType<typeof getApplicationDraft>>, TError = void>(
 draftId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicationDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicationDraft>>,
          TError,
          Awaited<ReturnType<typeof getApplicationDraft>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicationDraft<TData = Awaited<ReturnType<typeof getApplicationDraft>>, TError = void>(
 draftId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicationDraft>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One application draft, with its form data, to resume it
 */

export function useGetApplicationDraft<TData = Awaited<ReturnType<typeof getApplicationDraft>>, TError = void>(
 draftId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicationDraft>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApplicationDraftQueryOptions(draftId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Save the latest state of an application draft
 */
export const updateApplicationDraft = (
    draftId: string,
    saveApplicationDraft: SaveApplicationDraft,
 ) => {
      
      
      return customAxiosInstanceMutator<ApplicationDraft>(
      {url: `/loan/api/v1/application-drafts/${draftId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveApplicationDraft
    },
      );
    }
  


export const getUpdateApplicationDraftMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApplicationDraft>>, TError,{draftId: string;data: SaveApplicationDraft}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateApplicationDraft>>, TError,{draftId: string;data: SaveApplicationDraft}, TContext> => {

const mutationKey = ['updateApplicationDraft'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateApplicationDraft>>, {draftId: string;data: SaveApplicationDraft}> = (props) => {
          const {draftId,data} = props ?? {};

          return  updateApplicationDraft(draftId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateApplicationDraftMutationResult = NonNullable<Awaited<ReturnType<typeof updateApplicationDraft>>>
    export type UpdateApplicationDraftMutationBody = SaveApplicationDraft
    export type UpdateApplicationDraftMutationError = void

    /**
 * @summary Save the latest state of an application draft
 */
export const useUpdateApplicationDraft = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApplicationDraft>>, TError,{draftId: string;data: SaveApplicationDraft}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateApplicationDraft>>,
        TError,
        {draftId: string;data: SaveApplicationDraft},
        TContext
      > => {

      const mutationOptions = getUpdateApplicationDraftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Remove an application draft (submitted or discarded)
 */
export const deleteApplicationDraft = (
    draftId: string,
 ) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/loan/api/v1/application-drafts/${draftId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteApplicationDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApplicationDraft>>, TError,{draftId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApplicationDraft>>, TError,{draftId: string}, TContext> => {

const mutationKey = ['deleteApplicationDraft'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApplicationDraft>>, {draftId: string}> = (props) => {
          const {draftId} = props ?? {};

          return  deleteApplicationDraft(draftId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApplicationDraftMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApplicationDraft>>>
    
    export type DeleteApplicationDraftMutationError = unknown

    /**
 * @summary Remove an application draft (submitted or discarded)
 */
export const useDeleteApplicationDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApplicationDraft>>, TError,{draftId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApplicationDraft>>,
        TError,
        {draftId: string},
        TContext
      > => {

      const mutationOptions = getDeleteApplicationDraftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * An overdue notice for everything payable when an instalment is already late, otherwise a reminder of the next instalment, sent to the customer's contact details on record. Logged on the loan's follow-up history.

 * @summary Send the borrower a reminder now, by SMS or email
 */
export const sendCollectionReminder = (
    accountId: string,
    sendCollectionReminder: SendCollectionReminder,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<CollectionReminder>(
      {url: `/loan/api/v1/ledger-accounts/${accountId}/reminders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendCollectionReminder, signal
    },
      );
    }
  


export const getSendCollectionReminderMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCollectionReminder>>, TError,{accountId: string;data: SendCollectionReminder}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendCollectionReminder>>, TError,{accountId: string;data: SendCollectionReminder}, TContext> => {

const mutationKey = ['sendCollectionReminder'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendCollectionReminder>>, {accountId: string;data: SendCollectionReminder}> = (props) => {
          const {accountId,data} = props ?? {};

          return  sendCollectionReminder(accountId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendCollectionReminderMutationResult = NonNullable<Awaited<ReturnType<typeof sendCollectionReminder>>>
    export type SendCollectionReminderMutationBody = SendCollectionReminder
    export type SendCollectionReminderMutationError = void

    /**
 * @summary Send the borrower a reminder now, by SMS or email
 */
export const useSendCollectionReminder = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCollectionReminder>>, TError,{accountId: string;data: SendCollectionReminder}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendCollectionReminder>>,
        TError,
        {accountId: string;data: SendCollectionReminder},
        TContext
      > => {

      const mutationOptions = getSendCollectionReminderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * How long each document type stays current and whether it may be reused; types with no configured rule belong to one application.
 * @summary Document validity rules
 */
export const listDocumentValidityRules = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DocumentValidityRule[]>(
      {url: `/loan/api/v1/document-validity-rules`, method: 'GET', signal
    },
      );
    }
  



export const getListDocumentValidityRulesQueryKey = () => {
    return [
    `/loan/api/v1/document-validity-rules`
    ] as const;
    }

    
export const getListDocumentValidityRulesQueryOptions = <TData = Awaited<ReturnType<typeof listDocumentValidityRules>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentValidityRules>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDocumentValidityRulesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocumentValidityRules>>> = ({ signal }) => listDocumentValidityRules(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDocumentValidityRules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDocumentValidityRulesQueryResult = NonNullable<Awaited<ReturnType<typeof listDocumentValidityRules>>>
export type ListDocumentValidityRulesQueryError = unknown


export function useListDocumentValidityRules<TData = Awaited<ReturnType<typeof listDocumentValidityRules>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentValidityRules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocumentValidityRules>>,
          TError,
          Awaited<ReturnType<typeof listDocumentValidityRules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocumentValidityRules<TData = Awaited<ReturnType<typeof listDocumentValidityRules>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentValidityRules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocumentValidityRules>>,
          TError,
          Awaited<ReturnType<typeof listDocumentValidityRules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocumentValidityRules<TData = Awaited<ReturnType<typeof listDocumentValidityRules>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentValidityRules>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Document validity rules
 */

export function useListDocumentValidityRules<TData = Awaited<ReturnType<typeof listDocumentValidityRules>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentValidityRules>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDocumentValidityRulesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Which documents each funding product needs, the stage a missing one blocks, how many are expected and how many release the gate.
 * @summary The document requirements matrix
 */
export const listDocumentRequirements = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DocumentRequirement[]>(
      {url: `/loan/api/v1/document-requirements`, method: 'GET', signal
    },
      );
    }
  



export const getListDocumentRequirementsQueryKey = () => {
    return [
    `/loan/api/v1/document-requirements`
    ] as const;
    }

    
export const getListDocumentRequirementsQueryOptions = <TData = Awaited<ReturnType<typeof listDocumentRequirements>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentRequirements>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDocumentRequirementsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocumentRequirements>>> = ({ signal }) => listDocumentRequirements(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDocumentRequirements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDocumentRequirementsQueryResult = NonNullable<Awaited<ReturnType<typeof listDocumentRequirements>>>
export type ListDocumentRequirementsQueryError = unknown


export function useListDocumentRequirements<TData = Awaited<ReturnType<typeof listDocumentRequirements>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentRequirements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocumentRequirements>>,
          TError,
          Awaited<ReturnType<typeof listDocumentRequirements>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocumentRequirements<TData = Awaited<ReturnType<typeof listDocumentRequirements>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentRequirements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocumentRequirements>>,
          TError,
          Awaited<ReturnType<typeof listDocumentRequirements>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocumentRequirements<TData = Awaited<ReturnType<typeof listDocumentRequirements>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentRequirements>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The document requirements matrix
 */

export function useListDocumentRequirements<TData = Awaited<ReturnType<typeof listDocumentRequirements>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentRequirements>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDocumentRequirementsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Applies the editable fields (applies, transaction specific, compulsory, stages, quantities, reuse); each changed field is recorded with who changed it.
 * @summary Change a document requirement
 */
export const updateDocumentRequirement = (
    ruleId: string,
    documentRequirementUpdate: DocumentRequirementUpdate,
 ) => {
      
      
      return customAxiosInstanceMutator<DocumentRequirement>(
      {url: `/loan/api/v1/document-requirements/${ruleId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: documentRequirementUpdate
    },
      );
    }
  


export const getUpdateDocumentRequirementMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocumentRequirement>>, TError,{ruleId: string;data: DocumentRequirementUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateDocumentRequirement>>, TError,{ruleId: string;data: DocumentRequirementUpdate}, TContext> => {

const mutationKey = ['updateDocumentRequirement'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDocumentRequirement>>, {ruleId: string;data: DocumentRequirementUpdate}> = (props) => {
          const {ruleId,data} = props ?? {};

          return  updateDocumentRequirement(ruleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDocumentRequirementMutationResult = NonNullable<Awaited<ReturnType<typeof updateDocumentRequirement>>>
    export type UpdateDocumentRequirementMutationBody = DocumentRequirementUpdate
    export type UpdateDocumentRequirementMutationError = void

    /**
 * @summary Change a document requirement
 */
export const useUpdateDocumentRequirement = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocumentRequirement>>, TError,{ruleId: string;data: DocumentRequirementUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDocumentRequirement>>,
        TError,
        {ruleId: string;data: DocumentRequirementUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateDocumentRequirementMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Changes to a document requirement
 */
export const getDocumentRequirementHistory = (
    ruleId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DocumentRequirementChange[]>(
      {url: `/loan/api/v1/document-requirements/${ruleId}/history`, method: 'GET', signal
    },
      );
    }
  



export const getGetDocumentRequirementHistoryQueryKey = (ruleId?: string,) => {
    return [
    `/loan/api/v1/document-requirements/${ruleId}/history`
    ] as const;
    }

    
export const getGetDocumentRequirementHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentRequirementHistory>>, TError = unknown>(ruleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequirementHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentRequirementHistoryQueryKey(ruleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentRequirementHistory>>> = ({ signal }) => getDocumentRequirementHistory(ruleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ruleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequirementHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentRequirementHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentRequirementHistory>>>
export type GetDocumentRequirementHistoryQueryError = unknown


export function useGetDocumentRequirementHistory<TData = Awaited<ReturnType<typeof getDocumentRequirementHistory>>, TError = unknown>(
 ruleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequirementHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentRequirementHistory>>,
          TError,
          Awaited<ReturnType<typeof getDocumentRequirementHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentRequirementHistory<TData = Awaited<ReturnType<typeof getDocumentRequirementHistory>>, TError = unknown>(
 ruleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequirementHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentRequirementHistory>>,
          TError,
          Awaited<ReturnType<typeof getDocumentRequirementHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentRequirementHistory<TData = Awaited<ReturnType<typeof getDocumentRequirementHistory>>, TError = unknown>(
 ruleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequirementHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Changes to a document requirement
 */

export function useGetDocumentRequirementHistory<TData = Awaited<ReturnType<typeof getDocumentRequirementHistory>>, TError = unknown>(
 ruleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequirementHistory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentRequirementHistoryQueryOptions(ruleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * The application's product requirements and where each stands, with whether its documents allow each stage.
 * @summary An application's document checklist
 */
export const getDocumentChecklist = (
    loanApplicationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DocumentChecklist>(
      {url: `/loan/api/v1/loan-applications/${loanApplicationId}/document-checklist`, method: 'GET', signal
    },
      );
    }
  



export const getGetDocumentChecklistQueryKey = (loanApplicationId?: string,) => {
    return [
    `/loan/api/v1/loan-applications/${loanApplicationId}/document-checklist`
    ] as const;
    }

    
export const getGetDocumentChecklistQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentChecklist>>, TError = void>(loanApplicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentChecklist>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentChecklistQueryKey(loanApplicationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentChecklist>>> = ({ signal }) => getDocumentChecklist(loanApplicationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(loanApplicationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentChecklist>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentChecklistQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentChecklist>>>
export type GetDocumentChecklistQueryError = void


export function useGetDocumentChecklist<TData = Awaited<ReturnType<typeof getDocumentChecklist>>, TError = void>(
 loanApplicationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentChecklist>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentChecklist>>,
          TError,
          Awaited<ReturnType<typeof getDocumentChecklist>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentChecklist<TData = Awaited<ReturnType<typeof getDocumentChecklist>>, TError = void>(
 loanApplicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentChecklist>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentChecklist>>,
          TError,
          Awaited<ReturnType<typeof getDocumentChecklist>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentChecklist<TData = Awaited<ReturnType<typeof getDocumentChecklist>>, TError = void>(
 loanApplicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentChecklist>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary An application's document checklist
 */

export function useGetDocumentChecklist<TData = Awaited<ReturnType<typeof getDocumentChecklist>>, TError = void>(
 loanApplicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentChecklist>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentChecklistQueryOptions(loanApplicationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * The assessor's report from the Credit Assessment Procedure Manual; exists is false until first saved.
 * @summary The application's Credit Assessment Report
 */
export const getCreditAssessmentReport = (
    loanApplicationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<CreditAssessmentReport>(
      {url: `/loan/api/v1/loan-applications/${loanApplicationId}/credit-assessment-report`, method: 'GET', signal
    },
      );
    }
  



export const getGetCreditAssessmentReportQueryKey = (loanApplicationId?: string,) => {
    return [
    `/loan/api/v1/loan-applications/${loanApplicationId}/credit-assessment-report`
    ] as const;
    }

    
export const getGetCreditAssessmentReportQueryOptions = <TData = Awaited<ReturnType<typeof getCreditAssessmentReport>>, TError = unknown>(loanApplicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessmentReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditAssessmentReportQueryKey(loanApplicationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditAssessmentReport>>> = ({ signal }) => getCreditAssessmentReport(loanApplicationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(loanApplicationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessmentReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreditAssessmentReportQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditAssessmentReport>>>
export type GetCreditAssessmentReportQueryError = unknown


export function useGetCreditAssessmentReport<TData = Awaited<ReturnType<typeof getCreditAssessmentReport>>, TError = unknown>(
 loanApplicationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessmentReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditAssessmentReport>>,
          TError,
          Awaited<ReturnType<typeof getCreditAssessmentReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditAssessmentReport<TData = Awaited<ReturnType<typeof getCreditAssessmentReport>>, TError = unknown>(
 loanApplicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessmentReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditAssessmentReport>>,
          TError,
          Awaited<ReturnType<typeof getCreditAssessmentReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditAssessmentReport<TData = Awaited<ReturnType<typeof getCreditAssessmentReport>>, TError = unknown>(
 loanApplicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessmentReport>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The application's Credit Assessment Report
 */

export function useGetCreditAssessmentReport<TData = Awaited<ReturnType<typeof getCreditAssessmentReport>>, TError = unknown>(
 loanApplicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditAssessmentReport>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreditAssessmentReportQueryOptions(loanApplicationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Replaces the whole report and records who saved it.
 * @summary Save the application's Credit Assessment Report
 */
export const saveCreditAssessmentReport = (
    loanApplicationId: string,
    creditAssessmentReportUpdate: CreditAssessmentReportUpdate,
 ) => {
      
      
      return customAxiosInstanceMutator<CreditAssessmentReport>(
      {url: `/loan/api/v1/loan-applications/${loanApplicationId}/credit-assessment-report`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: creditAssessmentReportUpdate
    },
      );
    }
  


export const getSaveCreditAssessmentReportMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveCreditAssessmentReport>>, TError,{loanApplicationId: string;data: CreditAssessmentReportUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveCreditAssessmentReport>>, TError,{loanApplicationId: string;data: CreditAssessmentReportUpdate}, TContext> => {

const mutationKey = ['saveCreditAssessmentReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveCreditAssessmentReport>>, {loanApplicationId: string;data: CreditAssessmentReportUpdate}> = (props) => {
          const {loanApplicationId,data} = props ?? {};

          return  saveCreditAssessmentReport(loanApplicationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveCreditAssessmentReportMutationResult = NonNullable<Awaited<ReturnType<typeof saveCreditAssessmentReport>>>
    export type SaveCreditAssessmentReportMutationBody = CreditAssessmentReportUpdate
    export type SaveCreditAssessmentReportMutationError = void

    /**
 * @summary Save the application's Credit Assessment Report
 */
export const useSaveCreditAssessmentReport = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveCreditAssessmentReport>>, TError,{loanApplicationId: string;data: CreditAssessmentReportUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveCreditAssessmentReport>>,
        TError,
        {loanApplicationId: string;data: CreditAssessmentReportUpdate},
        TContext
      > => {

      const mutationOptions = getSaveCreditAssessmentReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Every borrower with a disbursed loan, with their loans, document counts and what needs attention.
 * @summary The document archive
 */
export const getDocumentArchive = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<ArchiveOverview>(
      {url: `/loan/api/v1/document-archive`, method: 'GET', signal
    },
      );
    }
  



export const getGetDocumentArchiveQueryKey = () => {
    return [
    `/loan/api/v1/document-archive`
    ] as const;
    }

    
export const getGetDocumentArchiveQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentArchive>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentArchive>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentArchiveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentArchive>>> = ({ signal }) => getDocumentArchive(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentArchive>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentArchiveQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentArchive>>>
export type GetDocumentArchiveQueryError = unknown


export function useGetDocumentArchive<TData = Awaited<ReturnType<typeof getDocumentArchive>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentArchive>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentArchive>>,
          TError,
          Awaited<ReturnType<typeof getDocumentArchive>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentArchive<TData = Awaited<ReturnType<typeof getDocumentArchive>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentArchive>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentArchive>>,
          TError,
          Awaited<ReturnType<typeof getDocumentArchive>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentArchive<TData = Awaited<ReturnType<typeof getDocumentArchive>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentArchive>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The document archive
 */

export function useGetDocumentArchive<TData = Awaited<ReturnType<typeof getDocumentArchive>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentArchive>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentArchiveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Reusable customer documents by subfolder, a folder per loan, and what needs attention.
 * @summary One borrower's file
 */
export const getArchiveBusinessFile = (
    customerPartyId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<ArchiveBusinessFile>(
      {url: `/loan/api/v1/document-archive/customers/${customerPartyId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetArchiveBusinessFileQueryKey = (customerPartyId?: string,) => {
    return [
    `/loan/api/v1/document-archive/customers/${customerPartyId}`
    ] as const;
    }

    
export const getGetArchiveBusinessFileQueryOptions = <TData = Awaited<ReturnType<typeof getArchiveBusinessFile>>, TError = void>(customerPartyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchiveBusinessFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArchiveBusinessFileQueryKey(customerPartyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArchiveBusinessFile>>> = ({ signal }) => getArchiveBusinessFile(customerPartyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerPartyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArchiveBusinessFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetArchiveBusinessFileQueryResult = NonNullable<Awaited<ReturnType<typeof getArchiveBusinessFile>>>
export type GetArchiveBusinessFileQueryError = void


export function useGetArchiveBusinessFile<TData = Awaited<ReturnType<typeof getArchiveBusinessFile>>, TError = void>(
 customerPartyId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchiveBusinessFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArchiveBusinessFile>>,
          TError,
          Awaited<ReturnType<typeof getArchiveBusinessFile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArchiveBusinessFile<TData = Awaited<ReturnType<typeof getArchiveBusinessFile>>, TError = void>(
 customerPartyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchiveBusinessFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArchiveBusinessFile>>,
          TError,
          Awaited<ReturnType<typeof getArchiveBusinessFile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArchiveBusinessFile<TData = Awaited<ReturnType<typeof getArchiveBusinessFile>>, TError = void>(
 customerPartyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchiveBusinessFile>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One borrower's file
 */

export function useGetArchiveBusinessFile<TData = Awaited<ReturnType<typeof getArchiveBusinessFile>>, TError = void>(
 customerPartyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchiveBusinessFile>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetArchiveBusinessFileQueryOptions(customerPartyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * The loan's documents, current and previous versions, by subfolder.
 * @summary One loan's folder
 */
export const getArchiveLoanFolder = (
    loanApplicationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<ArchiveLoanFolder>(
      {url: `/loan/api/v1/document-archive/loans/${loanApplicationId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetArchiveLoanFolderQueryKey = (loanApplicationId?: string,) => {
    return [
    `/loan/api/v1/document-archive/loans/${loanApplicationId}`
    ] as const;
    }

    
export const getGetArchiveLoanFolderQueryOptions = <TData = Awaited<ReturnType<typeof getArchiveLoanFolder>>, TError = void>(loanApplicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchiveLoanFolder>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArchiveLoanFolderQueryKey(loanApplicationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArchiveLoanFolder>>> = ({ signal }) => getArchiveLoanFolder(loanApplicationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(loanApplicationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArchiveLoanFolder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetArchiveLoanFolderQueryResult = NonNullable<Awaited<ReturnType<typeof getArchiveLoanFolder>>>
export type GetArchiveLoanFolderQueryError = void


export function useGetArchiveLoanFolder<TData = Awaited<ReturnType<typeof getArchiveLoanFolder>>, TError = void>(
 loanApplicationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchiveLoanFolder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArchiveLoanFolder>>,
          TError,
          Awaited<ReturnType<typeof getArchiveLoanFolder>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArchiveLoanFolder<TData = Awaited<ReturnType<typeof getArchiveLoanFolder>>, TError = void>(
 loanApplicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchiveLoanFolder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArchiveLoanFolder>>,
          TError,
          Awaited<ReturnType<typeof getArchiveLoanFolder>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArchiveLoanFolder<TData = Awaited<ReturnType<typeof getArchiveLoanFolder>>, TError = void>(
 loanApplicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchiveLoanFolder>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One loan's folder
 */

export function useGetArchiveLoanFolder<TData = Awaited<ReturnType<typeof getArchiveLoanFolder>>, TError = void>(
 loanApplicationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchiveLoanFolder>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetArchiveLoanFolderQueryOptions(loanApplicationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Adds an append-only collection note to the ledger account. Used by the collections team to track interactions, payment arrangements, and escalations.

 * @summary Add a note to a ledger account
 */
export const addCollectionNote = (
    accountId: string,
    addCollectionNote: AddCollectionNote,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<CollectionNote>(
      {url: `/loan/api/v1/ledger-accounts/${accountId}/notes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addCollectionNote, signal
    },
      );
    }
  


export const getAddCollectionNoteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCollectionNote>>, TError,{accountId: string;data: AddCollectionNote}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addCollectionNote>>, TError,{accountId: string;data: AddCollectionNote}, TContext> => {

const mutationKey = ['addCollectionNote'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCollectionNote>>, {accountId: string;data: AddCollectionNote}> = (props) => {
          const {accountId,data} = props ?? {};

          return  addCollectionNote(accountId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddCollectionNoteMutationResult = NonNullable<Awaited<ReturnType<typeof addCollectionNote>>>
    export type AddCollectionNoteMutationBody = AddCollectionNote
    export type AddCollectionNoteMutationError = void

    /**
 * @summary Add a note to a ledger account
 */
export const useAddCollectionNote = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCollectionNote>>, TError,{accountId: string;data: AddCollectionNote}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addCollectionNote>>,
        TError,
        {accountId: string;data: AddCollectionNote},
        TContext
      > => {

      const mutationOptions = getAddCollectionNoteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns paginated collection notes for a ledger account, newest first.
 * @summary Get notes for a ledger account
 */
export const getCollectionNotes = (
    accountId: string,
    params?: GetCollectionNotesParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<CollectionNotePage>(
      {url: `/loan/api/v1/ledger-accounts/${accountId}/notes`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetCollectionNotesQueryKey = (accountId?: string,
    params?: GetCollectionNotesParams,) => {
    return [
    `/loan/api/v1/ledger-accounts/${accountId}/notes`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCollectionNotesQueryOptions = <TData = Awaited<ReturnType<typeof getCollectionNotes>>, TError = void>(accountId: string,
    params?: GetCollectionNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollectionNotes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCollectionNotesQueryKey(accountId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCollectionNotes>>> = ({ signal }) => getCollectionNotes(accountId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(accountId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCollectionNotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCollectionNotesQueryResult = NonNullable<Awaited<ReturnType<typeof getCollectionNotes>>>
export type GetCollectionNotesQueryError = void


export function useGetCollectionNotes<TData = Awaited<ReturnType<typeof getCollectionNotes>>, TError = void>(
 accountId: string,
    params: undefined |  GetCollectionNotesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollectionNotes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionNotes>>,
          TError,
          Awaited<ReturnType<typeof getCollectionNotes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCollectionNotes<TData = Awaited<ReturnType<typeof getCollectionNotes>>, TError = void>(
 accountId: string,
    params?: GetCollectionNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollectionNotes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionNotes>>,
          TError,
          Awaited<ReturnType<typeof getCollectionNotes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCollectionNotes<TData = Awaited<ReturnType<typeof getCollectionNotes>>, TError = void>(
 accountId: string,
    params?: GetCollectionNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollectionNotes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get notes for a ledger account
 */

export function useGetCollectionNotes<TData = Awaited<ReturnType<typeof getCollectionNotes>>, TError = void>(
 accountId: string,
    params?: GetCollectionNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollectionNotes>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCollectionNotesQueryOptions(accountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Sets opening balance for a customer migrated from another system and marks it as applied immediately in the customer ledger.
 * @summary Set opening balance for customer (migration)
 */
export const setOpeningBalance = (
    customerPartyId: string,
    openingBalanceRequest: OpeningBalanceRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<CustomerLedger>(
      {url: `/loan/api/v1/ledger/customer/${customerPartyId}/opening-balance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: openingBalanceRequest, signal
    },
      );
    }
  


export const getSetOpeningBalanceMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOpeningBalance>>, TError,{customerPartyId: string;data: OpeningBalanceRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setOpeningBalance>>, TError,{customerPartyId: string;data: OpeningBalanceRequest}, TContext> => {

const mutationKey = ['setOpeningBalance'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setOpeningBalance>>, {customerPartyId: string;data: OpeningBalanceRequest}> = (props) => {
          const {customerPartyId,data} = props ?? {};

          return  setOpeningBalance(customerPartyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetOpeningBalanceMutationResult = NonNullable<Awaited<ReturnType<typeof setOpeningBalance>>>
    export type SetOpeningBalanceMutationBody = OpeningBalanceRequest
    export type SetOpeningBalanceMutationError = void

    /**
 * @summary Set opening balance for customer (migration)
 */
export const useSetOpeningBalance = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOpeningBalance>>, TError,{customerPartyId: string;data: OpeningBalanceRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setOpeningBalance>>,
        TError,
        {customerPartyId: string;data: OpeningBalanceRequest},
        TContext
      > => {

      const mutationOptions = getSetOpeningBalanceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves opening balance information for a customer
 * @summary Get opening balance for customer
 */
export const getOpeningBalance = (
    customerPartyId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<OpeningBalanceResponse>(
      {url: `/loan/api/v1/ledger/customer/${customerPartyId}/opening-balance`, method: 'GET', signal
    },
      );
    }
  



export const getGetOpeningBalanceQueryKey = (customerPartyId?: string,) => {
    return [
    `/loan/api/v1/ledger/customer/${customerPartyId}/opening-balance`
    ] as const;
    }

    
export const getGetOpeningBalanceQueryOptions = <TData = Awaited<ReturnType<typeof getOpeningBalance>>, TError = void>(customerPartyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpeningBalance>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpeningBalanceQueryKey(customerPartyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpeningBalance>>> = ({ signal }) => getOpeningBalance(customerPartyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerPartyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpeningBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOpeningBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof getOpeningBalance>>>
export type GetOpeningBalanceQueryError = void


export function useGetOpeningBalance<TData = Awaited<ReturnType<typeof getOpeningBalance>>, TError = void>(
 customerPartyId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpeningBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpeningBalance>>,
          TError,
          Awaited<ReturnType<typeof getOpeningBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpeningBalance<TData = Awaited<ReturnType<typeof getOpeningBalance>>, TError = void>(
 customerPartyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpeningBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpeningBalance>>,
          TError,
          Awaited<ReturnType<typeof getOpeningBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpeningBalance<TData = Awaited<ReturnType<typeof getOpeningBalance>>, TError = void>(
 customerPartyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpeningBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get opening balance for customer
 */

export function useGetOpeningBalance<TData = Awaited<ReturnType<typeof getOpeningBalance>>, TError = void>(
 customerPartyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpeningBalance>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOpeningBalanceQueryOptions(customerPartyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Records initial loan disbursement transaction
 * @summary Record loan drawdown (disbursement)
 */
export const recordDrawdown = (
    drawdownRequest: DrawdownRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerTransaction>(
      {url: `/loan/api/v1/ledger/payments/drawdown`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: drawdownRequest, signal
    },
      );
    }
  


export const getRecordDrawdownMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordDrawdown>>, TError,{data: DrawdownRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof recordDrawdown>>, TError,{data: DrawdownRequest}, TContext> => {

const mutationKey = ['recordDrawdown'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordDrawdown>>, {data: DrawdownRequest}> = (props) => {
          const {data} = props ?? {};

          return  recordDrawdown(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RecordDrawdownMutationResult = NonNullable<Awaited<ReturnType<typeof recordDrawdown>>>
    export type RecordDrawdownMutationBody = DrawdownRequest
    export type RecordDrawdownMutationError = void

    /**
 * @summary Record loan drawdown (disbursement)
 */
export const useRecordDrawdown = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordDrawdown>>, TError,{data: DrawdownRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordDrawdown>>,
        TError,
        {data: DrawdownRequest},
        TContext
      > => {

      const mutationOptions = getRecordDrawdownMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Records a customer payment with automatic waterfall allocation
 * @summary Record customer payment
 */
export const recordPayment = (
    paymentRequest: PaymentRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerTransaction>(
      {url: `/loan/api/v1/ledger/payments/payment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: paymentRequest, signal
    },
      );
    }
  


export const getRecordPaymentMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordPayment>>, TError,{data: PaymentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof recordPayment>>, TError,{data: PaymentRequest}, TContext> => {

const mutationKey = ['recordPayment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordPayment>>, {data: PaymentRequest}> = (props) => {
          const {data} = props ?? {};

          return  recordPayment(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RecordPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof recordPayment>>>
    export type RecordPaymentMutationBody = PaymentRequest
    export type RecordPaymentMutationError = void

    /**
 * @summary Record customer payment
 */
export const useRecordPayment = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordPayment>>, TError,{data: PaymentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordPayment>>,
        TError,
        {data: PaymentRequest},
        TContext
      > => {

      const mutationOptions = getRecordPaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Legacy debt a client already had before the LMS existed. Includes customers whose balance has NOT been activated - recorded against the customer but carried by no account, so nothing could be paid against it and no interest could be raised on it. That list is invisible everywhere else on the system.

 * @summary Customers with an opening balance still outstanding
 */
export const listOpeningBalances = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<OpeningBalanceSummary[]>(
      {url: `/loan/api/v1/ledger/opening-balances`, method: 'GET', signal
    },
      );
    }
  



export const getListOpeningBalancesQueryKey = () => {
    return [
    `/loan/api/v1/ledger/opening-balances`
    ] as const;
    }

    
export const getListOpeningBalancesQueryOptions = <TData = Awaited<ReturnType<typeof listOpeningBalances>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOpeningBalances>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOpeningBalancesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOpeningBalances>>> = ({ signal }) => listOpeningBalances(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOpeningBalances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOpeningBalancesQueryResult = NonNullable<Awaited<ReturnType<typeof listOpeningBalances>>>
export type ListOpeningBalancesQueryError = unknown


export function useListOpeningBalances<TData = Awaited<ReturnType<typeof listOpeningBalances>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOpeningBalances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOpeningBalances>>,
          TError,
          Awaited<ReturnType<typeof listOpeningBalances>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOpeningBalances<TData = Awaited<ReturnType<typeof listOpeningBalances>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOpeningBalances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOpeningBalances>>,
          TError,
          Awaited<ReturnType<typeof listOpeningBalances>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOpeningBalances<TData = Awaited<ReturnType<typeof listOpeningBalances>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOpeningBalances>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Customers with an opening balance still outstanding
 */

export function useListOpeningBalances<TData = Awaited<ReturnType<typeof listOpeningBalances>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOpeningBalances>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOpeningBalancesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary The state of one customer's opening balance
 */
export const getOpeningBalanceSummary = (
    customerPartyId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<OpeningBalanceSummary>(
      {url: `/loan/api/v1/ledger/customer/${customerPartyId}/opening-balance/summary`, method: 'GET', signal
    },
      );
    }
  



export const getGetOpeningBalanceSummaryQueryKey = (customerPartyId?: string,) => {
    return [
    `/loan/api/v1/ledger/customer/${customerPartyId}/opening-balance/summary`
    ] as const;
    }

    
export const getGetOpeningBalanceSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getOpeningBalanceSummary>>, TError = unknown>(customerPartyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpeningBalanceSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpeningBalanceSummaryQueryKey(customerPartyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpeningBalanceSummary>>> = ({ signal }) => getOpeningBalanceSummary(customerPartyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerPartyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpeningBalanceSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOpeningBalanceSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getOpeningBalanceSummary>>>
export type GetOpeningBalanceSummaryQueryError = unknown


export function useGetOpeningBalanceSummary<TData = Awaited<ReturnType<typeof getOpeningBalanceSummary>>, TError = unknown>(
 customerPartyId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpeningBalanceSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpeningBalanceSummary>>,
          TError,
          Awaited<ReturnType<typeof getOpeningBalanceSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpeningBalanceSummary<TData = Awaited<ReturnType<typeof getOpeningBalanceSummary>>, TError = unknown>(
 customerPartyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpeningBalanceSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpeningBalanceSummary>>,
          TError,
          Awaited<ReturnType<typeof getOpeningBalanceSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpeningBalanceSummary<TData = Awaited<ReturnType<typeof getOpeningBalanceSummary>>, TError = unknown>(
 customerPartyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpeningBalanceSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The state of one customer's opening balance
 */

export function useGetOpeningBalanceSummary<TData = Awaited<ReturnType<typeof getOpeningBalanceSummary>>, TError = unknown>(
 customerPartyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpeningBalanceSummary>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOpeningBalanceSummaryQueryOptions(customerPartyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates the migration account carrying the opening balance, without requiring a new loan. The balance previously only became postable as a side effect of a drawdown, so a client whose only debt was legacy had no account at all. Idempotent - calling it again returns the existing account rather than posting the balance twice.

 * @summary Open an account for the opening balance so it can be collected
 */
export const activateOpeningBalance = (
    customerPartyId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<OpeningBalanceSummary>(
      {url: `/loan/api/v1/ledger/customer/${customerPartyId}/opening-balance/activate`, method: 'POST', signal
    },
      );
    }
  


export const getActivateOpeningBalanceMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateOpeningBalance>>, TError,{customerPartyId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activateOpeningBalance>>, TError,{customerPartyId: string}, TContext> => {

const mutationKey = ['activateOpeningBalance'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateOpeningBalance>>, {customerPartyId: string}> = (props) => {
          const {customerPartyId} = props ?? {};

          return  activateOpeningBalance(customerPartyId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivateOpeningBalanceMutationResult = NonNullable<Awaited<ReturnType<typeof activateOpeningBalance>>>
    
    export type ActivateOpeningBalanceMutationError = void

    /**
 * @summary Open an account for the opening balance so it can be collected
 */
export const useActivateOpeningBalance = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateOpeningBalance>>, TError,{customerPartyId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activateOpeningBalance>>,
        TError,
        {customerPartyId: string},
        TContext
      > => {

      const mutationOptions = getActivateOpeningBalanceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Allocated by the normal waterfall (penalties, fees, interest, principal). Activates the balance first if nothing carries it yet, so the business never has to know that a migration account is the underlying mechanism.

 * @summary Capture a payment against an opening balance
 */
export const recordOpeningBalancePayment = (
    openingBalancePaymentRequest: OpeningBalancePaymentRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerTransaction>(
      {url: `/loan/api/v1/ledger/opening-balance/payment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: openingBalancePaymentRequest, signal
    },
      );
    }
  


export const getRecordOpeningBalancePaymentMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordOpeningBalancePayment>>, TError,{data: OpeningBalancePaymentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof recordOpeningBalancePayment>>, TError,{data: OpeningBalancePaymentRequest}, TContext> => {

const mutationKey = ['recordOpeningBalancePayment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordOpeningBalancePayment>>, {data: OpeningBalancePaymentRequest}> = (props) => {
          const {data} = props ?? {};

          return  recordOpeningBalancePayment(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RecordOpeningBalancePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof recordOpeningBalancePayment>>>
    export type RecordOpeningBalancePaymentMutationBody = OpeningBalancePaymentRequest
    export type RecordOpeningBalancePaymentMutationError = void

    /**
 * @summary Capture a payment against an opening balance
 */
export const useRecordOpeningBalancePayment = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordOpeningBalancePayment>>, TError,{data: OpeningBalancePaymentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordOpeningBalancePayment>>,
        TError,
        {data: OpeningBalancePaymentRequest},
        TContext
      > => {

      const mutationOptions = getRecordOpeningBalancePaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Legacy debt has no product schedule to derive interest from, so the business either supplies a rand amount or a percentage of what is currently outstanding. Supply exactly one of amount or ratePercent.

 * @summary Raise interest on an opening balance
 */
export const raiseOpeningBalanceInterest = (
    openingBalanceInterestRequest: OpeningBalanceInterestRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerTransaction>(
      {url: `/loan/api/v1/ledger/opening-balance/interest`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: openingBalanceInterestRequest, signal
    },
      );
    }
  


export const getRaiseOpeningBalanceInterestMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof raiseOpeningBalanceInterest>>, TError,{data: OpeningBalanceInterestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof raiseOpeningBalanceInterest>>, TError,{data: OpeningBalanceInterestRequest}, TContext> => {

const mutationKey = ['raiseOpeningBalanceInterest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof raiseOpeningBalanceInterest>>, {data: OpeningBalanceInterestRequest}> = (props) => {
          const {data} = props ?? {};

          return  raiseOpeningBalanceInterest(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RaiseOpeningBalanceInterestMutationResult = NonNullable<Awaited<ReturnType<typeof raiseOpeningBalanceInterest>>>
    export type RaiseOpeningBalanceInterestMutationBody = OpeningBalanceInterestRequest
    export type RaiseOpeningBalanceInterestMutationError = void

    /**
 * @summary Raise interest on an opening balance
 */
export const useRaiseOpeningBalanceInterest = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof raiseOpeningBalanceInterest>>, TError,{data: OpeningBalanceInterestRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof raiseOpeningBalanceInterest>>,
        TError,
        {data: OpeningBalanceInterestRequest},
        TContext
      > => {

      const mutationOptions = getRaiseOpeningBalanceInterestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Records a single payment that settles more than one loan. A client with a R20 000 and a R50 000 loan who pays R70 000 is one receipt against two accounts, and capturing it as two unrelated payments loses that fact - the bank reference then matches two ledger entries with no link between them, which is what makes reconciliation guesswork.

The split amounts must add up to the total received. Each leg is allocated by the normal waterfall (penalties, fees, interest, principal) against its own account. The whole split posts in one transaction: if any leg fails, none are written.

 * @summary Record one customer receipt split across several loan accounts
 */
export const recordSplitPayment = (
    splitPaymentRequest: SplitPaymentRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<SplitPaymentResult>(
      {url: `/loan/api/v1/ledger/payments/split`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: splitPaymentRequest, signal
    },
      );
    }
  


export const getRecordSplitPaymentMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordSplitPayment>>, TError,{data: SplitPaymentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof recordSplitPayment>>, TError,{data: SplitPaymentRequest}, TContext> => {

const mutationKey = ['recordSplitPayment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordSplitPayment>>, {data: SplitPaymentRequest}> = (props) => {
          const {data} = props ?? {};

          return  recordSplitPayment(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RecordSplitPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof recordSplitPayment>>>
    export type RecordSplitPaymentMutationBody = SplitPaymentRequest
    export type RecordSplitPaymentMutationError = void

    /**
 * @summary Record one customer receipt split across several loan accounts
 */
export const useRecordSplitPayment = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordSplitPayment>>, TError,{data: SplitPaymentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordSplitPayment>>,
        TError,
        {data: SplitPaymentRequest},
        TContext
      > => {

      const mutationOptions = getRecordSplitPaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Calculates total payoff amount for early repayment (excludes unaccrued future interest)
 * @summary Get early repayment quote
 */
export const getEarlyRepaymentQuote = (
    getEarlyRepaymentQuoteBody: GetEarlyRepaymentQuoteBody,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<EarlyRepaymentQuote>(
      {url: `/loan/api/v1/ledger/payments/early-repayment/quote`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getEarlyRepaymentQuoteBody, signal
    },
      );
    }
  


export const getGetEarlyRepaymentQuoteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEarlyRepaymentQuote>>, TError,{data: GetEarlyRepaymentQuoteBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getEarlyRepaymentQuote>>, TError,{data: GetEarlyRepaymentQuoteBody}, TContext> => {

const mutationKey = ['getEarlyRepaymentQuote'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getEarlyRepaymentQuote>>, {data: GetEarlyRepaymentQuoteBody}> = (props) => {
          const {data} = props ?? {};

          return  getEarlyRepaymentQuote(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetEarlyRepaymentQuoteMutationResult = NonNullable<Awaited<ReturnType<typeof getEarlyRepaymentQuote>>>
    export type GetEarlyRepaymentQuoteMutationBody = GetEarlyRepaymentQuoteBody
    export type GetEarlyRepaymentQuoteMutationError = void

    /**
 * @summary Get early repayment quote
 */
export const useGetEarlyRepaymentQuote = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEarlyRepaymentQuote>>, TError,{data: GetEarlyRepaymentQuoteBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getEarlyRepaymentQuote>>,
        TError,
        {data: GetEarlyRepaymentQuoteBody},
        TContext
      > => {

      const mutationOptions = getGetEarlyRepaymentQuoteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Records full loan payoff (early repayment)
 * @summary Record early repayment
 */
export const recordEarlyRepayment = (
    earlyRepaymentRequest: EarlyRepaymentRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerTransaction>(
      {url: `/loan/api/v1/ledger/payments/early-repayment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: earlyRepaymentRequest, signal
    },
      );
    }
  


export const getRecordEarlyRepaymentMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordEarlyRepayment>>, TError,{data: EarlyRepaymentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof recordEarlyRepayment>>, TError,{data: EarlyRepaymentRequest}, TContext> => {

const mutationKey = ['recordEarlyRepayment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordEarlyRepayment>>, {data: EarlyRepaymentRequest}> = (props) => {
          const {data} = props ?? {};

          return  recordEarlyRepayment(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RecordEarlyRepaymentMutationResult = NonNullable<Awaited<ReturnType<typeof recordEarlyRepayment>>>
    export type RecordEarlyRepaymentMutationBody = EarlyRepaymentRequest
    export type RecordEarlyRepaymentMutationError = void

    /**
 * @summary Record early repayment
 */
export const useRecordEarlyRepayment = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordEarlyRepayment>>, TError,{data: EarlyRepaymentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordEarlyRepayment>>,
        TError,
        {data: EarlyRepaymentRequest},
        TContext
      > => {

      const mutationOptions = getRecordEarlyRepaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Records a discount or waiver for fees, interest, or penalties
 * @summary Record discount/waiver
 */
export const recordDiscount = (
    discountRequest: DiscountRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerTransaction>(
      {url: `/loan/api/v1/ledger/payments/discount`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: discountRequest, signal
    },
      );
    }
  


export const getRecordDiscountMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordDiscount>>, TError,{data: DiscountRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof recordDiscount>>, TError,{data: DiscountRequest}, TContext> => {

const mutationKey = ['recordDiscount'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordDiscount>>, {data: DiscountRequest}> = (props) => {
          const {data} = props ?? {};

          return  recordDiscount(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RecordDiscountMutationResult = NonNullable<Awaited<ReturnType<typeof recordDiscount>>>
    export type RecordDiscountMutationBody = DiscountRequest
    export type RecordDiscountMutationError = void

    /**
 * @summary Record discount/waiver
 */
export const useRecordDiscount = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordDiscount>>, TError,{data: DiscountRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordDiscount>>,
        TError,
        {data: DiscountRequest},
        TContext
      > => {

      const mutationOptions = getRecordDiscountMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Adds a charge (admin fee, monthly service fee, interest, penalty) to an existing loan. The service method already existed and is used internally by disbursement, the daily scheduler and the penalty engine, but there was no endpoint - so business could not add or correct a charge on a live loan from the portal at all, which is one of the reasons charges are still being tracked in the spreadsheet.

 * @summary Record an ad-hoc charge against a loan
 */
export const recordCharge = (
    chargeRequest: ChargeRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerTransaction>(
      {url: `/loan/api/v1/ledger/payments/charge`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: chargeRequest, signal
    },
      );
    }
  


export const getRecordChargeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordCharge>>, TError,{data: ChargeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof recordCharge>>, TError,{data: ChargeRequest}, TContext> => {

const mutationKey = ['recordCharge'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordCharge>>, {data: ChargeRequest}> = (props) => {
          const {data} = props ?? {};

          return  recordCharge(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RecordChargeMutationResult = NonNullable<Awaited<ReturnType<typeof recordCharge>>>
    export type RecordChargeMutationBody = ChargeRequest
    export type RecordChargeMutationError = void

    /**
 * @summary Record an ad-hoc charge against a loan
 */
export const useRecordCharge = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordCharge>>, TError,{data: ChargeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordCharge>>,
        TError,
        {data: ChargeRequest},
        TContext
      > => {

      const mutationOptions = getRecordChargeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Records a full account write-off (bad debt)
 * @summary Record write-off
 */
export const recordWriteOff = (
    writeOffRequest: WriteOffRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerTransaction>(
      {url: `/loan/api/v1/ledger/payments/write-off`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: writeOffRequest, signal
    },
      );
    }
  


export const getRecordWriteOffMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordWriteOff>>, TError,{data: WriteOffRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof recordWriteOff>>, TError,{data: WriteOffRequest}, TContext> => {

const mutationKey = ['recordWriteOff'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordWriteOff>>, {data: WriteOffRequest}> = (props) => {
          const {data} = props ?? {};

          return  recordWriteOff(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RecordWriteOffMutationResult = NonNullable<Awaited<ReturnType<typeof recordWriteOff>>>
    export type RecordWriteOffMutationBody = WriteOffRequest
    export type RecordWriteOffMutationError = void

    /**
 * @summary Record write-off
 */
export const useRecordWriteOff = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordWriteOff>>, TError,{data: WriteOffRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordWriteOff>>,
        TError,
        {data: WriteOffRequest},
        TContext
      > => {

      const mutationOptions = getRecordWriteOffMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Creates a compensating reversal transaction (immutable correction)
 * @summary Reverse transaction
 */
export const reverseTransaction = (
    reversalRequest: ReversalRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerTransaction>(
      {url: `/loan/api/v1/ledger/payments/reverse`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reversalRequest, signal
    },
      );
    }
  


export const getReverseTransactionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reverseTransaction>>, TError,{data: ReversalRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reverseTransaction>>, TError,{data: ReversalRequest}, TContext> => {

const mutationKey = ['reverseTransaction'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reverseTransaction>>, {data: ReversalRequest}> = (props) => {
          const {data} = props ?? {};

          return  reverseTransaction(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReverseTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof reverseTransaction>>>
    export type ReverseTransactionMutationBody = ReversalRequest
    export type ReverseTransactionMutationError = void

    /**
 * @summary Reverse transaction
 */
export const useReverseTransaction = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reverseTransaction>>, TError,{data: ReversalRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reverseTransaction>>,
        TError,
        {data: ReversalRequest},
        TContext
      > => {

      const mutationOptions = getReverseTransactionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Atomically reverses the original PAYMENT and posts a corrected PAYMENT to the target account.
 * @summary Rectify or re-allocate a payment (immutable correction)
 */
export const rectifyPayment = (
    rectifyPaymentRequest: RectifyPaymentRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<LedgerTransaction>(
      {url: `/loan/api/v1/ledger/payments/rectify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rectifyPaymentRequest, signal
    },
      );
    }
  


export const getRectifyPaymentMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rectifyPayment>>, TError,{data: RectifyPaymentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rectifyPayment>>, TError,{data: RectifyPaymentRequest}, TContext> => {

const mutationKey = ['rectifyPayment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rectifyPayment>>, {data: RectifyPaymentRequest}> = (props) => {
          const {data} = props ?? {};

          return  rectifyPayment(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RectifyPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof rectifyPayment>>>
    export type RectifyPaymentMutationBody = RectifyPaymentRequest
    export type RectifyPaymentMutationError = void

    /**
 * @summary Rectify or re-allocate a payment (immutable correction)
 */
export const useRectifyPayment = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rectifyPayment>>, TError,{data: RectifyPaymentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rectifyPayment>>,
        TError,
        {data: RectifyPaymentRequest},
        TContext
      > => {

      const mutationOptions = getRectifyPaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Manually triggers daily scheduler (interest accrual, fees, penalties, balances, status updates)
 * @summary Execute daily scheduler (Admin Only)
 */
export const executeDailyScheduler = (
    schedulerExecutionRequest?: SchedulerExecutionRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<SchedulerExecutionResult>(
      {url: `/loan/api/v1/ledger/scheduler/execute`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: schedulerExecutionRequest, signal
    },
      );
    }
  


export const getExecuteDailySchedulerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeDailyScheduler>>, TError,{data: SchedulerExecutionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof executeDailyScheduler>>, TError,{data: SchedulerExecutionRequest}, TContext> => {

const mutationKey = ['executeDailyScheduler'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeDailyScheduler>>, {data: SchedulerExecutionRequest}> = (props) => {
          const {data} = props ?? {};

          return  executeDailyScheduler(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExecuteDailySchedulerMutationResult = NonNullable<Awaited<ReturnType<typeof executeDailyScheduler>>>
    export type ExecuteDailySchedulerMutationBody = SchedulerExecutionRequest
    export type ExecuteDailySchedulerMutationError = void

    /**
 * @summary Execute daily scheduler (Admin Only)
 */
export const useExecuteDailyScheduler = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeDailyScheduler>>, TError,{data: SchedulerExecutionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof executeDailyScheduler>>,
        TError,
        {data: SchedulerExecutionRequest},
        TContext
      > => {

      const mutationOptions = getExecuteDailySchedulerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
